import ActionTypes from './types'
import { GlobalConfig } from 'galarm-config'
import {
  AlarmUtils,
  FirebaseManager,
  TaskManager,
  AlarmUtilsWithExtras,
  WebUtils,
  FirestoreManager
} from 'galarm-shared'
import DateTimeUtils from '../utils/DateTimeUtils'
import {
  NotificationManager,
  StorageManager,
  AlarmManager,
  LogUtils,
  NavigationUtils
} from 'galarm-ps-api'
import { Constants } from 'galarm-config'
import arrayDifferenceWith from 'lodash/differenceWith'
import arrayIntersectionWith from 'lodash/intersectionWith'
import arrayUniq from 'lodash/uniq'
import Utils from '../utils/Utils'
import { I18n } from 'galarm-config'
import { Platform } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import objGet from 'lodash/get'
import objCompact from 'lodash/compact'
import moment from 'moment-timezone'
import uuid from 'react-native-uuid'
import {
  participantAlarmsSelector,
  makeOwnAlarmSelector,
  ownAlarmsSelector,
  allAlarmsSelector,
  makeSubscribedAlarmSystemAlertsSelector,
  upgradePurchasedSelector,
  ringerSettingsSelector,
  makeAlarmAcknowledgementsSelector,
  makeAlarmStatusChangesSelector,
  alarmCategoriesSelector,
  makeAlarmCategoryForAlarmIdSelector,
  makeAlarmSelector,
  canCreateNewAlarmDataSelector,
  makeRecentlyDeletedAlarmSelector,
  nextFiveAlarmsThatShouldRingSelector,
  missedAlarmsSelector,
  inactiveAlarmsCountSelector,
  simpleAllAlarmsSelector,
  allTasksCountSelector,
  makeAllOwnAlarmSelector,
  makeAllParticipantAlarmSelector
} from '../store/selectors'
import isEmpty from 'lodash/isEmpty'
import objOmit from 'lodash/omit'
import isObjEqual from 'fast-deep-equal'
import { FirebaseProxy } from 'galarm-ps-api'
import * as RNLocalize from 'react-native-localize'

const setConnectionStatus = isConnected => {
  return {
    type: ActionTypes.SET_CONNECTION_STATUS,
    payload: {
      isConnected
    }
  }
}

const addSystemAlerts = systemAlerts => ({
  type: ActionTypes.ADD_SYSTEM_ALERTS,
  payload: {
    systemAlerts
  }
})

const addSystemAlert = alert => ({
  type: ActionTypes.ADD_SYSTEM_ALERT,
  payload: {
    alert
  }
})

const removeSystemAlert = id => ({
  type: ActionTypes.REMOVE_SYSTEM_ALERT,
  payload: {
    id
  }
})

const removeSystemMessage = id => ({
  type: ActionTypes.REMOVE_SYSTEM_MESSAGE,
  payload: {
    id
  }
})

const addHiddenSystemMessage = id => ({
  type: ActionTypes.ADD_HIDDEN_SYSTEM_MESSAGE,
  payload: {
    id
  }
})

const updateAlarm = (alarmId, alarm) => ({
  type: ActionTypes.UPDATE_ALARM,
  payload: {
    alarmId,
    alarm
  }
})

// eslint-disable-next-line no-unused-vars
const incrementOwnAlarmsLocalCount = (alarmType, countType) => ({
  type: ActionTypes.INCREMENT_OWN_ALARMS_COUNT,
  payload: {
    alarmType,
    countType
  }
})

const setAlarmsCount = alarmsCount => ({
  type: ActionTypes.SET_ALARMS_COUNT,
  payload: { alarmsCount }
})

const setDeviceOs = deviceOs => ({
  type: ActionTypes.SET_DEVICE_OS,
  payload: { deviceOs }
})

const setConnectedToIap = status => ({
  type: ActionTypes.SET_CONNECTED_TO_IAP,
  payload: {
    status
  }
})

const setMuteAlarms = muteAlarms => ({
  type: ActionTypes.SET_MUTE_ALARMS,
  payload: {
    muteAlarms
  }
})

const setPurchases = purchases => ({
  type: ActionTypes.SET_PURCHASES,
  payload: {
    purchases
  }
})

const addPurchase = purchase => ({
  type: ActionTypes.ADD_PURCHASE,
  payload: {
    purchase
  }
})

const setMaxAllowedAlarms = maxAllowedAlarms => ({
  type: ActionTypes.SET_MAX_ALLOWED_ALARMS,
  payload: {
    maxAllowedAlarms
  }
})

// eslint-disable-next-line no-unused-vars
const updateAlarms = alarms => ({
  type: ActionTypes.UPDATE_ALARMS,
  payload: {
    alarms
  }
})

const addLocalAlarm = alarm => ({
  type: ActionTypes.ADD_LOCAL_ALARM,
  payload: {
    alarm
  }
})

const addLocalChecklist = (checklist, persistedOnline) => ({
  type: ActionTypes.ADD_LOCAL_CHECKLIST,
  payload: {
    checklist,
    persistedOnline
  }
})

const updateLocalChecklist = checklist => ({
  type: ActionTypes.UPDATE_LOCAL_CHECKLIST,
  payload: {
    checklist
  }
})

const removeLocalChecklist = checklistId => ({
  type: ActionTypes.REMOVE_LOCAL_CHECKLIST,
  payload: {
    checklistId
  }
})

const updateLocalAlarm = alarm => ({
  type: ActionTypes.UPDATE_LOCAL_ALARM,
  payload: {
    alarm
  }
})

const softUpdateLocalAlarm = alarm => ({
  type: ActionTypes.SOFT_UPDATE_LOCAL_ALARM,
  payload: {
    alarm
  }
})

const softUpdateLocalParticipantAlarm = alarm => ({
  type: ActionTypes.SOFT_UPDATE_LOCAL_PARTICIPANT_ALARM,
  payload: {
    alarm
  }
})

const setCalendarEvents = events => ({
  type: ActionTypes.SET_CALENDAR_EVENTS,
  payload: {
    events
  }
})

// eslint-disable-next-line no-unused-vars
const addCalendarEvent = event => ({
  type: ActionTypes.ADD_CALENDAR_EVENT,
  payload: {
    event
  }
})

// eslint-disable-next-line no-unused-vars
const removeCalendarEvent = eventId => ({
  type: ActionTypes.REMOVE_CALENDAR_EVENT,
  payload: {
    eventId
  }
})

const updateCalendarEvent = (eventId, event) => ({
  type: ActionTypes.UPDATE_CALENDAR_EVENT,
  payload: {
    eventId,
    event
  }
})

const setSortAlarmCategoriesBy = sortAlarmCategoriesBy => ({
  type: ActionTypes.SET_SORT_ALARM_CATEGORIES_BY,
  payload: {
    sortAlarmCategoriesBy
  }
})

const setMissedAlarmPlacementSetting = missedAlarmPlacementSetting => ({
  type: ActionTypes.SET_MISSED_ALARM_PLACEMENT_SETTING,
  payload: {
    missedAlarmPlacementSetting
  }
})

const setFabButtonBehavior = fabButtonBehavior => ({
  type: ActionTypes.SET_FAB_BUTTON_BEHAVIOR,
  payload: {
    fabButtonBehavior
  }
})

const updateConnectedAccount = (accountId, account) => ({
  type: ActionTypes.UPDATE_CONNECTED_ACCOUNT,
  payload: {
    accountId,
    account
  }
})

const updateGroup = (groupId, groupData, isRemovedGroup = false) => ({
  type: ActionTypes.UPDATE_GROUP,
  payload: {
    groupId,
    groupData,
    isRemovedGroup
  }
})

const updateGroupAvatarImages = (groupId, images) => ({
  type: ActionTypes.UPDATE_GROUP_AVATAR_IMAGES,
  payload: {
    groupId: groupId,
    images: images
  }
})

const deleteGroupAvatarImages = groupId => ({
  type: ActionTypes.DELETE_GROUP_AVATAR_IMAGES,
  payload: {
    groupId: groupId
  }
})

const removeGroup = groupId => ({
  type: ActionTypes.REMOVE_GROUP,
  payload: {
    groupId
  }
})

const addConnection = (id, connectionInfo) => ({
  type: ActionTypes.ADD_CONNECTION,
  payload: {
    id,
    ...connectionInfo
  }
})

const addConnections = connections => ({
  type: ActionTypes.ADD_CONNECTIONS,
  payload: {
    connections
  }
})

const addContact = contact => ({
  type: ActionTypes.ADD_CONTACT,
  payload: {
    contact
  }
})

const addInvitedContact = contact => ({
  type: ActionTypes.ADD_INVITED_CONTACT,
  payload: {
    contact
  }
})

const deleteInvitedContact = contactId => ({
  type: ActionTypes.DELETE_INVITED_CONTACT,
  payload: {
    contactId
  }
})

const addContacts = contacts => ({
  type: ActionTypes.ADD_CONTACTS,
  payload: {
    contacts
  }
})

const addPhoneContacts = phoneContacts => ({
  type: ActionTypes.ADD_PHONE_CONTACTS,
  payload: {
    phoneContacts
  }
})

const deleteContact = contactId => ({
  type: ActionTypes.DELETE_CONTACT,
  payload: {
    contactId
  }
})

// eslint-disable-next-line no-unused-vars
const setIncidentAlarms = alarms => ({
  type: ActionTypes.SET_INCIDENT_ALARMS,
  payload: {
    alarms
  }
})

const addIncidentAlarm = alarm => ({
  type: ActionTypes.ADD_INCIDENT_ALARM,
  payload: {
    alarm
  }
})

const removeIncidentAlarm = alarmId => ({
  type: ActionTypes.REMOVE_INCIDENT_ALARM,
  payload: {
    alarmId
  }
})

// eslint-disable-next-line no-unused-vars
const addIncidentAlarms = alarms => ({
  type: ActionTypes.ADD_INCIDENT_ALARMS,
  payload: {
    alarms
  }
})

const addBackupAlarm = (alarmId, alarm) => ({
  type: ActionTypes.ADD_BACKUP_ALARM,
  payload: {
    alarmId,
    alarm
  }
})

const removeBackupAlarm = alarmId => ({
  type: ActionTypes.REMOVE_BACKUP_ALARM,
  payload: {
    alarmId
  }
})

const setRecentlyDeletedAlarms = alarms => ({
  type: ActionTypes.SET_RECENTLY_DELETED_ALARMS,
  payload: {
    alarms
  }
})

const removeParticipantAlarms = alarmIds => ({
  type: ActionTypes.REMOVE_PARTICIPANT_ALARMS,
  payload: {
    alarmIds
  }
})

const removeLocalAlarm = alarmId => ({
  type: ActionTypes.REMOVE_LOCAL_ALARM,
  payload: {
    alarmId
  }
})

const removeLocalAlarms = alarmIds => ({
  type: ActionTypes.REMOVE_LOCAL_ALARMS,
  payload: {
    alarmIds
  }
})

const removePendingAction = actionId => ({
  type: ActionTypes.REMOVE_PENDING_ACTION,
  payload: {
    id: actionId
  }
})

const updatePendingActionRetryCount = actionId => ({
  type: ActionTypes.UPDATE_PENDING_ACTION_RETRY_COUNT,
  payload: {
    id: actionId
  }
})

const updateSoftPendingActionRetryCount = actionId => ({
  type: ActionTypes.UPDATE_SOFT_PENDING_ACTION_RETRY_COUNT,
  payload: {
    id: actionId
  }
})

const removeSoftPendingAction = actionId => ({
  type: ActionTypes.REMOVE_SOFT_PENDING_ACTION,
  payload: {
    id: actionId
  }
})

const addAddChecklistPendingAction = checklist => ({
  type: ActionTypes.ADD_ADD_CHECKLIST_PENDING_ACTION,
  payload: {
    checklist
  }
})

const addEditChecklistPendingAction = checklist => ({
  type: ActionTypes.ADD_EDIT_CHECKLIST_PENDING_ACTION,
  payload: {
    checklist
  }
})

const addRemoveChecklistPendingAction = checklistId => ({
  type: ActionTypes.ADD_REMOVE_CHECKLIST_PENDING_ACTION,
  payload: {
    checklistId
  }
})

const setStopwatchesCount = stopwatchesCount => ({
  type: ActionTypes.SET_STOPWATCHES_COUNT,
  payload: { stopwatchesCount }
})

const setTimersCount = timersCount => ({
  type: ActionTypes.SET_TIMERS_COUNT,
  payload: { timersCount }
})

const addAddAlarmPendingAction = alarm => ({
  type: ActionTypes.ADD_ADD_ALARM_PENDING_ACTION,
  payload: {
    alarm
  }
})

const addEditAlarmPendingAction = (
  editedAlarm,
  prevAlarm,
  removeSubscription,
  wipeAlarmActions = true
) => ({
  type: ActionTypes.ADD_EDIT_ALARM_PENDING_ACTION,
  payload: {
    editedAlarm,
    prevAlarm,
    removeSubscription,
    wipeAlarmActions
  }
})

const addEnableDisableAlarmPendingAction = (alarm, timestamp, alarmStatus) => ({
  type: ActionTypes.ADD_ENABLE_DISABLE_ALARM_PENDING_ACTION,
  payload: {
    alarm,
    alarmStatus,
    timestamp
  }
})

const addDeleteAlarmPendingAction = alarm => ({
  type: ActionTypes.ADD_DELETE_ALARM_PENDING_ACTION,
  payload: {
    alarm
  }
})

const addRemoveRemoteAlarmNotificationPendingAction = alarmId => ({
  type: ActionTypes.ADD_REMOVE_REMOTE_ALARM_NOTIFICATION_PENDING_ACTION,
  payload: {
    alarmId
  }
})

const addUpdateParticipantAlarmRingerSettingsSoftPendingAction = (
  alarm,
  participantId,
  ringerSettings
) => ({
  type: ActionTypes.ADD_UPDATE_PARTICIPANT_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    ringerSettings
  }
})

const addUpdateParticipantPreReminderDurationSoftPendingAction = (
  alarm,
  participantId,
  preReminderDuration
) => ({
  type: ActionTypes.ADD_UPDATE_PARTICIPANT_ALARM_PRE_REMINDER_DURATION_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    preReminderDuration
  }
})

const addUpdateAlarmPreReminderSoftPendingAction = (
  alarm,
  preReminderDuration
) => ({
  type: ActionTypes.ADD_UPDATE_ALARM_PRE_REMINDER_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    preReminderDuration
  }
})

const addUpdateAlarmRingerSettingsSoftPendingAction = (
  alarm,
  ringerSettings
) => ({
  type: ActionTypes.ADD_UPDATE_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    ringerSettings
  }
})

const setUserInfo = userInfo => ({
  type: ActionTypes.SET_USER_INFO,
  payload: {
    ...userInfo
  }
})

const setUserName = userName => ({
  type: ActionTypes.SET_USER_NAME,
  payload: {
    name: userName
  }
})

const setUserMobileNumber = (mobileNumber, countryCode) => ({
  type: ActionTypes.SET_USER_MOBILE_NUMBER,
  payload: {
    mobileNumber: mobileNumber,
    countryCode: countryCode
  }
})

const setUserAvatarImages = images => ({
  type: ActionTypes.SET_USER_AVATAR_IMAGES,
  payload: {
    images
  }
})

const deleteUserAvatarImages = () => ({
  type: ActionTypes.DELETE_USER_AVATAR_IMAGES
})

const setContactAvatarImages = (contactId, images) => ({
  type: ActionTypes.SET_CONTACT_AVATAR_IMAGES,
  payload: {
    contactId,
    images
  }
})

const deleteContactAvatarImages = contactId => ({
  type: ActionTypes.DELETE_CONTACT_AVATAR_IMAGES,
  payload: {
    contactId
  }
})

const setConnectionAvatarImages = (id, images) => ({
  type: ActionTypes.SET_CONNECTION_AVATAR_IMAGES,
  payload: {
    id,
    images
  }
})

const deleteConnectionAvatarImages = id => ({
  type: ActionTypes.DELETE_CONNECTION_AVATAR_IMAGES,
  payload: {
    id
  }
})

const setTotalNumberOfContacts = totalNumberOfContacts => ({
  type: ActionTypes.SET_TOTAL_NUMBER_OF_CONTACTS,
  payload: {
    totalNumberOfContacts
  }
})

const setContactsLastUpdatedAt = contactsLastUpdatedAt => ({
  type: ActionTypes.SET_CONTACTS_LAST_UPDATED_AT,
  payload: {
    contactsLastUpdatedAt
  }
})

const setAuthenticatedWithFirebase = authenticatedWithFirebase => ({
  type: ActionTypes.SET_AUTHENTICATED_WITH_FIREBASE,
  payload: {
    authenticatedWithFirebase
  }
})

const setProgress = (state, message, closeable = false) => ({
  type: ActionTypes.SET_PROGRESS,
  payload: {
    state,
    message,
    closeable
  }
})

const resetProgress = () => ({
  type: ActionTypes.RESET_PROGRESS
})

const setUserSettings = userSettings => ({
  type: ActionTypes.SET_USER_SETTINGS,
  payload: {
    userSettings
  }
})

const setRingParticipantAlarmsByDefault = ringParticipantAlarmsByDefault => ({
  type: ActionTypes.SET_RING_PARTICIPANT_ALARMS_BY_DEFAULT,
  payload: {
    ringParticipantAlarmsByDefault
  }
})

const setRingOnEarphoneOnly = ringOnEarphoneOnly => ({
  type: ActionTypes.SET_RING_ON_EARPHONE_ONLY,
  payload: {
    ringOnEarphoneOnly
  }
})

const setSpecifyTimezoneForAlarm = specifyTimezoneForAlarm => ({
  type: ActionTypes.SET_SPECIFY_TIMEZONE_FOR_ALARM,
  payload: {
    specifyTimezoneForAlarm
  }
})

const setDefaultTimezoneForAlarm = defaultTimezoneForAlarm => ({
  type: ActionTypes.SET_DEFAULT_TIMEZONE_FOR_ALARM,
  payload: {
    defaultTimezoneForAlarm
  }
})

const setGestureToDismissAnAlarm = gestureToDismissAnAlarm => ({
  type: ActionTypes.SET_GESTURE_TO_DISMISS_ALARM,
  payload: {
    gestureToDismissAnAlarm: gestureToDismissAnAlarm
  }
})

const setPreReminderRingtone = preReminderRingtone => ({
  type: ActionTypes.SET_PRE_REMINDER_RINGTONE,
  payload: {
    preReminderRingtone: preReminderRingtone
  }
})

const setTimerRingtone = timerRingtone => ({
  type: ActionTypes.SET_TIMER_RINGTONE,
  payload: {
    timerRingtone
  }
})

const setEnhancedNotifications = enhancedNotifications => ({
  type: ActionTypes.SET_ENHANCED_NOTIFICATIONS,
  payload: {
    enhancedNotifications: enhancedNotifications
  }
})

const setAppTerminatedNotification = appTerminatedNotification => ({
  type: ActionTypes.SET_APP_TERMINATED_NOTIFICATION,
  payload: {
    appTerminatedNotification: appTerminatedNotification
  }
})

const setNotificationSettingsUserSettings = notificationSettings => ({
  type: ActionTypes.SET_NOTIFICATION_SETTINGS,
  payload: {
    notificationSettings: notificationSettings
  }
})

const setGraduallyIncreaseVolume = graduallyIncreaseVolume => ({
  type: ActionTypes.SET_GRADUALLY_INCREASE_VOLUME,
  payload: {
    graduallyIncreaseVolume: graduallyIncreaseVolume
  }
})

const setShakeToStopAlarm = shakeToStopAlarm => ({
  type: ActionTypes.SET_SHAKE_TO_STOP_ALARM,
  payload: {
    shakeToStopAlarm: shakeToStopAlarm
  }
})

const setShakeSensitivity = shakeSensitivity => ({
  type: ActionTypes.SET_SHAKE_SENSITIVITY,
  payload: {
    shakeSensitivity
  }
})

const setPinMode = pinMode => ({
  type: ActionTypes.SET_PIN_MODE,
  payload: {
    pinMode: pinMode
  }
})

const setPromptForUpdate = promptForUpdate => ({
  type: ActionTypes.SET_PROMPT_FOR_UPDATE,
  payload: {
    promptForUpdate: promptForUpdate
  }
})

const setNotificationActionBehavior = notificationActionBehavior => ({
  type: ActionTypes.SET_NOTIFICATION_ACTION_BEHAVIOR,
  payload: {
    notificationActionBehavior: notificationActionBehavior
  }
})

const setGlobalAlarmRingerSettings = ringerSettings => ({
  type: ActionTypes.SET_GLOBAL_ALARM_RINGER_SETTINGS,
  payload: {
    ringerSettings
  }
})

const setTimeFormat = timeFormat => ({
  type: ActionTypes.SET_TIME_FORMAT,
  payload: {
    timeFormat
  }
})

const setNotificationsEnabled = state => ({
  type: ActionTypes.SET_NOTIFICATIONS_ENABLED,
  payload: {
    notificationsEnabled: state
  }
})

const setCriticalAlertsEnabled = state => ({
  type: ActionTypes.SET_CRITICAL_ALERTS_ENABLED,
  payload: {
    criticalAlertsEnabled: state
  }
})

const setAlarmNotificationChannelPopupEnabled = state => ({
  type: ActionTypes.SET_ALARM_NOTIFICATION_CHANNEL_ENABLED,
  payload: {
    alarmNotificationChannelPopupEnabled: state
  }
})

const setAlarmLockScreenNotificationEnabled = state => ({
  type: ActionTypes.SET_LOCK_SCREEN_NOTIFICATION_ENABLED,
  payload: {
    alarmLockScreenNotificationEnabled: state
  }
})

const setAppUpdateAvailable = appUpdateAvailable => ({
  type: ActionTypes.SET_APP_UPDATE_AVAILABLE,
  payload: {
    appUpdateAvailable
  }
})

const setBackgroundAppRefreshEnabled = state => ({
  type: ActionTypes.SET_BACKGROUND_APP_REFRESH_ENABLED,
  payload: {
    backgroundAppRefreshEnabled: state
  }
})

const markAlarmsAsExpired = expiredAlarmIds => ({
  type: ActionTypes.EXPIRE_ALARMS,
  payload: {
    alarmIds: expiredAlarmIds
  }
})

const updateAlarmsLocally = alarmIds => ({
  type: ActionTypes.UPDATE_ALARMS_LOCALLY,
  payload: {
    alarmIds
  }
})

const unsnoozeAlarmsLocally = alarmIds => ({
  type: ActionTypes.UNSNOOZE_ALARMS_LOCALLY,
  payload: {
    alarmIds
  }
})

const unsnoozeParticipantAlarmsLocally = (alarmIds, uid) => ({
  type: ActionTypes.UNSNOOZE_PARTICIPANT_ALARMS_LOCALLY,
  payload: {
    alarmIds,
    uid
  }
})

const updateParticipantsAlarmsLocally = alarmIds => ({
  type: ActionTypes.UPDATE_PARTICIPANT_ALARMS_LOCALLY,
  payload: {
    alarmIds
  }
})

const markParticipantAlarmsAsExpired = participantExpiredAlarmIds => ({
  type: ActionTypes.EXPIRE_PARTICIPANT_ALARMS,
  payload: {
    alarmIds: participantExpiredAlarmIds
  }
})

const setCurrentScreen = screenName => ({
  type: ActionTypes.SET_CURRENT_SCREEN,
  payload: {
    currentScreen: screenName
  }
})

const setShowRecentlyDeletedAlarms = showRecentlyDeletedAlarms => ({
  type: ActionTypes.SET_SHOW_RECENTLY_DELETED_ALARMS,
  payload: {
    showRecentlyDeletedAlarms
  }
})

const setDeviceToken = deviceToken => ({
  type: ActionTypes.SET_DEVICE_TOKEN,
  payload: {
    deviceToken
  }
})

const addEnterpriseSubscriptions = enterpriseSubscriptions => ({
  type: ActionTypes.ADD_ENTERPRISE_SUBSCRIPTIONS,
  payload: {
    enterpriseSubscriptions
  }
})

const setStripeSubscriptions = stripeSubscriptions => ({
  type: ActionTypes.SET_STRIPE_SUBSCRIPTIONS,
  payload: {
    stripeSubscriptions
  }
})

const setConnectedAccounts = connectedAccounts => ({
  type: ActionTypes.SET_CONNECTED_ACCOUNTS,
  payload: {
    connectedAccounts
  }
})

const addBlockedContacts = blockedContacts => ({
  type: ActionTypes.ADD_BLOCKED_CONTACTS,
  payload: {
    blockedContacts
  }
})

const setDeviceManufacturer = deviceManufacturer => ({
  type: ActionTypes.SET_DEVICE_MANUFACTURER,
  payload: {
    deviceManufacturer
  }
})

const addNewMessageToAlarmConversation = (alarmId, message) => ({
  type: ActionTypes.ADD_NEW_MESSAGE_TO_ALARM_CONVERSATION,
  payload: {
    alarmId,
    message
  }
})

const addMessagesToAlarmConversation = (alarmId, messages) => ({
  type: ActionTypes.ADD_MESSAGES_TO_ALARM_CONVERSATION,
  payload: {
    alarmId,
    messages
  }
})

const setIsLoadingEarlierMessagesForAlarm = (alarmId, isLoadingEarlier) => ({
  type: ActionTypes.SET_IS_LOADING_EARLIER_MESSAGES_FOR_ALARM,
  payload: {
    alarmId,
    isLoadingEarlier
  }
})

const processFirstMessageKeyForAlarmConversation = (
  alarmId,
  firstMessageKey
) => ({
  type: ActionTypes.PROCESS_FIRST_MESSAGE_KEY_FOR_ALARM_CONVERSATION,
  payload: {
    alarmId,
    firstMessageKey
  }
})

const updatePendingConversationMessageForAlarm = (alarmId, pendingMessage) => ({
  type: ActionTypes.UPDATE_PENDING_CONVERSATION_MESSAGE_FOR_ALARM,
  payload: {
    alarmId,
    pendingMessage
  }
})

const updatePendingFeedback = feedback => ({
  type: ActionTypes.UPDATE_PENDING_FEEDBACK,
  payload: {
    feedback
  }
})

const updatePendingProblem = problem => ({
  type: ActionTypes.UPDATE_PENDING_PROBLEM,
  payload: {
    problem
  }
})

const setUserEmail = email => ({
  type: ActionTypes.SET_USER_EMAIL,
  payload: {
    email
  }
})

const setShowSidebar = showSidebar => ({
  type: ActionTypes.SET_SHOW_SIDEBAR,
  payload: {
    showSidebar
  }
})

const updateUnseenMessagesForAlarm = (alarmId, unseenMessages) => ({
  type: ActionTypes.SET_UNSEEN_MESSAGES_FOR_ALARM,
  payload: {
    alarmId,
    unseenMessages
  }
})

const updateCurrentlyTypingUsersForAlarm = (alarmId, currentlyTypingUsers) => ({
  type: ActionTypes.UPDATE_CURRENTLY_TYPING_USERS_FOR_ALARM,
  payload: {
    alarmId,
    currentlyTypingUsers
  }
})

const addStartSnoozeForCreatorSoftPendingAction = (
  alarmId,
  snoozeInterval,
  snoozeDate
) => ({
  type: ActionTypes.ADD_START_SNOOZE_FOR_CREATOR_SOFT_PENDING_ACTION,
  payload: {
    alarmId,
    snoozeInterval,
    snoozeDate
  }
})

const addStopSnoozeForCreatorSoftPendingAction = (
  alarmId,
  scheduledRemotely = false
) => ({
  type: ActionTypes.ADD_STOP_SNOOZE_FOR_CREATOR_SOFT_PENDING_ACTION,
  payload: {
    alarmId,
    scheduledRemotely
  }
})

const addStartSnoozeForParticipantSoftPendingAction = (
  alarm,
  snoozeInterval,
  snoozeDate
) => ({
  type: ActionTypes.ADD_START_SNOOZE_FOR_PARTICIPANT_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    snoozeInterval,
    snoozeDate
  }
})

const addStopSnoozeForParticipantSoftPendingAction = alarm => ({
  type: ActionTypes.ADD_STOP_SNOOZE_FOR_PARTICIPANT_SOFT_PENDING_ACTION,
  payload: {
    alarm
  }
})

const addMarkPersonalAlarmDoneSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_MARK_PERSONAL_ALARM_DONE_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addMarkCreatorResponseForGroupAlarmSoftPendingAction = (
  alarm,
  response,
  rescheduleAlarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_MARK_CREATOR_RESPONSE_FOR_GROUP_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    response,
    rescheduleAlarm,
    occurrenceTime,
    timestamp
  }
})

const addMarkParticipantResponseForGroupAlarmSoftPendingAction = (
  alarm,
  response,
  rescheduleAlarm,
  updateAlarmResponseStatus,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_MARK_PARTICIPANT_RESPONSE_FOR_GROUP_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    response,
    rescheduleAlarm,
    updateAlarmResponseStatus,
    occurrenceTime,
    timestamp
  }
})

const addSkipPersonalAlarmSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_SKIP_PERSONAL_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addSkipPersonalParticipantAlarmSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_SKIP_PERSONAL_PARTICIPANT_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addUpdateRecipientAlarmDateAndTimeSoftPendingAction = (
  alarm,
  newRecipientDate,
  originalRecipientDate,
  currDate
) => ({
  type: ActionTypes.ADD_UPDATE_RECIPIENT_ALARM_DATE_TIME_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    newRecipientDate,
    originalRecipientDate,
    currDate
  }
})

const addSkipRecipientAlarmSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_SKIP_RECIPIENT_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addSkipRecipientCreatorAlarmSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_SKIP_RECIPIENT_CREATOR_ALARM_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addMarkRecipientAlarmDoneSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp
) => ({
  type: ActionTypes.ADD_MARK_RECIPIENT_ALARM_DONE_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp
  }
})

const addSetParticipantAlarmResponseSoftPendingAction = (
  alarm,
  participantResponse
) => ({
  type: ActionTypes.ADD_SET_PARTICIPANT_ALARM_RESPONSE_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    participantResponse
  }
})

const addSetRecipientAlarmResponseSoftPendingAction = (
  alarm,
  participantResponse
) => ({
  type: ActionTypes.ADD_SET_RECIPIENT_ALARM_RESPONSE_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    participantResponse
  }
})

const addSetPastAlarmOccurrenceResponseSoftPendingAction = (
  alarm,
  occurrenceTime,
  timestamp,
  response
) => ({
  type: ActionTypes.ADD_SET_PAST_ALARM_OCCURRENCE_RESPONSE_SOFT_PENDING_ACTION,
  payload: {
    alarm,
    occurrenceTime,
    timestamp,
    response
  }
})

const addUpdateGlobalAlarmRingerSettingsSoftPendingAction = ringerSettings => ({
  type: ActionTypes.ADD_UPDATE_GLOBAL_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION,
  payload: {
    ringerSettings
  }
})

const addUpdateRingParticipantAlarmsByDefaultSettingSoftPendingAction =
  ringParticipantAlarmsByDefault => ({
    type: ActionTypes.ADD_UPDATE_RING_PARTICIPANT_ALARMS_BY_DEFAULT_SETTING_SOFT_PENDING_ACTION,
    payload: {
      ringParticipantAlarmsByDefault
    }
  })

const addUpdateRingOnEarphoneOnlySoftPendingAction = ringOnEarphoneOnly => ({
  type: ActionTypes.ADD_UPDATE_RING_ON_EARPHONE_ONLY_SOFT_PENDING_ACTION,
  payload: {
    ringOnEarphoneOnly
  }
})

const addUpdateSpecifyTimezoneForAlarmSoftPendingAction =
  specifyTimezoneForAlarm => ({
    type: ActionTypes.ADD_UPDATE_SPECIFY_TIMEZONE_FOR_ALARM_SOFT_PENDING_ACTION,
    payload: {
      specifyTimezoneForAlarm
    }
  })

const addUpdateGestureToDimissAnAlarmSoftPendingAction =
  gestureToDismissAnAlarm => ({
    type: ActionTypes.ADD_UPDATE_GESTURE_TO_DISMISS_ALARM_SOFT_PENDING_ACTION,
    payload: {
      gestureToDismissAnAlarm
    }
  })

const addUpdatePreReminderRingtoneSoftPendingAction = preReminderRingtone => ({
  type: ActionTypes.ADD_UPDATE_PRE_REMINDER_RINGTONE_SOFT_PENDING_ACTION,
  payload: {
    preReminderRingtone
  }
})

const addUpdateTimerRingtoneSoftPendingAction = timerRingtone => ({
  type: ActionTypes.ADD_UPDATE_TIMER_RINGTONE_SOFT_PENDING_ACTION,
  payload: {
    timerRingtone
  }
})

const addUpdateMuteAlarmsSoftPendingAction = muteAlarms => ({
  type: ActionTypes.ADD_UPDATE_MUTE_ALARMS_SOFT_PENDING_ACTION,
  payload: {
    muteAlarms
  }
})

const addUpdateDefaultTimezoneForAlarmSoftPendingAction =
  defaultTimezoneForAlarm => ({
    type: ActionTypes.ADD_UPDATE_DEFAULT_TIMEZONE_FOR_ALARM_SOFT_PENDING_ACTION,
    payload: {
      defaultTimezoneForAlarm
    }
  })
const addUpdateNotificationSettingsSoftPendingAction =
  notificationSettings => ({
    type: ActionTypes.ADD_UPDATE_NOTIFICATION_SETTINGS_SOFT_PENDING_ACTION,
    payload: {
      notificationSettings
    }
  })

const addUpdateGraduallyIncreaseVolumeSoftPendingAction =
  graduallyIncreaseVolume => ({
    type: ActionTypes.ADD_UPDATE_GRADUALLY_INCREASE_VOLUME_SOFT_PENDING_ACTION,
    payload: {
      graduallyIncreaseVolume
    }
  })

const addUpdateShakeToStopAlarmSoftPendingAction = shakeToStopAlarm => ({
  type: ActionTypes.ADD_UPDATE_SHAKE_TO_STOP_ALARM_SOFT_PENDING_ACTION,
  payload: {
    shakeToStopAlarm
  }
})

const addUpdateShakeSensitivitySoftPendingAction = shakeSensitivity => ({
  type: ActionTypes.ADD_UPDATE_SHAKE_SENSITIVITY_SOFT_PENDING_ACTION,
  payload: {
    shakeSensitivity
  }
})

const addUpdatePinModeSoftPendingAction = pinMode => ({
  type: ActionTypes.ADD_UPDATE_PIN_MODE_SOFT_PENDING_ACTION,
  payload: {
    pinMode
  }
})

const addUpdateNotificationActionBehaviorSoftPendingAction =
  notificationActionBehavior => ({
    type: ActionTypes.ADD_UPDATE_NOTIFICATION_ACTION_BEHAVIOR_SOFT_PENDING_ACTION,
    payload: {
      notificationActionBehavior
    }
  })

const addUpdatePromptForUpdateSoftPendingAction = promptForUpdate => ({
  type: ActionTypes.ADD_UPDATE_PROMPT_FOR_UPDATE_SOFT_PENDING_ACTION,
  payload: {
    promptForUpdate
  }
})

const addUpdateSortAlarmCategoriesBySoftPendingAction =
  sortAlarmCategoriesBy => ({
    type: ActionTypes.ADD_UPDATE_SORT_ALARM_CATEGORIES_BY_SOFT_PENDING_ACTION,
    payload: {
      sortAlarmCategoriesBy
    }
  })

const addUpdateMissedAlarmPlacementSettingSoftPendingAction =
  missedAlarmPlacementSetting => ({
    type: ActionTypes.ADD_UPDATE_MISSED_ALARM_PLACEMENT_SETTING_SOFT_PENDING_ACTION,
    payload: {
      missedAlarmPlacementSetting
    }
  })

const addUpdateFabButtonBehaviorSoftPendingAction = fabButtonBehavior => ({
  type: ActionTypes.ADD_UPDATE_FAB_BUTTON_BEHAVIOR_SOFT_PENDING_ACTION,
  payload: {
    fabButtonBehavior
  }
})

const resetApp = () => ({
  type: ActionTypes.RESET_APP
})

const setRateTheAppUserInfo = rateTheAppInfo => ({
  type: ActionTypes.SET_RATE_THE_APP_USER_INFO,
  payload: {
    rateTheAppInfo
  }
})

const setExistingAlarmsLoaded = () => ({
  type: ActionTypes.SET_EXISTING_ALARMS_LOADED
})

const batchActions = (...actions) => ({
  type: ActionTypes.BATCH_ACTIONS,
  actions
})

const setContactsPermissionStatus = contactsPermissionStatus => ({
  type: ActionTypes.SET_CONTACTS_PERMISSION_STATUS,
  payload: {
    contactsPermissionStatus
  }
})

const setLatestRelease = latestRelease => ({
  type: ActionTypes.SET_LATEST_RELEASE,
  payload: {
    latestRelease
  }
})

const setTabActiveIndex = tabActiveIndex => ({
  type: ActionTypes.SET_TAB_ACTIVE_INDEX,
  payload: {
    tabActiveIndex
  }
})

const genericAction = (type, payload = {}) => ({
  type: type,
  payload
})

const willChangesBeDiscarded = appState => {
  return (
    objGet(appState, 'inspectorPanelConfig.newAlarmWizard.visible', false) ||
    objGet(appState, 'inspectorPanelConfig.editAlarmWizard.visible', false) ||
    objGet(appState, 'inspectorPanelConfig.newGroupWizard.visible', false) ||
    objGet(appState, 'inspectorPanelConfig.editGroupWizard.visible', false) ||
    objGet(
      appState,
      'inspectorPanelConfig.newInstantAlarmWizard.visible',
      false
    ) ||
    objGet(
      appState,
      'inspectorPanelConfig.changeMemberStateScreen.visible',
      false
    )
  )
}

const showNewInstantAlarmWizard = props => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_NEW_INSTANT_ALARM_WIZARD, props)
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_NEW_INSTANT_ALARM_WIZARD, props))
}

const showNewAlarmWizard = props => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.SHOW_NEW_ALARM_WIZARD, props))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_NEW_ALARM_WIZARD, props))
}

const showDuplicateAlarmWizard = props => dispatch => {
  dispatch(genericAction(ActionTypes.SHOW_DUPLICATE_ALARM_WIZARD, props))
}

const showEditAlarmWizard = alarmId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_EDIT_ALARM_WIZARD, {
              alarmId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_EDIT_ALARM_WIZARD, {
      alarmId
    })
  )
}

const showAlarmConversationScreen = alarmId => ({
  type: ActionTypes.SHOW_ALARM_CONVERSATION_SCREEN,
  payload: {
    alarmId
  }
})

const hideAlarmConversationScreen = () => ({
  type: ActionTypes.HIDE_ALARM_CONVERSATION_SCREEN
})

const showAlarmHistoryScreen = alarm => ({
  type: ActionTypes.SHOW_ALARM_HISTORY_SCREEN,
  payload: {
    alarm
  }
})

const hideAlarmHistoryScreen = () => ({
  type: ActionTypes.HIDE_ALARM_HISTORY_SCREEN
})

const showNewGroupWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.SHOW_NEW_GROUP_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_NEW_GROUP_WIZARD))
}

const showEditGroupWizard = groupId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_EDIT_GROUP_WIZARD, {
              groupId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_EDIT_GROUP_WIZARD, {
      groupId
    })
  )
}

const hideNewAlarmWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_NEW_ALARM_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_NEW_ALARM_WIZARD))
}

const hideDuplicateAlarmWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_DUPLICATE_ALARM_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_DUPLICATE_ALARM_WIZARD))
}

const hideNewInstantAlarmWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_NEW_INSTANT_ALARM_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_NEW_INSTANT_ALARM_WIZARD))
}

const hideEditAlarmWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_EDIT_ALARM_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_EDIT_ALARM_WIZARD))
}

// Close action directly closes the wizard without checking for
// discarded changes. These are called to close the wizard after
// user saves the alarm/group.

// eslint-disable-next-line no-unused-vars
const closeNewAlarmWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_NEW_ALARM_WIZARD))
}

// eslint-disable-next-line no-unused-vars
const closeDuplicateAlarmWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_DUPLICATE_ALARM_WIZARD))
}

// eslint-disable-next-line no-unused-vars
const closeInstantAlarmWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_NEW_INSTANT_ALARM_WIZARD))
}

// eslint-disable-next-line no-unused-vars
const closeEditAlarmWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_EDIT_ALARM_WIZARD))
}

// eslint-disable-next-line no-unused-vars
const closeNewGroupWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_NEW_GROUP_WIZARD))
}

// eslint-disable-next-line no-unused-vars
const closeEditGroupWizard = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_EDIT_GROUP_WIZARD))
}

const resetInspectorPanel = () => ({
  type: ActionTypes.RESET_INSPECTOR_PANEL
})

const hideNewGroupWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_NEW_GROUP_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_NEW_GROUP_WIZARD))
}

const hideEditGroupWizard = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_EDIT_GROUP_WIZARD))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_EDIT_GROUP_WIZARD))
}

const showSelectAlarmTypeScreen = props => (dispatch, getState) => {
  const canCreateNewAlarmData = canCreateNewAlarmDataSelector(getState())

  // This is only called for galarm-web and hence not passed a navigation object
  // to canCreateNewAlarmAndShowAlertsIfNeeded. If called from mobile, this method
  // requires navigation object
  const canCreateNewAlarm =
    AlarmUtilsWithExtras.canCreateNewAlarmAndShowAlertsIfNeeded(
      canCreateNewAlarmData
    )
  if (!canCreateNewAlarm) {
    return
  }

  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_SELECT_ALARM_TYPE_SCREEN, props)
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_SELECT_ALARM_TYPE_SCREEN, props))
}

const hideSelectAlarmTypeScreen = () => ({
  type: ActionTypes.HIDE_SELECT_ALARM_TYPE_SCREEN
})

const showAlarmDetailsScreen = alarmId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_ALARM_DETAILS_SCREEN, {
              alarmId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_ALARM_DETAILS_SCREEN, {
      alarmId
    })
  )
}

const showCalendarEventDetailsScreen = eventId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_CALENDAR_EVENT_DETAILS_SCREEN, {
              eventId
            })
          )
      },
      { text: I18n.t('no') }
    ])
    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_CALENDAR_EVENT_DETAILS_SCREEN, {
      eventId
    })
  )
}

const showInstantAlarmDetailsScreen = alarmId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_INSTANT_ALARM_DETAILS_SCREEN, {
              alarmId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_INSTANT_ALARM_DETAILS_SCREEN, {
      alarmId
    })
  )
}

// eslint-disable-next-line no-unused-vars
const hideAlarmDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_ALARM_DETAILS_SCREEN))
}

// eslint-disable-next-line no-unused-vars
const hideCalendarEventDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_CALENDAR_EVENT_DETAILS_SCREEN))
}

// eslint-disable-next-line no-unused-vars
const hideInstantAlarmDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_INSTANT_ALARM_DETAILS_SCREEN))
}

const showInstantParticipantAlarmDetailsScreen =
  alarmId => (dispatch, getState) => {
    if (willChangesBeDiscarded(getState().appState)) {
      NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
        {
          text: I18n.t('yes'),
          onPress: () =>
            dispatch(
              genericAction(
                ActionTypes.SHOW_INSTANT_PARTICIPANT_ALARM_DETAILS_SCREEN,
                {
                  alarmId
                }
              )
            )
        },
        {
          text: I18n.t('no')
        }
      ])

      return
    }
    dispatch(
      genericAction(ActionTypes.SHOW_INSTANT_PARTICIPANT_ALARM_DETAILS_SCREEN, {
        alarmId
      })
    )
  }

const showIncidentAlarmDetailsScreen = alarmId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_INCIDENT_ALARM_DETAILS_SCREEN, {
              alarmId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_INCIDENT_ALARM_DETAILS_SCREEN, {
      alarmId
    })
  )
}

const showParticipantAlarmDetailsScreen = alarmId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_PARTICIPANT_ALARM_DETAILS_SCREEN, {
              alarmId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_PARTICIPANT_ALARM_DETAILS_SCREEN, {
      alarmId
    })
  )
}

// eslint-disable-next-line no-unused-vars
const hideParticipantAlarmDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_PARTICIPANT_ALARM_DETAILS_SCREEN))
}

// eslint-disable-next-line no-unused-vars
const hideInstantParticipantAlarmDetailsScreen = () => (dispatch, getState) => {
  dispatch(
    genericAction(ActionTypes.HIDE_INSTANT_PARTICIPANT_ALARM_DETAILS_SCREEN)
  )
}

// eslint-disable-next-line no-unused-vars
const hideIncidentAlarmDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_INCIDENT_ALARM_DETAILS_SCREEN))
}

const showGroupDetailsScreen = groupId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_GROUP_DETAILS_SCREEN, { groupId })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_GROUP_DETAILS_SCREEN, { groupId }))
}

// eslint-disable-next-line no-unused-vars
const hideGroupDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_GROUP_DETAILS_SCREEN))
}

const showChangeMemberStateScreen =
  (groupId, groupName, members, updateMemberState, memberToChange) =>
  (dispatch, getState) => {
    if (willChangesBeDiscarded(getState().appState)) {
      NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
        {
          text: I18n.t('yes'),
          onPress: () =>
            dispatch(
              genericAction(ActionTypes.SHOW_CHANGE_MEMBER_STATE_SCREEN, {
                groupId,
                groupName,
                members,
                updateMemberState,
                memberToChange
              })
            )
        },
        {
          text: I18n.t('no')
        }
      ])

      return
    }
    dispatch(
      genericAction(ActionTypes.SHOW_CHANGE_MEMBER_STATE_SCREEN, {
        groupId,
        groupName,
        members,
        updateMemberState,
        memberToChange
      })
    )
  }

const showContactDetailsScreen = contactId => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(
            genericAction(ActionTypes.SHOW_CONTACT_DETAILS_SCREEN, {
              contactId
            })
          )
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(
    genericAction(ActionTypes.SHOW_CONTACT_DETAILS_SCREEN, { contactId })
  )
}

// eslint-disable-next-line no-unused-vars
const hideChangeGroupMemberStateScreen = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.HIDE_CHANGE_MEMBER_STATE_SCREEN))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.HIDE_CHANGE_MEMBER_STATE_SCREEN))
}

// eslint-disable-next-line no-unused-vars
const closeChangeGroupMemberStateScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_CHANGE_MEMBER_STATE_SCREEN))
}

// eslint-disable-next-line no-unused-vars
const hideContactDetailsScreen = () => (dispatch, getState) => {
  dispatch(genericAction(ActionTypes.HIDE_CONTACT_DETAILS_SCREEN))
}

const showReportAProblemScreen = () => ({
  type: ActionTypes.SHOW_REPORT_A_PROBLEM_SCREEN
})

const hideReportAProblemScreen = () => ({
  type: ActionTypes.HIDE_REPORT_A_PROBLEM_SCREEN
})

const showProfileAndSettingsScreen = () => (dispatch, getState) => {
  if (willChangesBeDiscarded(getState().appState)) {
    NavigationUtils.showAlert(I18n.t('confirm'), I18n.t('discardChanges'), [
      {
        text: I18n.t('yes'),
        onPress: () =>
          dispatch(genericAction(ActionTypes.SHOW_PROFILE_AND_SETTINGS_SCREEN))
      },
      {
        text: I18n.t('no')
      }
    ])

    return
  }
  dispatch(genericAction(ActionTypes.SHOW_PROFILE_AND_SETTINGS_SCREEN))
}

const hideProfileAndSettingsScreen = () => ({
  type: ActionTypes.HIDE_PROFILE_AND_SETTINGS_SCREEN
})

// rescheduleAlarm is used by group alarm if a user
// confirm the group alarm in advance but still wants
// the alarm to ring at the set time. For other types
// of alarms, it is defualted to true which would have
// no affect on the functioning of the alarm. But it could
// be used for other alarm types also. For e.g. when user
// marks an alarm done in advance, they can be asked the
// same question.
const addAlarmAcknowledgementAction = (
  alarm,
  occurrenceTime,
  uid,
  timestamp,
  response,
  rescheduleAlarm
) => {
  const occurrenceTimeString = AlarmUtils.getOccurrenceTimeString(
    occurrenceTime,
    alarm.creatorTimezoneOffset,
    alarm.creatorTimezone
  )
  return {
    type: ActionTypes.ADD_ALARM_ACKNOWLEDGEMENT,
    payload: {
      alarmId: alarm.id,
      occurrenceTimeString,
      uid,
      timestamp,
      response,
      rescheduleAlarm
    }
  }
}

const addIncidentAlarmAcknowledgementAction = (
  alarmId,
  occurrenceTimeString,
  uid,
  timestamp,
  response,
  rescheduleAlarm
) => {
  return {
    type: ActionTypes.ADD_ALARM_ACKNOWLEDGEMENT,
    payload: {
      alarmId,
      occurrenceTimeString,
      uid,
      timestamp,
      response,
      rescheduleAlarm
    }
  }
}

const removeAlarmAcknowledgementActions = alarmId => ({
  type: ActionTypes.REMOVE_ALARM_ACKNOWLEDGEMENTS,
  payload: {
    alarmId
  }
})

const addAlarmStatusChangeAction = (alarmId, timestamp, status) => ({
  type: ActionTypes.ADD_ALARM_STATUS_CHANGE,
  payload: {
    alarmId,
    timestamp,
    status
  }
})

const removeAlarmStatusChangeActions = alarmId => ({
  type: ActionTypes.REMOVE_ALARM_STATUS_CHANGES,
  payload: {
    alarmId
  }
})

const addAlarmAcknowledgements = (alarmId, alarmAcknowledgements) => ({
  type: ActionTypes.ADD_ALARM_ACKNOWLEDGEMENTS,
  payload: {
    alarmId,
    alarmAcknowledgements
  }
})

const updateAlarmsAcknowledgements = alarmsAcknowledgements => ({
  type: ActionTypes.UPDATE_ALARMS_ACKNOWLEDGEMENTS,
  payload: {
    alarmsAcknowledgements
  }
})

const addAlarmStatusChanges = (alarmId, alarmStatusChanges) => ({
  type: ActionTypes.ADD_ALARM_STATUS_CHANGES,
  payload: {
    alarmId,
    alarmStatusChanges
  }
})

const updateAlarmsStatusChanges = alarmsStatusChanges => ({
  type: ActionTypes.UPDATE_ALARMS_STATUS_CHANGES,
  payload: {
    alarmsStatusChanges
  }
})

const addSkuDetails = skuDetails => ({
  type: ActionTypes.ADD_SKU_DETAILS,
  payload: {
    skuDetails
  }
})

const setJoinDate = joinDate => ({
  type: ActionTypes.SET_JOIN_DATE,
  payload: {
    joinDate
  }
})

const setShareableAlarmLinksCount = shareableAlarmLinksCount => ({
  type: ActionTypes.SET_SHAREABLE_ALARM_LINKS_COUNT,
  payload: {
    shareableAlarmLinksCount
  }
})

const setAlarmsSavedToCalendarCount = alarmsSavedToCalendarCount => ({
  type: ActionTypes.SET_ALARMS_SAVED_TO_CALENDAR_COUNT,
  payload: {
    alarmsSavedToCalendarCount
  }
})

const setInstantAlarmsCount = instantAlarmsCount => ({
  type: ActionTypes.SET_INSTANT_ALARMS_COUNT,
  payload: {
    instantAlarmsCount
  }
})

const setColorScheme = colorScheme => ({
  type: ActionTypes.SET_COLOR_SCHEME,
  payload: {
    colorScheme
  }
})

const setWebColorScheme = webColorScheme => ({
  type: ActionTypes.SET_WEB_COLOR_SCHEME,
  payload: {
    webColorScheme
  }
})

const setPrimaryColorId = primaryColorId => ({
  type: ActionTypes.SET_PRIMARY_COLOR_ID,
  payload: {
    primaryColorId
  }
})

const toggleCategorizedAlarmView = () => ({
  type: ActionTypes.TOGGLE_CATEGORIZED_ALARM_VIEW
})

const setSeenSpecifyTimezoneAlert = () => ({
  type: ActionTypes.SET_SEEN_SPECIFY_TIMEZONE_ALERT
})

const setAlarmCategories = alarmCategories => ({
  type: ActionTypes.SET_ALARM_CATEGORIES,
  payload: {
    alarmCategories
  }
})

const createAlarmCategoryLocally = (id, alarmCategory) => ({
  type: ActionTypes.CREATE_ALARM_CATEGORY,
  payload: {
    id,
    alarmCategory
  }
})

const addAlarmToAlarmCategoryLocally = (id, alarmId) => ({
  type: ActionTypes.ADD_ALARM_TO_ALARM_CATEGORY,
  payload: {
    id,
    alarmId
  }
})

const removeAlarmFromAlarmCategoryLocally = (id, alarmId) => ({
  type: ActionTypes.REMOVE_ALARM_FROM_ALARM_CATEGORY,
  payload: {
    id,
    alarmId
  }
})

const deleteAlarmCategoryLocally = id => ({
  type: ActionTypes.DELETE_ALARM_CATEGORY,
  payload: {
    id
  }
})

const updateRecentContactsLocally = recentContacts => ({
  type: ActionTypes.UPDATE_RECENT_CONTACTS,
  payload: {
    recentContacts
  }
})

const updateRecentGroupsLocally = recentGroups => ({
  type: ActionTypes.UPDATE_RECENT_GROUPS,
  payload: {
    recentGroups
  }
})

const setRecentContacts = recentContacts => ({
  type: ActionTypes.SET_RECENT_CONTACTS,
  payload: {
    recentContacts
  }
})

const setRecentGroups = recentGroups => ({
  type: ActionTypes.SET_RECENT_GROUPS,
  payload: {
    recentGroups
  }
})

const updateRecentContacts = contactIds => dispatch => {
  const currDate = Date.now()
  // Add timestamp to recent contact ids
  const recentContacts = contactIds.reduce((acc, contactId) => {
    acc[contactId] = currDate
    return acc
  }, {})

  dispatch(updateRecentContactsLocally(recentContacts))

  GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/recentContacts`
    ),
    recentContacts
  )
}

const updateRecentGroups = groupId => dispatch => {
  const currDate = Date.now()
  // Add timestamp to recent group id
  const recentGroups = {
    [groupId]: currDate
  }

  dispatch(updateRecentGroupsLocally(recentGroups))

  GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/recentGroups`
    ),
    recentGroups
  )
}

const updateAlarmCategoryLocally = (id, alarmCategory) => ({
  type: ActionTypes.UPDATE_ALARM_CATEGORY,
  payload: {
    id,
    alarmCategory
  }
})

const unhideAlarmCategoryLocally = id => ({
  type: ActionTypes.UNHIDE_ALARM_CATEGORY,
  payload: {
    id
  }
})

const hideAlarmCategoryLocally = id => ({
  type: ActionTypes.HIDE_ALARM_CATEGORY,
  payload: {
    id
  }
})

const addAddAlarmToAlarmCategorySoftPendingAction = (
  alarmCategoryId,
  alarmId
) => ({
  type: ActionTypes.ADD_ADD_ALARM_TO_ALARM_CATEGORY_SOFT_PENDING_ACTION,
  payload: {
    alarmCategoryId,
    alarmId
  }
})

const addRemoveAlarmFromAlarmCategorySoftPendingAction = (
  alarmCategoryId,
  alarmId
) => ({
  type: ActionTypes.ADD_REMOVE_ALARM_FROM_ALARM_CATEGORY_SOFT_PENDING_ACTION,
  payload: {
    alarmCategoryId,
    alarmId
  }
})

const addDeleteAlarmCategorySoftPendingAction = alarmCategoryId => ({
  type: ActionTypes.ADD_DELETE_ALARM_CATEGORY_SOFT_PENDING_ACTION,
  payload: {
    alarmCategoryId
  }
})

const setShowAppRunningElsewhereAlert = showAppRunningElsewhereAlert => ({
  type: ActionTypes.SET_SHOW_APP_RUNNING_ELSEWHERE_ALERT,
  payload: {
    showAppRunningElsewhereAlert
  }
})

const setMobileAndWebTimezoneMismatchDetected =
  mobileAndWebTimezoneMismatchDetected => ({
    type: ActionTypes.SET_MOBILE_AND_WEB_TIMEZONE_MISMATCH_DETECTED,
    payload: {
      mobileAndWebTimezoneMismatchDetected
    }
  })

const setIosNumNotificationsScheduled = iosNumNotificationsScheduled => ({
  type: ActionTypes.SET_IOS_NUM_NOTIFICATIONS_SCHEDULED,
  payload: {
    iosNumNotificationsScheduled
  }
})

const setShowQuickReminder = showQuickReminder => ({
  type: ActionTypes.SET_SHOW_QUICK_REMINDER,
  payload: {
    showQuickReminder
  }
})

const setCurrentlySelectedAlarmCategoryId = id => ({
  type: ActionTypes.SET_CURRENTLY_SELECTED_ALARM_CATEGORY_ID,
  payload: {
    id
  }
})

const setCurrentlySelectedTaskListId = id => ({
  type: ActionTypes.SET_CURRENTLY_SELECTED_TASK_LIST_ID,
  payload: {
    id
  }
})

const setShowAlertIncidents = showAlertIncidents => ({
  type: ActionTypes.SET_SHOW_ALERT_INCIDENTS,
  payload: {
    showAlertIncidents
  }
})

const setShowExpiredAlarms = showExpiredAlarms => ({
  type: ActionTypes.SET_SHOW_EXPIRED_ALARMS,
  payload: {
    showExpiredAlarms
  }
})

const setShowCalendarEvents = showCalendarEvents => ({
  type: ActionTypes.SET_SHOW_CALENDAR_EVENTS,
  payload: {
    showCalendarEvents
  }
})

const setShowInstantAlarms = showInstantAlarms => ({
  type: ActionTypes.SET_SHOW_INSTANT_ALARMS,
  payload: {
    showInstantAlarms
  }
})

const setShowTasks = showTasks => ({
  type: ActionTypes.SET_SHOW_TASKS,
  payload: {
    showTasks
  }
})

const setBatteryOptimizationDisabled = batteryOptimizationDisabled => ({
  type: ActionTypes.SET_BATTERY_OPTIMIZATION_DISABLED,
  payload: {
    batteryOptimizationDisabled
  }
})

const setDndAccessGranted = dndAccessGranted => ({
  type: ActionTypes.SET_DND_ACCESS_GRANTED,
  payload: {
    dndAccessGranted
  }
})

const setScheduleExactAlarmsEnabled = scheduleExactAlarmsEnabled => ({
  type: ActionTypes.SET_SCHEDULE_EXACT_ALARMS_ENABLED,
  payload: {
    scheduleExactAlarmsEnabled
  }
})

const setFirstDayOfWeek = firstDayOfWeek => ({
  type: ActionTypes.SET_FIRST_DAY_OF_WEEK,
  payload: {
    firstDayOfWeek
  }
})

const setWebFirstDayOfWeek = webFirstDayOfWeek => ({
  type: ActionTypes.SET_WEB_FIRST_DAY_OF_WEEK,
  payload: {
    webFirstDayOfWeek
  }
})

const addUpdateAlarmCategorySoftPendingAction = (
  alarmCategoryId,
  alarmCategory
) => ({
  type: ActionTypes.ADD_UPDATE_ALARM_CATEGORY_SOFT_PENDING_ACTION,
  payload: {
    alarmCategoryId,
    alarmCategory
  }
})

const addCreateAlarmCategorySoftPendingAction = (
  alarmCategoryId,
  alarmCategory
) => ({
  type: ActionTypes.ADD_CREATE_ALARM_CATEGORY_SOFT_PENDING_ACTION,
  payload: {
    alarmCategoryId,
    alarmCategory
  }
})

const updateWebColorScheme = colorScheme => dispatch => {
  GlobalConfig.webColorScheme = colorScheme
  dispatch(setWebColorScheme(colorScheme))
  AlarmUtils.setWebColorScheme(colorScheme)
}

const updateColorScheme = colorScheme => dispatch => {
  StorageManager.storeData({ colorScheme: colorScheme })
  GlobalConfig.colorScheme = colorScheme
  dispatch(setColorScheme(colorScheme))
  GlobalConfig.eventEmitter.emit('changeTheme', colorScheme)
}

const updatePrimaryColorId = primaryColorId => dispatch => {
  StorageManager.storeData({ primaryColorId: primaryColorId })
  GlobalConfig.primaryColorId = primaryColorId
  dispatch(setPrimaryColorId(primaryColorId))
  GlobalConfig.eventEmitter.emit('changePrimaryColor', primaryColorId)
}

const updateFirstDayOfWeekUserSetting = firstDayOfWeek => dispatch => {
  StorageManager.storeData({ firstDayOfWeek: firstDayOfWeek.toString() })
  GlobalConfig.firstDayOfWeek = firstDayOfWeek
  dispatch(setFirstDayOfWeek(firstDayOfWeek))
}

// eslint-disable-next-line no-unused-vars
const updateWebFirstDayOfWeekUserSetting = webFirstDayOfWeek => dispatch => {
  dispatch(setWebFirstDayOfWeek(webFirstDayOfWeek))
  AlarmUtils.updateWebFirstDayOfWeek(webFirstDayOfWeek)
}

const addAlarmToAlarmCategory =
  (alarmCategoryId, alarmId) => (dispatch, getState) => {
    dispatch(addAlarmToAlarmCategoryLocally(alarmCategoryId, alarmId))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (persistOnFirebase) {
      AlarmUtils.addAlarmToAlarmCategory(alarmCategoryId, alarmId)
    } else {
      dispatch(
        addAddAlarmToAlarmCategorySoftPendingAction(alarmCategoryId, alarmId)
      )
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.ADD_ALARM_TO_ALARM_CATEGORY,
      {}
    )
  }

const removeAlarmFromAlarmCategory =
  (alarmCategoryId, alarmId) => (dispatch, getState) => {
    dispatch(removeAlarmFromAlarmCategoryLocally(alarmCategoryId, alarmId))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (persistOnFirebase) {
      AlarmUtils.removeAlarmFromAlarmCategory(alarmCategoryId, alarmId)
    } else {
      dispatch(
        addRemoveAlarmFromAlarmCategorySoftPendingAction(
          alarmCategoryId,
          alarmId
        )
      )
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.REMOVE_ALARM_FROM_ALARM_CATEGORY,
      {}
    )
  }

const deleteAlarmCategory = alarmCategoryId => (dispatch, getState) => {
  dispatch(deleteAlarmCategoryLocally(alarmCategoryId))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  if (persistOnFirebase) {
    AlarmUtils.deleteAlarmCategory(alarmCategoryId)
  } else {
    dispatch(addDeleteAlarmCategorySoftPendingAction(alarmCategoryId))
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.DELETE_ALARM_CATEGORY,
    {}
  )
}

const deleteAlarmsInCategory = (alarmCategoryId, alarmIds) => dispatch => {
  if (alarmIds.length !== 0) {
    dispatch(deleteAllAlarms(alarmIds, 'deleteAlarmsInCategory'))
  }
}

const unhideAlarmCategory = alarmCategoryId => (dispatch, getState) => {
  dispatch(unhideAlarmCategoryLocally(alarmCategoryId))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  const alarmCategoryUpdate = { disabled: null }

  if (persistOnFirebase) {
    AlarmUtils.updateAlarmCategory(alarmCategoryId, alarmCategoryUpdate)
  } else {
    dispatch(
      addUpdateAlarmCategorySoftPendingAction(
        alarmCategoryId,
        alarmCategoryUpdate
      )
    )
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.UNHIDE_ALARM_CATEGORY,
    {}
  )
}

const hideAlarmCategory = alarmCategoryId => (dispatch, getState) => {
  dispatch(hideAlarmCategoryLocally(alarmCategoryId))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  const alarmCategoryUpdate = { disabled: true, alarmIds: null }

  if (persistOnFirebase) {
    AlarmUtils.updateAlarmCategory(alarmCategoryId, alarmCategoryUpdate)
  } else {
    dispatch(
      addUpdateAlarmCategorySoftPendingAction(
        alarmCategoryId,
        alarmCategoryUpdate
      )
    )
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.HIDE_ALARM_CATEGORY, {})
}

const updateAlarmCategory =
  (alarmCategoryId, alarmCategory) => (dispatch, getState) => {
    dispatch(updateAlarmCategoryLocally(alarmCategoryId, alarmCategory))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (persistOnFirebase) {
      AlarmUtils.updateAlarmCategory(alarmCategoryId, alarmCategory)
    } else {
      dispatch(
        addUpdateAlarmCategorySoftPendingAction(alarmCategoryId, alarmCategory)
      )
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.UPDATE_ALARM_CATEGORY,
      {}
    )
  }

const createAlarmCategory = alarmCategory => (dispatch, getState) => {
  const id = GlobalConfig.firebaseHelpers.generatePushKey(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alarmCategories`
    )
  )
  const alarmCategoryWithId = {
    id,
    ...alarmCategory
  }

  dispatch(createAlarmCategoryLocally(id, alarmCategoryWithId))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  if (persistOnFirebase) {
    AlarmUtils.createAlarmCategory(id, alarmCategoryWithId)
  } else {
    dispatch(addCreateAlarmCategorySoftPendingAction(id, alarmCategoryWithId))
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.CREATE_ALARM_CATEGORY, {
    [Constants.UserAnalyticsEventParameters.SOURCE]: alarmCategory.source
  })

  return Promise.resolve(alarmCategoryWithId)
}

// eslint-disable-next-line no-unused-vars
const deleteAllUserDefinedAlarmCategories = () => (dispatch, getState) => {
  const alarmCategories = alarmCategoriesSelector(getState())
  Object.values(alarmCategories).forEach(alarmCategory => {
    if (alarmCategory.source !== Constants.ALARM_CATEGORY_SOURCES.SYSTEM) {
      dispatch(deleteAlarmCategory(alarmCategory.id))
    }
  })
  if (Object.values(alarmCategories).length > 0) {
    const alert = {
      id: 'allUserCategoriesDeleted',
      type: Constants.AlertTypes.ALL_USER_CATEGORIES_DELETED,
      message: I18n.t('allUserCategoriesDeleted')
    }

    dispatch(addSystemAlert(alert))
  }
}

const handlePendingActions = () => async (dispatch, getState) => {
  console.log('Handling pending actions')

  // Archives a permanently-failing action to Firestore so support can inspect
  // the payload later, surfaces a system alert with the reference ID, then
  // removes the action from the queue.
  const archiveAndDrop = async (failedAction, removeActionCreator) => {
    let referenceId = null
    try {
      const docRef = await GlobalConfig.firebaseHelpers.addDocument(
        GlobalConfig.firebaseHelpers.collectionRef(
          `userInfos/${GlobalConfig.uid}/failedPendingActions`
        ),
        {
          ...failedAction,
          uid: GlobalConfig.uid,
          failedAt: Date.now()
        }
      )
      referenceId = docRef.id
    } catch (archiveError) {
      LogUtils.logError(
        archiveError,
        'Unable to archive failed pending action',
        failedAction
      )
    }

    dispatch(
      addSystemAlert({
        id: `pendingActionFailed_${failedAction.id}`,
        type: Constants.AlertTypes.PENDING_ACTION_FAILED,
        message: referenceId
          ? I18n.t('pendingActionFailedWithRef', {
              actionName: failedAction.name,
              referenceId
            })
          : I18n.t('pendingActionFailed', { actionName: failedAction.name })
      })
    )
    dispatch(removeActionCreator(failedAction.id))
  }

  // Snapshot the queue before iterating. This means a failed action is left
  // in the live queue for retry on the next connectivity event, but we still
  // process all the other (independent) actions in this pass instead of
  // stopping at the first failure.
  const pendingActionsSnapshot = [...getState().pendingActions.pendingActions]
  for (const pendingAction of pendingActionsSnapshot) {
    try {
      switch (pendingAction.name) {
        case Constants.ADD_ALARM_PENDING_ACTION_NAME:
          await handleAddAlarmPendingAction(pendingAction.alarm)
          break
        case Constants.DELETE_ALARM_PENDING_ACTION_NAME:
          await handleDeleteAlarmPendingAction(pendingAction.alarm)
          break
        case Constants.EDIT_ALARM_PENDING_ACTION_NAME:
          await handleEditAlarmPendingAction(
            pendingAction.editedAlarm,
            pendingAction.prevAlarm,
            pendingAction.removeSubscription,
            pendingAction.wipeAlarmActions
          )
          break
        case Constants.ADD_CHECKLIST_PENDING_ACTION_NAME:
          await handleAddChecklistPendingAction(pendingAction.checklist)
          break
        case Constants.EDIT_CHECKLIST_PENDING_ACTION_NAME:
          await handleEditChecklistPendingAction(pendingAction.checklist)
          break
        case Constants.REMOVE_CHECKLIST_PENDING_ACTION_NAME:
          await handleRemoveChecklistPendingAction(pendingAction.checklistId)
          break
        case Constants.ADD_ENABLE_DISABLE_ALARM_PENDING_ACTION_NAME:
          await handleEnableDisableAlarmPendingAction(
            pendingAction.alarm,
            pendingAction.timestamp,
            pendingAction.alarmStatus
          )
          break
        case Constants.REMOVE_REMOTE_ALARM_NOTIFICATION_PENDING_ACTION_NAME:
          await handleRemoveRemoteAlarmNotificationPendingAction(
            pendingAction.alarmId
          )
          break
        default:
          LogUtils.logError(
            new Error('Unknown pending action ' + pendingAction.name)
          )
      }
      dispatch(removePendingAction(pendingAction.id))
    } catch (error) {
      // Do NOT remove the pending action on error — it may be a transient
      // network/Firebase failure. Leave it in the queue so it is retried the
      // next time the device comes online. We intentionally do NOT break here:
      // subsequent actions for other alarms are independent and should still
      // be processed in this pass.
      LogUtils.logError(error, 'Unable to handle pending action', pendingAction)
      const MAX_RETRIES = 3
      const retryCount = (pendingAction.retryCount || 0) + 1
      if (retryCount >= MAX_RETRIES) {
        // Archive to Firestore for support recovery, surface alert, then drop.
        await archiveAndDrop(pendingAction, removePendingAction)
      } else {
        dispatch(updatePendingActionRetryCount(pendingAction.id))
      }
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.HANDLE_PENDING_ACTION,
      {
        [Constants.UserAnalyticsEventParameters.ACTION_NAME]: pendingAction.name
      }
    )
  }

  const softPendingActionsSnapshot = [
    ...getState().pendingActions.softPendingActions
  ]
  for (const softPendingAction of softPendingActionsSnapshot) {
    try {
      switch (softPendingAction.name) {
        case Constants.START_SNOOZE_FOR_CREATOR_SOFT_PENDING_ACTION_NAME:
          await handleStartSnoozeForCreatorPendingAction(softPendingAction)
          break
        case Constants.STOP_SNOOZE_FOR_CREATOR_SOFT_PENDING_ACTION_NAME:
          await handleStopSnoozeForCreatorPendingAction(
            softPendingAction.alarmId,
            softPendingAction.scheduledRemotely
          )
          break
        case Constants.START_SNOOZE_FOR_PARTICIPANT_SOFT_PENDING_ACTION_NAME:
          await handleStartSnoozeForParticipantPendingAction(softPendingAction)
          break
        case Constants.STOP_SNOOZE_FOR_PARTICIPANT_SOFT_PENDING_ACTION_NAME:
          await handleStopSnoozeForParticipantPendingAction(
            softPendingAction.alarm
          )
          break
        case Constants.MARK_PERSONAL_ALARM_DONE_SOFT_PENDING_ACTION_NAME:
          await handleMarkPersonalAlarmDonePendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.SKIP_PERSONAL_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleSkipPersonalAlarmPendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.SKIP_PERSONAL_PARTICIPANT_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleSkipPersonalParticipantAlarmPendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.SKIP_RECIPIENT_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleSkipRecipientAlarmPendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.SKIP_RECIPIENT_CREATOR_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleSkipRecipientCreatorAlarmPendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.UPDATE_RECIPIENT_ALARM_DATE_TIME_SOFT_PENDING_ACTION_NAME:
          await handleUpdateRecipientAlarmDateAndTimePendingAction(
            softPendingAction.alarm,
            softPendingAction.newRecipientDate,
            softPendingAction.originalRecipientDate,
            softPendingAction.currDate
          )
          break
        case Constants.MARK_RECIPIENT_ALARM_DONE_SOFT_PENDING_ACTION_NAME:
          await handleMarkRecipientAlarmDonePendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp
          )
          break
        case Constants.SET_PARTICIPANT_ALARM_RESPONSE_SOFT_PENDING_ACTION_NAME:
          await handleSetParticipantAlarmResponsePendingAction(
            softPendingAction.alarm,
            softPendingAction.participantResponse
          )
          break
        case Constants.SET_RECIPIENT_ALARM_RESPONSE_SOFT_PENDING_ACTION_NAME:
          await handleSetRecipientAlarmResponsePendingAction(
            softPendingAction.alarm,
            softPendingAction.participantResponse
          )
          break
        case Constants.SET_PAST_ALARM_OCCURRENCE_RESPONSE_SOFT_PENDING_ACTION_NAME:
          await handleSetPastAlarmOccurrenceResponsePendingAction(
            softPendingAction.alarm,
            softPendingAction.occurrenceTime,
            softPendingAction.timestamp,
            softPendingAction.response
          )
          break
        case Constants.ADD_UPDATE_PARTICIPANT_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateParticipantAlarmRingerSettingsPendingAction(
            softPendingAction.alarm,
            softPendingAction.ringerSettings
          )
          break
        case Constants.ADD_UPDATE_PARTICIPANT_ALARM_PRE_REMINDER_DURATION_SOFT_PENDING_ACTION_NAME:
          await handleUpdateParticipantAlarmPreReminderDurationPendingAction(
            softPendingAction.alarm,
            softPendingAction.preReminderDuration
          )
          break
        case Constants.ADD_UPDATE_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateAlarmRingerSettingsPendingAction(
            softPendingAction.alarm,
            softPendingAction.ringerSettings
          )
          break
        case Constants.ADD_UPDATE_ALARM_PRE_REMINDER_SOFT_PENDING_ACTION_NAME:
          await handleUpdateAlarmPreReminderPendingAction(
            softPendingAction.alarm,
            softPendingAction.preReminderDuration
          )
          break
        case Constants.ADD_UPDATE_GLOBAL_ALARM_RINGER_SETTINGS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateGlobalAlarmRingerSettingsPendingAction(
            softPendingAction.ringerSettings
          )
          break
        case Constants.ADD_UPDATE_RING_PARTICIPANT_ALARMS_BY_DEFAULT_SETTING_SOFT_PENDING_ACTION_NAME:
          await handleUpdateRingParticipantAlarmsByDefaultSettingPendingAction(
            softPendingAction.ringParticipantAlarmsByDefault
          )
          break
        case Constants.ADD_ALARM_TO_ALARM_CATEGORY_SOFT_PENDING_ACTION_NAME:
          await handleAddAlarmToAlarmCategoryPendingAction(softPendingAction)
          break
        case Constants.REMOVE_ALARM_FROM_ALARM_CATEGORY_SOFT_PENDING_ACTION_NAME:
          await handleRemoveAlarmFromAlarmCategoryPendingAction(
            softPendingAction
          )
          break
        case Constants.DELETE_ALARM_CATEGORY_SOFT_PENDING_ACTION_NAME:
          await handleDeleteAlarmCategoryPendingAction(softPendingAction)
          break
        case Constants.UPDATE_ALARM_CATEGORY_SOFT_PENDING_ACTION_NAME:
          await handleUpdateAlarmCategoryPendingAction(softPendingAction)
          break
        case Constants.CREATE_ALARM_CATEGORY_SOFT_PENDING_ACTION_NAME:
          await handleCreateAlarmCategoryPendingAction(softPendingAction)
          break
        case Constants.MARK_CREATOR_RESPONSE_FOR_GROUP_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleMarkCreatorResponseForGroupAlarmPendingAction(
            softPendingAction
          )
          break
        case Constants.MARK_PARTICIPANT_RESPONSE_FOR_GROUP_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleMarkParticipantResponseForGroupAlarmPendingAction(
            softPendingAction
          )
          break
        case Constants.UPDATE_RING_ON_EARPHONE_ONLY_SOFT_PENDING_ACTION_NAME:
          await handleAddUpdateRingOnEarphoneOnlySoftPendingAction(
            softPendingAction.ringOnEarphoneOnly
          )
          break
        case Constants.UPDATE_GESTURE_TO_DISMISS_AN_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleUpdateGestureToDismissAlarmSoftPendingAction(
            softPendingAction.gestureToDismissAnAlarm
          )
          break
        case Constants.UPDATE_NOTIFICATION_SETTINGS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateNotificationSettingsUserSettingsSoftPendingAction(
            softPendingAction.notificationSettings
          )
          break
        case Constants.ADD_UPDATE_SPECIFY_TIMEZONE_FOR_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleUpdateSpecifyTimezoneForAlarm(
            softPendingAction.specifyTimezoneForAlarm
          )
          break
        case Constants.ADD_UPDATE_DEFAULT_TIMEZONE_FOR_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleUpdateDefaultTimezoneForAlarm(
            softPendingAction.defaultTimezoneForAlarm
          )
          break
        case Constants.UPDATE_GRADUALLY_INCREASE_VOLUME_SOFT_PENDING_ACTION_NAME:
          await handleUpdateGraduallyIncreaseVolumeSoftPendingAction(
            softPendingAction.graduallyIncreaseVolume
          )
          break
        case Constants.UPDATE_SHAKE_TO_STOP_ALARM_SOFT_PENDING_ACTION_NAME:
          await handleUpdateShakeToStopAlarmSoftPendingAction(
            softPendingAction.shakeToStopAlarm
          )
          break
        case Constants.UPDATE_SHAKE_SENSITIVITY_SOFT_PENDING_ACTION_NAME:
          await handleUpdateShakeSensitivitySoftPendingAction(
            softPendingAction.shakeSensitivity
          )
          break
        case Constants.UPDATE_PIN_MODE_SOFT_PENDING_ACTION_NAME:
          await handleUpdatePinModeSoftPendingAction(softPendingAction.pinMode)
          break
        case Constants.UPDATE_NOTIFICATION_ACTION_BEHAVIOR_SOFT_PENDING_ACTION_NAME:
          await handleUpdateNotificationActionBehaviorSoftPendingAction(
            softPendingAction.notificationActionBehavior
          )
          break
        case Constants.UPDATE_PROMPT_FOR_UPDATE_SOFT_PENDING_ACTION_NAME:
          await handleUpdatePromptForUpdateSoftPendingAction(
            softPendingAction.promptForUpdate
          )
          break
        case Constants.UPDATE_SORT_ALARM_CATEGORIES_BY_SOFT_PENDING_ACTION_NAME:
          await handleUpdateSortAlarmCategoriesBySoftPendingAction(
            softPendingAction.sortAlarmCategoriesBy
          )
          break
        case Constants.UPDATE_MISSED_ALARMS_PLACEMENT_SETTINGS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateMissedAlarmPlacementSettingSoftPendingAction(
            softPendingAction.missedAlarmPlacementSetting
          )
          break
        case Constants.UPDATE_FAB_BUTTON_BEHAVIOR_SOFT_PENDING_ACTION_NAME:
          await handleUpdateFabButtonBehaviorSoftPendingAction(
            softPendingAction.fabButtonBehavior
          )
          break
        case Constants.UPDATE_MUTE_ALARMS_SOFT_PENDING_ACTION_NAME:
          await handleUpdateMuteAlarmsSoftPendingAction(
            softPendingAction.muteAlarms
          )
          break
        case Constants.UPDATE_PRE_REMINDER_RINGTONE_SOFT_PENDING_ACTION_NAME:
          await handleUpdatePreReminderRingtoneSoftPendingAction(
            softPendingAction.preReminderRingtone
          )
          break
        case Constants.UPDATE_TIMER_RINGTONE_SOFT_PENDING_ACTION_NAME:
          await handleUpdateTimerRingtoneSoftPendingAction(
            softPendingAction.timerRingtone
          )
          break
        default:
          LogUtils.logError(
            new Error('Unknown soft pending action ' + softPendingAction.name)
          )
      }
      dispatch(removeSoftPendingAction(softPendingAction.id))
    } catch (error) {
      // Same as above: don't drop on error, continue with remaining actions.
      LogUtils.logError(
        error,
        'Unable to handle soft pending action',
        softPendingAction
      )
      const MAX_RETRIES = 3
      const retryCount = (softPendingAction.retryCount || 0) + 1
      if (retryCount >= MAX_RETRIES) {
        await archiveAndDrop(softPendingAction, removeSoftPendingAction)
      } else {
        dispatch(updateSoftPendingActionRetryCount(softPendingAction.id))
      }
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.HANDLE_PENDING_ACTION,
      {
        [Constants.UserAnalyticsEventParameters.ACTION_NAME]:
          softPendingAction.name
      }
    )
  }
  return Promise.resolve()
}

const handleUpdateRecipientAlarmDateAndTimePendingAction = async (
  alarm,
  newRecipientDate,
  originalRecipientDate,
  currDate
) => {
  console.log('Handling update recipient alarm date and time pending action')
  await updateRecipientAlarmDateAndTimeCore(
    alarm,
    newRecipientDate,
    originalRecipientDate,
    currDate
  )
}

const handleAddAlarmToAlarmCategoryPendingAction = async pendingAction => {
  console.log('Handling add alarm to alarm category pending action')
  const { alarmCategoryId, alarmId } = pendingAction
  await AlarmUtils.addAlarmToAlarmCategory(alarmCategoryId, alarmId)
}

const handleRemoveAlarmFromAlarmCategoryPendingAction = async pendingAction => {
  console.log('Handling remove alarm from alarm category pending action')
  const { alarmCategoryId, alarmId } = pendingAction
  await AlarmUtils.removeAlarmFromAlarmCategory(alarmCategoryId, alarmId)
}

const handleDeleteAlarmCategoryPendingAction = async pendingAction => {
  console.log('Handling delete alarm category pending action')
  const { alarmCategoryId } = pendingAction
  await AlarmUtils.deleteAlarmCategory(alarmCategoryId)
}

const handleUpdateAlarmCategoryPendingAction = async pendingAction => {
  console.log('Handling update alarm category pending action')
  const { alarmCategoryId, alarmCategory } = pendingAction
  await AlarmUtils.updateAlarmCategory(alarmCategoryId, alarmCategory)
}

const handleCreateAlarmCategoryPendingAction = async pendingAction => {
  console.log('Handling create alarm category pending action')
  const { alarmCategoryId, alarmCategory } = pendingAction
  await AlarmUtils.createAlarmCategory(alarmCategoryId, alarmCategory)
}
const handleStartSnoozeForCreatorPendingAction = async pendingAction => {
  console.log('Handling start snooze for creator pending action')
  const { alarmId, snoozeInterval, snoozeDate } = pendingAction
  const firebaseUpdateObj = AlarmUtils.createFirebaseObjForSnoozingCreatorAlarm(
    alarmId,
    snoozeInterval,
    snoozeDate
  )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleStopSnoozeForCreatorPendingAction = async (
  alarmId,
  scheduledRemotely = false
) => {
  console.log('Handling stop snooze for creator pending action')

  if (scheduledRemotely) {
    console.log('Canceling remote snooze notification for alarm ' + alarmId)

    await TaskManager.addHttpsCloudTask('cancelSnoozeForAlarm', {
      uid: GlobalConfig.uid,
      alarmId: alarmId
    })
      .then(() => {
        console.log('Successfully canceled remote snooze notification')
      })
      .catch(error => {
        console.error('Error canceling remote snooze notification:', error)
      })
  } else {
    const firebaseUpdateObj =
      AlarmUtils.createFirebaseObjForStoppingSnoozeForCreatorAlarm(alarmId)
    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.rootFirebaseRef,
      firebaseUpdateObj
    )
  }
}

const handleStartSnoozeForParticipantPendingAction = async pendingAction => {
  console.log('Handling start snooze for participant pending action')
  const { alarm, snoozeInterval, snoozeDate } = pendingAction
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForSnoozingParticipantAlarm(
      alarm,
      snoozeInterval,
      snoozeDate
    )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleStopSnoozeForParticipantPendingAction = async alarm => {
  console.log('Handling stop snooze for participant pending action')
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForStoppingSnoozeForParticipantAlarm(alarm)
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleMarkPersonalAlarmDonePendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling mark personal alarm done pending action')
  await AlarmUtils.markAlarmAsAcknowledgedCore(alarm, occurrenceTime, timestamp)
}

const handleSkipPersonalAlarmPendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling skip personal alarm pending action')
  await AlarmUtils.skipPersonalAlarmCore(alarm, occurrenceTime, timestamp)
}

const handleSkipPersonalParticipantAlarmPendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling skip personal participant alarm pending action')
  await AlarmUtils.skipPersonalParticipantAlarmCore(
    alarm,
    occurrenceTime,
    timestamp
  )
}

const handleSkipRecipientAlarmPendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling skip recipient alarm pending action')
  await AlarmUtils.skipRecipientAlarmCore(alarm, occurrenceTime, timestamp)
}

const handleSkipRecipientCreatorAlarmPendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling skip recipient creator alarm pending action')
  await AlarmUtils.skipRecipientCreatorAlarmCore(
    alarm,
    occurrenceTime,
    timestamp
  )
}

const handleMarkRecipientAlarmDonePendingAction = async (
  alarm,
  occurrenceTime,
  timestamp
) => {
  console.log('Handling mark recipient alarm done pending action')
  await AlarmUtils.markRecipientAlarmAsDoneCore(
    alarm,
    occurrenceTime,
    timestamp
  )
}

const handleMarkCreatorResponseForGroupAlarmPendingAction =
  async actionData => {
    console.log('Handling mark creator response for group alarm pending action')
    const { alarm, response, rescheduleAlarm, occurrenceTime, timestamp } =
      actionData
    await AlarmUtils.markCreatorResponseForSimultaneousAlarmCore(
      alarm,
      occurrenceTime,
      timestamp,
      response,
      rescheduleAlarm
    )
  }

const handleMarkParticipantResponseForGroupAlarmPendingAction =
  async actionData => {
    console.log(
      'Handling mark participant response for group alarm pending action'
    )
    const {
      alarm,
      response,
      rescheduleAlarm,
      updateAlarmResponseStatus,
      occurrenceTime,
      timestamp
    } = actionData
    await AlarmUtils.markParticipantResponseForSimultaneousAlarmCore(
      alarm,
      occurrenceTime,
      timestamp,
      response,
      updateAlarmResponseStatus,
      rescheduleAlarm
    )
  }

const handleSetParticipantAlarmResponsePendingAction = async (
  alarm,
  participantResponse
) => {
  console.log('Handling set participant alarm response pending action')
  await AlarmUtils.setBackupResponseStatusForAlarmCore(
    alarm,
    alarm.responseStatus,
    participantResponse,
    alarm.order,
    true
  )
}

const handleSetRecipientAlarmResponsePendingAction = async (
  alarm,
  participantResponse
) => {
  console.log('Handling set participant alarm response pending action')
  await AlarmUtils.setRecipientResponseStatusForAlarmCore(
    alarm,
    participantResponse,
    true
  )
}

const handleSetPastAlarmOccurrenceResponsePendingAction = async (
  alarm,
  occurrenceTime,
  timestamp,
  response
) => {
  console.log('Handling set past alarm occurrence response pending action')
  await AlarmUtils.setPastAlarmOccurrenceResponse(
    alarm,
    occurrenceTime,
    timestamp,
    response
  )
}

const handleAddAlarmPendingAction = async alarm => {
  console.log('Handling add alarm pending action')
  const nextDate = AlarmUtils.getNextDateForAlarm(
    alarm.date,
    alarm.endDate,
    alarm.repeatType,
    alarm.repeat,
    alarm.creatorTimezone
  )

  const alarmToProcess =
    Date.now() > nextDate ? { ...alarm, status: false } : alarm

  await AlarmUtils.addAlarm(alarmToProcess)

  if (alarmToProcess.status) {
    sendRemoteNotificationsForNewAlarm(alarmToProcess)
  }
}

const handleDeleteAlarmPendingAction = async alarm => {
  console.log('Handling delete alarm pending action')
  await AlarmUtils.deleteAlarm(alarm)
}

const handleRemoveRemoteAlarmNotificationPendingAction = async alarmId => {
  console.log('Handling remove remote alarm notification pending action')
  // Call cloud function to cancel remote notification for the alarm
  await TaskManager.addHttpsCloudTask('cancelNotificationForAlarm', {
    uid: GlobalConfig.uid,
    alarmId: alarmId
  })
}

const handleEditAlarmPendingAction = async (
  editedAlarm,
  prevAlarm,
  removeSubscription = true,
  wipeAlarmActions = true
) => {
  console.log('Handling edit alarm pending action')
  const nextDate = AlarmUtils.getNextDateForAlarm(
    editedAlarm.date,
    editedAlarm.endDate,
    editedAlarm.repeatType,
    editedAlarm.repeat,
    editedAlarm.creatorTimezone
  )

  const alarmToProcess =
    Date.now() > nextDate ? { ...editedAlarm, status: false } : editedAlarm

  await AlarmUtils.editAlarm(
    alarmToProcess,
    prevAlarm,
    removeSubscription,
    wipeAlarmActions
  )

  if (alarmToProcess.status) {
    sendRemoteNotificationsForEditAlarm(alarmToProcess, prevAlarm)
  }
}

const handleAddChecklistPendingAction = checklist => {
  AlarmUtils.addChecklist(checklist)
}

const handleEditChecklistPendingAction = checklist => {
  AlarmUtils.editChecklist(checklist)
}

const handleRemoveChecklistPendingAction = checklistId => {
  AlarmUtils.removeChecklist(checklistId)
}

const handleEnableDisableAlarmPendingAction = async (
  alarm,
  timestamp,
  alarmStatus
) => {
  console.log('Handling enable/disable alarm pending action')
  await updateAlarmStatusCore(alarm, timestamp, alarmStatus)
}

const handleUpdateParticipantAlarmPreReminderDurationPendingAction = async (
  alarm,
  preReminderDuration
) => {
  console.log(
    'Handling update participant alarm pre-reminder duration pending action'
  )
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForUpdatingParticipantAlarmPreReminderDuration(
      alarm,
      preReminderDuration
    )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleUpdateParticipantAlarmRingerSettingsPendingAction = async (
  alarm,
  ringerSettings
) => {
  console.log(
    'Handling update participant alarm ringer settings pending action'
  )
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForUpdatingParticipantAlarmRingerSettings(
      alarm,
      ringerSettings
    )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleUpdateAlarmPreReminderPendingAction = async (
  alarm,
  ringerSettings
) => {
  console.log('Handling update alarm pre reminder pending action')
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForUpdatingAlarmPreReminderDuration(
      alarm,
      ringerSettings
    )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleUpdateAlarmRingerSettingsPendingAction = async (
  alarm,
  ringerSettings
) => {
  console.log('Handling update alarm ringer settings pending action')
  const firebaseUpdateObj =
    AlarmUtils.createFirebaseObjForUpdatingAlarmRingerSettings(
      alarm,
      ringerSettings
    )
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const handleUpdateGlobalAlarmRingerSettingsPendingAction =
  async ringerSettings => {
    console.log('Handling update global alarm ringer settings pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      ringerSettings
    )
  }

const handleUpdateRingParticipantAlarmsByDefaultSettingPendingAction =
  async ringParticipantAlarmsByDefault => {
    console.log(
      'Handling update ring participant alarms by default setting pending action'
    )

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { ringParticipantAlarmsByDefault }
    )
  }

const handleAddUpdateRingOnEarphoneOnlySoftPendingAction =
  async ringOnEarphoneOnly => {
    console.log('Handling update ring on earphones only setting pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { ringOnEarphoneOnly }
    )
  }

const handleUpdateGestureToDismissAlarmSoftPendingAction =
  async gestureToDismissAnAlarm => {
    console.log(
      'Handling update gesture to dismiss an alarm setting pending action'
    )

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { gestureToDismissAnAlarm }
    )
  }

const handleUpdateNotificationSettingsUserSettingsSoftPendingAction =
  async notificationSettings => {
    console.log('Handling update notification settings pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { notificationSettings }
    )
  }
const handleUpdateDefaultTimezoneForAlarm = async defaultTimezoneForAlarm => {
  console.log('Handling update default timezone for alarm pending action')

  await GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userSettings/${GlobalConfig.uid}/defaultTimezoneForAlarm`
    ),
    defaultTimezoneForAlarm
  )
}

const handleUpdateSpecifyTimezoneForAlarm = async specifyTimezoneForAlarm => {
  console.log('Handling update specify timezone for alarm pending action')

  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(`userSettings/${GlobalConfig.uid}`),
    { specifyTimezoneForAlarm }
  )

  if (!specifyTimezoneForAlarm) {
    await GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/defaultTimezoneForAlarm`
      ),
      ''
    )
  }
}

const handleUpdateGraduallyIncreaseVolumeSoftPendingAction =
  async graduallyIncreaseVolume => {
    console.log(
      'Handling update gradually increase volume setting pending action'
    )

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { graduallyIncreaseVolume }
    )
  }

const handleUpdateShakeToStopAlarmSoftPendingAction =
  async shakeToStopAlarm => {
    console.log('Handling update shake to stop alarm setting pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { shakeToStopAlarm }
    )
  }

const handleUpdateShakeSensitivitySoftPendingAction =
  async shakeSensitivity => {
    console.log('Handling update shake sensitivity setting pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { shakeSensitivity }
    )
  }

const handleUpdatePinModeSoftPendingAction = async pinMode => {
  console.log('Handling update pin mode setting pending action')
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(`userSettings/${GlobalConfig.uid}`),
    { pinMode }
  )
}

const handleUpdateNotificationActionBehaviorSoftPendingAction =
  async notificationActionBehavior => {
    console.log(
      'Handling update notification action behavior setting pending action'
    )

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { notificationActionBehavior }
    )
  }

const handleUpdatePromptForUpdateSoftPendingAction = async promptForUpdate => {
  console.log('Handling update prompt for update setting pending action')

  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(`userSettings/${GlobalConfig.uid}`),
    { promptForUpdate }
  )
}

const handleUpdateSortAlarmCategoriesBySoftPendingAction =
  async sortAlarmCategoriesBy => {
    console.log(
      'Handling update sort alarm categories by setting pending action'
    )

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { sortAlarmCategoriesBy }
    )
  }

const handleUpdateMissedAlarmPlacementSettingSoftPendingAction =
  async missedAlarmPlacementSetting => {
    console.log('Handling update missed alarm placement setting pending action')

    await GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}`
      ),
      { missedAlarmPlacementSetting }
    )
  }

const handleUpdateFabButtonBehaviorSoftPendingAction =
  async fabButtonBehavior => {
    console.log('Handling update fab button behavior setting pending action')

    await GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/fabButtonBehavior`
      ),
      fabButtonBehavior
    )
  }

const handleUpdateMuteAlarmsSoftPendingAction = async muteAlarms => {
  console.log('Handling update mute alarms setting pending action')

  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(`userSettings/${GlobalConfig.uid}`),
    { muteAlarms }
  )
}

const handleUpdatePreReminderRingtoneSoftPendingAction =
  async preReminderRingtone => {
    console.log('Handling update pre reminder ringtone setting pending action')

    await GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/preReminderRingtone`
      ),
      preReminderRingtone
    )
  }

const handleUpdateTimerRingtoneSoftPendingAction = async timerRingtone => {
  console.log('Handling update timer ringtone setting pending action')

  await GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userSettings/${GlobalConfig.uid}/timerRingtone`
    ),
    timerRingtone
  )
}

const sendRemoteNotificationsForNewAlarm = alarm => {
  const participants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
  const notificationKey =
    alarm.type === Constants.AlarmTypes.RECIPIENT
      ? Constants.NotificationKeys.AddedAsRecipientNotification
      : alarm.type === Constants.AlarmTypes.CASCADING
      ? Constants.NotificationKeys.AddedAsBackupNotification
      : Constants.NotificationKeys.AddedAsParticipantNotification
  participants.forEach(participant => {
    console.log(
      'Sending remote notification for new alarm to ' + participant.name
    )
    const notificationInfo = getNotificationInfoForBackupAlarmAdded(
      alarm,
      participant.order || 0
    )
    NotificationManager.sendRemoteNotification(
      participant.id,
      notificationKey,
      notificationInfo
    )
  })
}

const incrementShareableAlarmLinkCount = alarmType => (dispatch, getState) => {
  const linksCount = objGet(
    getState().userInfo,
    `shareableAlarmLinksCount.${alarmType}`,
    0
  )
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/shareableAlarmLinksCount/${alarmType}`
    ),
    linksCount + 1
  )
}

const incrementAlarmsSavedToCalendarCount = () => (dispatch, getState) => {
  const alarmsSavedToCalendarCount =
    getState().userInfo.alarmsSavedToCalendarCount
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alarmsSavedToCalendarCount`
    ),
    alarmsSavedToCalendarCount + 1
  )
}

const incrementInstantAlarmsCount = () => (dispatch, getState) => {
  const instantAlarmsCount = getState().userInfo.instantAlarmsCount
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/instantAlarmsCount`
    ),
    instantAlarmsCount + 1
  )
}

const incrementStopwatchesCount = () => (dispatch, getState) => {
  const stopwatchesCount = getState().userInfo.stopwatchesCount
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/stopwatchesCount`
    ),
    stopwatchesCount + 1
  )
}

const incrementTimersCount = () => (dispatch, getState) => {
  const timersCount = getState().userInfo.timersCount
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/timersCount`
    ),
    timersCount + 1
  )
}

const incrementOwnAlarmsCount =
  (alarmType, countType) => (dispatch, getState) => {
    const alarmsCount = objGet(
      getState().userInfo.alarmsCount,
      `ownAlarms.${alarmType}.${countType}`,
      0
    )
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/alarmsCount/ownAlarms/${alarmType}/${countType}`
      ),
      alarmsCount + 1
    )
  }

const addChecklist = checklist => (dispatch, getState) => {
  dispatch(addLocalChecklist(checklist, false))

  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    AlarmUtils.addChecklist(checklist)
  } else {
    dispatch(addAddChecklistPendingAction(checklist))
  }
}

const updateChecklist = checklist => (dispatch, getState) => {
  dispatch(updateLocalChecklist(checklist))

  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    AlarmUtils.editChecklist(checklist)
  } else {
    dispatch(addEditChecklistPendingAction(checklist))
  }
}

const removeChecklist = checklistId => (dispatch, getState) => {
  FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`checklists/${checklistId}`)
  )

  dispatch(removeLocalChecklist(checklistId))

  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    AlarmUtils.removeChecklist(checklistId)
  } else {
    dispatch(addRemoveChecklistPendingAction(checklistId))
  }
}

const toggleTaskInChecklist = (checklistId, itemId) => (dispatch, getState) => {
  const checklists = getState().alarms.checklists
  const checklist = checklists.find(c => c.id === checklistId)

  if (!checklist) {
    console.error('Checklist not found:', checklistId)
    return
  }

  const updatedItems = checklist.items.map(item => {
    if (item.id === itemId) {
      return { ...item, checked: !item.checked }
    }
    return item
  })

  const updatedChecklist = {
    ...checklist,
    items: updatedItems,
    lastUpdatedAt: Date.now()
  }

  dispatch(updateChecklist(updatedChecklist))
}

const removeTaskFromChecklist =
  (checklistId, itemId) => (dispatch, getState) => {
    const checklists = getState().alarms.checklists
    const checklist = checklists.find(c => c.id === checklistId)

    if (!checklist) {
      console.error('Checklist not found:', checklistId)
      return
    }

    const updatedItems = checklist.items.filter(item => item.id !== itemId)

    const updatedChecklist = {
      ...checklist,
      items: updatedItems,
      lastUpdatedAt: Date.now()
    }

    dispatch(updateChecklist(updatedChecklist))
  }

const updateTaskNameInChecklist =
  (checklistId, itemId, newName) => (dispatch, getState) => {
    const checklists = getState().alarms.checklists
    const checklist = checklists.find(c => c.id === checklistId)

    if (!checklist) {
      console.error('Checklist not found:', checklistId)
      return
    }

    const updatedItems = checklist.items.map(item => {
      if (item.id === itemId) {
        return { ...item, name: newName }
      }
      return item
    })

    const updatedChecklist = {
      ...checklist,
      items: updatedItems,
      lastUpdatedAt: Date.now()
    }

    dispatch(updateChecklist(updatedChecklist))
  }

const addAlarm = alarm => (dispatch, getState) => {
  // for debugging purposes
  // alarm.scheduledRemotely = true
  dispatch(addLocalAlarm(alarm))

  if (alarm.creationMode === Constants.AlarmCreationModes.INSTANT_ALARM) {
    dispatch(incrementInstantAlarmsCount())
  } else {
    dispatch(
      incrementOwnAlarmsCount(alarm.type, Constants.ALARMS_COUNT_TYPES.NEW)
    )
  }

  const shouldSchedule =
    alarm.status &&
    alarm.creationMode !== Constants.AlarmCreationModes.INSTANT_ALARM

  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    // Local alarms don't need to wait on the persist to complete before they can ring, so schedule
    // them right away instead of delaying on the alarm doc being written
    if (shouldSchedule && !alarm.scheduledRemotely) {
      scheduleLocalNotificationForOwnAlarm(alarm)
    }

    // Persist the alarm first - only once it exists in the database is it safe to schedule it
    // remotely, otherwise the cloud function can run before the alarm doc exists and fail with
    // "alarm not found".
    AlarmUtils.addAlarm(alarm)
      .then(() => {
        if (shouldSchedule && alarm.scheduledRemotely) {
          dispatch(scheduleNotificationForOwnAlarm(alarm))
        }
      })
      .catch(() => {
        // Couldn't persist the alarm, so it can't be scheduled remotely either - fall back to a
        // local notification and correct the scheduledRemotely flag. Local-only alarms are already
        // scheduled above, so there's nothing more to do for those here.
        if (shouldSchedule && alarm.scheduledRemotely) {
          dispatch(softUpdateLocalAlarm({ ...alarm, scheduledRemotely: false }))
          scheduleLocalNotificationForOwnAlarm(alarm)
        }
      })

    // Schedule a notification if alarm is enabled. If the alarm date is in past, the alarm status
    // will be disabled and no notification will be scheduled
    if (alarm.status) {
      sendRemoteNotificationsForNewAlarm(alarm)
    }
  } else {
    // We still want to schedule the local notification for the alarm such that the alarm rings on
    // the creator phone even if it has not been synced online. scheduleNotificationForOwnAlarm also
    // flips scheduledRemotely to false and queues a pending action to cancel the remote
    // notification once back online.
    dispatch(scheduleNotificationForOwnAlarm(alarm))
    dispatch(addAddAlarmPendingAction(alarm))
  }

  const numParticipants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  ).length
  const hasParticipants = numParticipants > 0

  var date = moment(alarm.date)
  var dayOfMonth = date.date()
  var dayOfMonthString = dayOfMonth.toString()

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.NEW_ALARM, {
    [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type,
    [Constants.UserAnalyticsEventParameters.HAS_PARTICIPANTS]:
      hasParticipants.toString(),
    [Constants.UserAnalyticsEventParameters.TIME_BETWEEN_PARTICIPANT_ALERTS]:
      alarm.cascadingAlarmInterval || 0,
    [Constants.UserAnalyticsEventParameters.REMIND_ME_AFTER]:
      alarm.recipientAlarmInterval || 0,
    [Constants.UserAnalyticsEventParameters.REPEAT_TYPE]:
      alarm.repeatType || Constants.RepeatTypes.NO_REPEAT,
    [Constants.UserAnalyticsEventParameters.DAY_OF_MONTH]: dayOfMonthString,
    [Constants.UserAnalyticsEventParameters.HAS_END_DATE]:
      (!!alarm.endDate).toString(),
    [Constants.UserAnalyticsEventParameters.ALARM_CREATION_SOURCE]:
      alarm.source,
    [Constants.UserAnalyticsEventParameters.HAS_PRE_REMINDER]:
      (!!alarm.preReminderDuration).toString()
  })

  if (hasParticipants) {
    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.NEW_ALARM_WITH_PARTICIPANTS,
      {
        [Constants.UserAnalyticsEventParameters.NUM_PARTICIPANTS]:
          numParticipants
      }
    )
  }
}

const sendRemoteNotificationsForEditAlarm = (editedAlarm, prevAlarm) => {
  // If time has has changed, send remote notification to all the backups in the alarm
  // and if user has also changed some backups as part of the edit, then send remote
  // notification to the no longer backups so that the scheduled local notifications
  // for those alarms can be cancelled
  // Else if user has not changed the time, then only send remote notifications to changed
  // backups if any
  if (editedAlarm.type !== Constants.AlarmTypes.RECIPIENT) {
    sendRemoteNotificationsToNewBackupsIfNeeded(editedAlarm, prevAlarm)
    sendRemoteNotificationsToNoLongerBackupsIfNeeded(editedAlarm, prevAlarm)
    sendRemoteNotificationsToExistingBackupsForChangesIfNeeded(
      editedAlarm,
      prevAlarm
    )
  } else if (editedAlarm.type === Constants.AlarmTypes.RECIPIENT) {
    if (editedAlarm.recipient.id !== prevAlarm.recipient.id) {
      const recipientNotificationInfo = getNotificationInfoForBackupAlarmAdded(
        editedAlarm,
        0,
        Constants.ParticipantTypes.CONTACT
      )
      NotificationManager.sendRemoteNotification(
        editedAlarm.recipient.id,
        Constants.NotificationKeys.AddedAsRecipientNotification,
        recipientNotificationInfo
      )

      const creatorNotificationInfo = {
        alarmId: editedAlarm.id,
        type: Constants.NotificationTypes.BACKUP_ALARM_REMOVED,
        alarmCreatorName: editedAlarm.creatorName,
        alarmName: prevAlarm.name
      }

      console.log(
        'Sending remote notification for no longer recipient to ' +
          prevAlarm.recipient.name
      )
      NotificationManager.sendRemoteNotification(
        prevAlarm.recipient.id,
        Constants.NotificationKeys.RemovedAsRecipientNotification,
        creatorNotificationInfo
      )
    } else {
      if (
        AlarmUtils.getNextDateForAlarm(
          editedAlarm.date,
          editedAlarm.endDate,
          editedAlarm.repeatType,
          editedAlarm.repeat,
          editedAlarm.creatorTimezone
        ) !==
          AlarmUtils.getNextDateForAlarm(
            prevAlarm.date,
            prevAlarm.endDate,
            prevAlarm.repeatType,
            prevAlarm.repeat,
            prevAlarm.creatorTimezone
          ) ||
        editedAlarm.repeatType !== prevAlarm.repeatType ||
        editedAlarm.repeat !== prevAlarm.repeat ||
        editedAlarm.recipientAlarmInterval !== prevAlarm.recipientAlarmInterval
      ) {
        const previousBackupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
          prevAlarm,
          prevAlarm.order
        )
        const newBackupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
          editedAlarm,
          editedAlarm.order
        )

        // Fail safe check to make sure that the time has actually changed for the participant
        if (previousBackupAlarmDate !== newBackupAlarmDate) {
          console.log(
            'Sending remote notification for time change to ' +
              editedAlarm.recipient.name
          )
          const notificationInfo = {
            alarmId: editedAlarm.id,
            type: Constants.NotificationTypes.BACKUP_ALARM_ADDED,
            alarmType: editedAlarm.type,
            alarmCreatorName: editedAlarm.creatorName,
            alarmName: editedAlarm.name,
            previousAlarmDate: previousBackupAlarmDate.toString(),
            newAlarmDate: newBackupAlarmDate.toString()
          }
          NotificationManager.sendRemoteNotification(
            editedAlarm.recipient.id,
            Constants.NotificationKeys.AlarmTimeChangedNotification,
            notificationInfo
          )
        }
      }

      if (editedAlarm.name !== prevAlarm.name) {
        console.log(
          'Sending remote notification for name change to ' +
            editedAlarm.recipient.name
        )

        const notificationInfo = {
          alarmId: editedAlarm.id,
          type: Constants.NotificationTypes.BACKUP_ALARM_NAME_CHANGED,
          alarmType: editedAlarm.type,
          alarmCreatorName: editedAlarm.creatorName,
          newAlarmName: editedAlarm.name,
          prevAlarmName: prevAlarm.name
        }
        NotificationManager.sendRemoteNotification(
          editedAlarm.recipient.id,
          Constants.NotificationKeys.AlarmNameChangedNotification,
          notificationInfo
        )
      }

      if (editedAlarm.notes !== prevAlarm.notes) {
        console.log(
          'Sending remote notification for notes change to ' +
            editedAlarm.recipient.name
        )

        const notificationInfo = {
          alarmId: editedAlarm.id,
          type: Constants.NotificationTypes.BACKUP_ALARM_NOTES_CHANGED,
          alarmType: editedAlarm.type,
          alarmCreatorName: editedAlarm.creatorName,
          alarmName: editedAlarm.name
        }
        NotificationManager.sendRemoteNotification(
          editedAlarm.recipient.id,
          Constants.NotificationKeys.AlarmNotesChangedNotification,
          notificationInfo
        )
      }
    }
  }

  if (prevAlarm.link && prevAlarm.link.subscribers) {
    const alarmEditedForSubscribers = AlarmUtils.isAlarmEditedForSubscribers(
      prevAlarm,
      editedAlarm
    )

    if (alarmEditedForSubscribers) {
      const alarmSubscribers = objGet(prevAlarm, 'link.subscribers', {})
      Object.keys(alarmSubscribers).forEach(alarmSubscriber => {
        const subscriberAlarmId = alarmSubscribers[alarmSubscriber]
        NotificationManager.sendRemoteNotification(
          alarmSubscriber,
          Constants.NotificationKeys.SubscribedAlarmEditedNotification,
          {
            type: Constants.NotificationTypes.SUBSCRIBED_ALARM_EDITED,
            subscriberAlarmId: subscriberAlarmId,
            alarmName: prevAlarm.name,
            alarmCreatorName: prevAlarm.creatorName
          }
        )
      })
    }
  }
}

// Find the intersection between the old and new members and send time change message to them
// Send new backup alarm message to the new members
const sendRemoteNotificationsToExistingBackupsForChangesIfNeeded = (
  editedAlarm,
  prevAlarm
) => {
  const currentParticipants = editedAlarm.backupGroup
    ? editedAlarm.backupGroup.members
    : editedAlarm.backupContacts
  const previousParticipants = prevAlarm.backupGroup
    ? prevAlarm.backupGroup.members
    : prevAlarm.backupContacts
  const commonParticipants = arrayIntersectionWith(
    currentParticipants,
    previousParticipants,
    (participant1, participant2) => {
      return participant1.id === participant2.id
    }
  )
  const filteredParticipants = commonParticipants.filter(participant => {
    return participant.responseStatus !== Constants.REJECT_ALARM
  })
  filteredParticipants.forEach(participant => {
    const previousParticipant = Utils.getObjectWithId(
      previousParticipants,
      participant.id
    )
    if (
      AlarmUtils.getNextDateForAlarm(
        editedAlarm.date,
        editedAlarm.endDate,
        editedAlarm.repeatType,
        editedAlarm.repeat,
        editedAlarm.creatorTimezone
      ) !==
        AlarmUtils.getNextDateForAlarm(
          prevAlarm.date,
          prevAlarm.endDate,
          prevAlarm.repeatType,
          prevAlarm.repeat,
          prevAlarm.creatorTimezone
        ) ||
      editedAlarm.repeatType !== prevAlarm.repeatType ||
      editedAlarm.repeat !== prevAlarm.repeat ||
      editedAlarm.cascadingAlarmInterval !== prevAlarm.cascadingAlarmInterval ||
      participant.order !== previousParticipant.order
    ) {
      const previousBackupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
        prevAlarm,
        previousParticipant.order
      )
      const newBackupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
        editedAlarm,
        participant.order
      )

      // Fail safe check to make sure that the time has actually changed for the participant
      if (previousBackupAlarmDate !== newBackupAlarmDate) {
        console.log(
          'Sending remote notification for time change to ' + participant.name
        )
        const notificationInfo = {
          alarmId: editedAlarm.id,
          type: Constants.NotificationTypes.BACKUP_ALARM_ADDED,
          alarmType: editedAlarm.type,
          alarmCreatorName: editedAlarm.creatorName,
          alarmName: editedAlarm.name,
          previousAlarmDate: previousBackupAlarmDate.toString(),
          newAlarmDate: newBackupAlarmDate.toString()
        }
        NotificationManager.sendRemoteNotification(
          participant.id,
          Constants.NotificationKeys.AlarmTimeChangedNotification,
          notificationInfo
        )
      }
    }

    if (editedAlarm.name !== prevAlarm.name) {
      console.log(
        'Sending remote notification for name change to ' + participant.name
      )

      const notificationInfo = {
        alarmId: editedAlarm.id,
        type: Constants.NotificationTypes.BACKUP_ALARM_NAME_CHANGED,
        alarmType: editedAlarm.type,
        alarmCreatorName: editedAlarm.creatorName,
        newAlarmName: editedAlarm.name,
        prevAlarmName: prevAlarm.name
      }
      NotificationManager.sendRemoteNotification(
        participant.id,
        Constants.NotificationKeys.AlarmNameChangedNotification,
        notificationInfo
      )
    }

    if (editedAlarm.notes !== prevAlarm.notes) {
      console.log(
        'Sending remote notification for notes change to ' + participant.name
      )

      const notificationInfo = {
        alarmId: editedAlarm.id,
        type: Constants.NotificationTypes.BACKUP_ALARM_NOTES_CHANGED,
        alarmType: editedAlarm.type,
        alarmCreatorName: editedAlarm.creatorName,
        alarmName: editedAlarm.name
      }
      NotificationManager.sendRemoteNotification(
        participant.id,
        Constants.NotificationKeys.AlarmNotesChangedNotification,
        notificationInfo
      )
    }
  })
}

const sendRemoteNotificationsToNewBackupsIfNeeded = (
  editedAlarm,
  prevAlarm
) => {
  let newParticipants

  if (!prevAlarm.backupGroup && editedAlarm.backupGroup) {
    newParticipants = editedAlarm.backupGroup.members
  } else if (
    prevAlarm.backupContacts &&
    editedAlarm.backupContacts &&
    prevAlarm.backupContacts.length === 0 &&
    editedAlarm.backupContacts.length > 0
  ) {
    newParticipants = editedAlarm.backupContacts
  } else {
    const currentParticipants = editedAlarm.backupGroup
      ? editedAlarm.backupGroup.members
      : editedAlarm.backupContacts
    const previousParticipants = prevAlarm.backupGroup
      ? prevAlarm.backupGroup.members
      : prevAlarm.backupContacts
    newParticipants = arrayDifferenceWith(
      currentParticipants,
      previousParticipants,
      (participant1, participant2) => {
        return participant1.id === participant2.id
      }
    )
  }

  newParticipants.forEach(participant => {
    const notificationInfo = getNotificationInfoForBackupAlarmAdded(
      editedAlarm,
      participant.order
    )
    console.log(
      'Sending remote notification for new participant to ' + participant.name
    )
    NotificationManager.sendRemoteNotification(
      participant.id,
      editedAlarm.type === Constants.AlarmTypes.CASCADING
        ? Constants.NotificationKeys.AddedAsBackupNotification
        : Constants.NotificationKeys.AddedAsParticipantNotification,
      notificationInfo
    )
  })
}

const getNotificationInfoForBackupAlarmAdded = (alarm, participantOrder) => {
  const backupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
    alarm,
    participantOrder
  )
  return {
    alarmId: alarm.id,
    type: Constants.NotificationTypes.BACKUP_ALARM_ADDED,
    alarmType: alarm.type,
    alarmCreatorName: alarm.creatorName,
    alarmName: alarm.name,
    alarmDate: backupAlarmDate.toString(),
    alarmCreationMode: alarm.creationMode
  }
}

const getNotificationInfoForParticipantAlarmEnabled = (
  alarm,
  participantOrder
) => {
  const backupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
    alarm,
    participantOrder
  )
  return {
    alarmId: alarm.id,
    type: Constants.NotificationTypes.PARTICIPANT_ALARM_ENABLED,
    alarmType: alarm.type,
    alarmCreatorName: alarm.creatorName,
    alarmName: alarm.name,
    alarmDate: backupAlarmDate.toString()
  }
}

const getNotificationInfoForParticipantAlarmDisabled = (
  alarm,
  participantOrder
) => {
  const backupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
    alarm,
    participantOrder
  )
  return {
    alarmId: alarm.id,
    type: Constants.NotificationTypes.PARTICIPANT_ALARM_DISABLED,
    alarmType: alarm.type,
    alarmCreatorName: alarm.creatorName,
    alarmName: alarm.name,
    alarmDate: backupAlarmDate.toString()
  }
}

const sendRemoteNotificationsToNoLongerBackupsIfNeeded = (
  editedAlarm,
  prevAlarm
) => {
  // Using prevAlarm.name here in case user has also changed the alarm name but the old
  // backups will still know the old name only
  const notificationInfo = {
    alarmId: editedAlarm.id,
    type: Constants.NotificationTypes.BACKUP_ALARM_REMOVED,
    alarmCreatorName: editedAlarm.creatorName,
    alarmName: prevAlarm.name
  }
  const currentParticipants = editedAlarm.backupGroup
    ? editedAlarm.backupGroup.members
    : editedAlarm.backupContacts
  const previousParticipants = prevAlarm.backupGroup
    ? prevAlarm.backupGroup.members
    : prevAlarm.backupContacts
  const noLongerParticipants = arrayDifferenceWith(
    previousParticipants,
    currentParticipants,
    (participant1, participant2) => {
      return participant1.id === participant2.id
    }
  )
  noLongerParticipants.forEach(participant => {
    console.log(
      'Sending remote notification for no longer participant to ' +
        participant.name
    )
    NotificationManager.sendRemoteNotification(
      participant.id,
      editedAlarm.type === Constants.AlarmTypes.CASCADING
        ? Constants.NotificationKeys.RemovedAsBackupNotification
        : Constants.NotificationKeys.RemovedAsParticipantNotification,
      notificationInfo
    )
  })
}

const editTimeAndRestoreAlarm = (alarmId, newDate) => (dispatch, getState) => {
  const recentlyDeletedAlarmsSelector = makeRecentlyDeletedAlarmSelector()
  const prevAlarm = recentlyDeletedAlarmsSelector(getState(), { alarmId })

  if (isEmpty(prevAlarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('alarmDoesntExist')
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'editTimeAndRestoreAlarm'
    })
    return
  }

  let alarmEndDate = GlobalConfig.defaultAlarmEndDate
  if (prevAlarm.endDate > newDate) {
    alarmEndDate = prevAlarm.endDate
  }

  const updatedAlarm = {
    ...prevAlarm,
    date: newDate,
    endDate: alarmEndDate
  }

  const participants = AlarmUtils.getAlarmParticipants(
    updatedAlarm.type,
    updatedAlarm.backupGroup,
    updatedAlarm.backupContacts,
    updatedAlarm.recipient
  )
  const filteredParticipants = participants.filter(participant => {
    return participant.responseStatus !== Constants.REJECT_ALARM
  })
  filteredParticipants.forEach(participant => {
    const notificationInfo = getNotificationInfoForBackupAlarmAdded(
      updatedAlarm,
      participant.order
    )
    const notificationKey = Constants.NotificationKeys.ADD_BACKUP_ALARM
    NotificationManager.sendRemoteNotification(
      participant.id,
      notificationKey,
      notificationInfo
    )
  })

  return AlarmUtils.restoreAlarm(updatedAlarm)
}

const editTimeAndEnableAlarm =
  (
    alarmId,
    newDate,
    resetParticipantResponses = true,
    wipeAlarmActions = true
  ) =>
  (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const prevAlarm = ownAlarmSelector(getState(), { alarmId })
    let backupGroup = prevAlarm.backupGroup || null
    let backupContacts = prevAlarm.backupContacts || []
    let recipient = prevAlarm.recipient || null

    if (isEmpty(prevAlarm)) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('alarmDoesntExist')
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'editTimeAndEnableAlarm'
      })
      return
    }

    if (!newDate) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('cantEnableAlarmNoValidNextDate')
      })
      return
    }

    // Resetting participant responses only makes sense when re-enabling a stale
    // alarm - not when simply advancing past an occurrence edited in place
    if (resetParticipantResponses) {
      if (prevAlarm.backupGroup && prevAlarm.backupGroup.members) {
        let members = prevAlarm.backupGroup.members.map(member => {
          return {
            ...member,
            responseStatus: Constants.ALARM_RESPONSE_PENDING,
            seenOn: null,
            deliveredOn: null
          }
        })
        backupGroup = {
          ...prevAlarm.backupGroup,
          members
        }
      } else if (
        prevAlarm.backupContacts &&
        prevAlarm.backupContacts.length > 0
      ) {
        backupContacts = prevAlarm.backupContacts.map(backupContact => {
          return {
            ...backupContact,
            responseStatus: Constants.ALARM_RESPONSE_PENDING,
            seenOn: null,
            deliveredOn: null
          }
        })
      } else if (prevAlarm.recipient) {
        recipient = {
          ...prevAlarm.recipient,
          responseStatus: Constants.ALARM_RESPONSE_PENDING,
          seenOn: null,
          deliveredOn: null
        }
      }
    }

    let alarmEndDate = GlobalConfig.defaultAlarmEndDate
    if (prevAlarm.endDate > newDate) {
      alarmEndDate = prevAlarm.endDate
    }

    const updatedAlarm = {
      ...prevAlarm,
      status: true,
      date: newDate,
      endDate: alarmEndDate,
      backupGroup,
      backupContacts,
      recipient,
      lastUpdatedAt: Date.now()
    }

    dispatch(editAlarm(updatedAlarm, false, wipeAlarmActions))
  }

const updateSubscriberAlarm = alarmId => (dispatch, getState) => {
  const ownAlarmSelector = makeOwnAlarmSelector()
  const alarm = ownAlarmSelector(getState(), { alarmId })

  const subscribedAlarmSystemAlertsSelector =
    makeSubscribedAlarmSystemAlertsSelector()
  const subscribedAlarmEditedSystemAlerts = subscribedAlarmSystemAlertsSelector(
    getState(),
    { alarmId }
  ).filter(alert => alert.type === Constants.AlertTypes.SUBSCRIBED_ALARM_EDITED)

  subscribedAlarmEditedSystemAlerts.forEach(alert =>
    dispatch(removeSystemAlert(alert.id))
  )

  if (isEmpty(alarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('alarmDoesntExist')
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'updateSubscriberAlarm'
    })
    return
  }

  const parentAlarmId = alarm.parentLink.alarmId

  if (!parentAlarmId) {
    LogUtils.logError(
      new Error("Can't update subscribed alarm"),
      'Parent alarm id not available',
      { parentAlarmId, alarmId: alarm.id }
    )
    return
  }

  AlarmUtils.retrieveAlarmByAlarmId(parentAlarmId, false).then(parentAlarm => {
    // If the parent link is created relative to the timezone, then convert the time to user's timezone first
    const relativeTimezone = objGet(parentAlarm, 'link.relativeTimezone', false)
    let alarmDate = parentAlarm.date
    if (relativeTimezone) {
      alarmDate = DateTimeUtils.getDateFromFormattedDateString(
        parentAlarm.dateString,
        RNLocalize.getTimeZone()
      )
    }
    const currDate = Date.now()
    const editedAlarm = {
      id: alarmId,
      name: parentAlarm.name,
      date: alarmDate,
      dateString: parentAlarm.dateString,
      status: alarm.status,
      creator: alarm.creator,
      creatorName: alarm.creatorName,
      creatorMobileNumber: alarm.creatorMobileNumber,
      creatorTimezoneOffset: alarm.creatorTimezoneOffset,
      timezoneSetting:
        alarm.timezoneSetting || Constants.TIMEZONE_SETTINGS.DEVICE,
      preReminderDuration:
        alarm.preReminderDuration || GlobalConfig.defaultPreReminderDuration,
      creatorTimezone: alarm.creatorTimezone,
      notes: parentAlarm.notes,
      repeat: parentAlarm.repeat,
      repeatType: parentAlarm.repeatType,
      type: parentAlarm.type,
      cascadingAlarmInterval: parentAlarm.cascadingAlarmInterval || null,
      recipientAlarmInterval: parentAlarm.recipientAlarmInterval || null,
      backupGroup: alarm.backupGroup || null,
      backupContacts: alarm.backupContacts || [],
      lastUpdatedAt: currDate,
      recipient: alarm.recipient || null,
      historyStartDate: currDate,
      release: GlobalConfig.release,
      ringerSettings: alarm.ringerSettings,
      creationMode: alarm.creationMode,
      endDate: parentAlarm.endDate || GlobalConfig.defaultAlarmEndDate,
      source: alarm.source,
      link: null,
      parentLink: alarm.parentLink
    }

    dispatch(editAlarm(editedAlarm, false))
  })
}

// eslint-disable-next-line no-unused-vars
const deleteSubscriberAlarm = alarmId => (dispatch, getState) => {
  // Just a wrapper over delete alarm for now. Keeping a separate function in case
  // more functionality is needed later on.

  // System alerts for this alarm are removed in deleteAlarm as user may
  // delete the alarm from the delete icon also.
  dispatch(deleteAlarm(alarmId))
}

const removeSubscribedAlarmSystemAlerts = alarmId => (dispatch, getState) => {
  const subscribedAlarmSystemAlertsSelector =
    makeSubscribedAlarmSystemAlertsSelector()
  const subscribedAlarmSystemAlerts = subscribedAlarmSystemAlertsSelector(
    getState(),
    { alarmId }
  )

  subscribedAlarmSystemAlerts.forEach(alert =>
    dispatch(removeSystemAlert(alert.id))
  )
}

// Deleting alarm history is same as moving the alarm to current date
const deleteAlarmHistory = alarmId => (dispatch, getState) => {
  const ownAlarmSelector = makeOwnAlarmSelector()
  const prevAlarm = ownAlarmSelector(getState(), { alarmId })

  if (isEmpty(prevAlarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('alarmDoesntExist')
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'deleteAlarmHistory'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(prevAlarm)
  const currDate = Date.now()

  const updatedAlarm = {
    ...prevAlarm,
    date: currAlarmDate,
    firstAlarmDate: currAlarmDate,
    historyStartDate: currDate,
    lastUpdatedAt: currDate
  }

  dispatch(editAlarm(updatedAlarm, false))
}

const editAlarm =
  (editedAlarm, removeSubscription = true, wipeAlarmActions = true) =>
  (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const prevAlarm = ownAlarmSelector(getState(), { alarmId: editedAlarm.id })
    dispatch(updateLocalAlarm(editedAlarm))
    dispatch(
      incrementOwnAlarmsCount(
        editedAlarm.type,
        Constants.ALARMS_COUNT_TYPES.EDIT
      )
    )

    // Remove all the pending system alerts for this alarm
    const subscribedAlarmSystemAlertsSelector =
      makeSubscribedAlarmSystemAlertsSelector()
    const subscribedAlarmSystemAlerts = subscribedAlarmSystemAlertsSelector(
      getState(),
      { alarmId: editedAlarm.id }
    )

    subscribedAlarmSystemAlerts.forEach(alert =>
      dispatch(removeSystemAlert(alert.id))
    )

    const shouldSchedule =
      editedAlarm.status &&
      editedAlarm.creationMode !== Constants.AlarmCreationModes.INSTANT_ALARM

    if (
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    ) {
      // Local alarms don't need to wait on the edit to persist before they can ring, so schedule
      // them right away instead of delaying on the alarm doc being written
      if (shouldSchedule && !editedAlarm.scheduledRemotely) {
        scheduleLocalNotificationForOwnAlarm(editedAlarm, true)
      }

      // Persist the edit first - only once it lands is it safe to schedule the alarm remotely,
      // otherwise the cloud function can read the stale, pre-edit data (e.g. the old time) and
      // schedule the notification incorrectly.
      AlarmUtils.editAlarm(
        editedAlarm,
        prevAlarm,
        removeSubscription,
        wipeAlarmActions
      )
        .then(() => {
          if (shouldSchedule && editedAlarm.scheduledRemotely) {
            dispatch(scheduleNotificationForOwnAlarm(editedAlarm, true))
          }
        })
        .catch(() => {
          // Couldn't persist the edit, so it can't be scheduled remotely either - fall back to a
          // local notification and correct the scheduledRemotely flag. Local-only alarms are
          // already scheduled above, so there's nothing more to do for those here.
          if (shouldSchedule && editedAlarm.scheduledRemotely) {
            AlarmUtils.cancelRemoteNotificationForAlarm(editedAlarm.id)
            scheduleLocalNotificationForOwnAlarm(editedAlarm, true)
          }
        })

      // Schedule a notification if alarm is enabled. If the alarm date is in past, the alarm status
      // will be disabled and no notification will be scheduled
      if (editedAlarm.status) {
        sendRemoteNotificationsForEditAlarm(editedAlarm, prevAlarm)
      }
    } else {
      // We still want to schedule the local notification for the alarm such that the alarm rings on
      // the creator phone even if it has not been synced online. scheduleNotificationForOwnAlarm
      // also flips scheduledRemotely to false and queues a pending action to cancel the remote
      // notification once back online.
      dispatch(scheduleNotificationForOwnAlarm(editedAlarm, true))
      dispatch(
        addEditAlarmPendingAction(
          editedAlarm,
          prevAlarm,
          removeSubscription,
          wipeAlarmActions
        )
      )
    }

    const hasParticipants =
      AlarmUtils.getAlarmParticipants(
        editedAlarm.type,
        editedAlarm.backupGroup,
        editedAlarm.backupContacts,
        editedAlarm.recipient
      ).length > 0

    var date = moment(editedAlarm.date)
    var dayOfMonth = date.date()
    var dayOfMonthString = dayOfMonth.toString()
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.EDIT_ALARM, {
      [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: editedAlarm.type,
      [Constants.UserAnalyticsEventParameters.HAS_PARTICIPANTS]:
        hasParticipants.toString(),
      [Constants.UserAnalyticsEventParameters.TIME_BETWEEN_PARTICIPANT_ALERTS]:
        editedAlarm.cascadingAlarmInterval || 0,
      [Constants.UserAnalyticsEventParameters.REMIND_ME_AFTER]:
        editedAlarm.recipientAlarmInterval || 0,
      [Constants.UserAnalyticsEventParameters.REPEAT_TYPE]:
        editedAlarm.repeatType || Constants.RepeatTypes.NO_REPEAT,
      [Constants.UserAnalyticsEventParameters.DAY_OF_MONTH]: dayOfMonthString,
      [Constants.UserAnalyticsEventParameters.HAS_PRE_REMINDER]:
        (!!editedAlarm.preReminderDuration).toString()
    })
  }

const restoreAlarm = alarmId => (dispatch, getState) => {
  const recentlyDeletedAlarmsSelector = makeRecentlyDeletedAlarmSelector()
  const alarm = recentlyDeletedAlarmsSelector(getState(), { alarmId })
  const participants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
  const filteredParticipants = participants.filter(participant => {
    return participant.responseStatus !== Constants.REJECT_ALARM
  })
  filteredParticipants.forEach(participant => {
    const notificationInfo = getNotificationInfoForBackupAlarmAdded(
      alarm,
      participant.order
    )

    const notificationKey = Constants.NotificationKeys.ADD_BACKUP_ALARM
    NotificationManager.sendRemoteNotification(
      participant.id,
      notificationKey,
      notificationInfo
    )
  })
  return AlarmUtils.restoreAlarm(alarm)
}

const updateAlarmStatus = (alarmId, alarmStatus) => (dispatch, getState) => {
  const ownAlarmSelector = makeOwnAlarmSelector()
  const alarm = ownAlarmSelector(getState(), { alarmId })
  const updatedAlarm = {
    ...alarm,
    status: alarmStatus
  }
  const currDate = Date.now()
  dispatch(updateLocalAlarm(updatedAlarm))
  dispatch(addAlarmStatusChangeAction(alarm.id, currDate, alarmStatus))
  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    updateAlarmStatusCore(alarm, currDate, alarmStatus)
  } else {
    dispatch(addEnableDisableAlarmPendingAction(alarm, currDate, alarmStatus))
  }

  if (alarmStatus) {
    dispatch(scheduleNotificationForOwnAlarm(updatedAlarm))
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_ENABLED, {})
  } else {
    dispatch(
      cancelNotificationsForAlarm(alarmId, updatedAlarm.scheduledRemotely)
    )
    NavigationUtils.showTransientAlert({
      message: I18n.t('disabledAlarm', { name: alarm.name }),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_DISABLED, {})
  }
}

const updateAlarmStatusCore = (alarm, timestamp, alarmStatus) => {
  const participants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
  const filteredParticipants = participants.filter(participant => {
    return participant.responseStatus !== Constants.REJECT_ALARM
  })
  filteredParticipants.forEach(participant => {
    const notificationInfo = alarmStatus
      ? getNotificationInfoForParticipantAlarmEnabled(alarm, participant.order)
      : getNotificationInfoForParticipantAlarmDisabled(alarm, participant.order)
    const notificationKey = alarmStatus
      ? Constants.NotificationKeys.ParticipantAlarmEnabled
      : Constants.NotificationKeys.ParticipantAlarmDisabled
    NotificationManager.sendRemoteNotification(
      participant.id,
      notificationKey,
      notificationInfo
    )
  })

  let firebaseUpdateObj = {}
  const responseId = GlobalConfig.firebaseHelpers.generatePushKey(
    GlobalConfig.rootFirebaseRef
  )
  firebaseUpdateObj['alarms/' + alarm.id + '/status'] = alarmStatus
  firebaseUpdateObj[
    'alarmActions/' +
      alarm.id +
      '/alarmStatusChanges/' +
      responseId +
      '/timestamp'
  ] = timestamp
  firebaseUpdateObj[
    'alarmActions/' + alarm.id + '/alarmStatusChanges/' + responseId + '/status'
  ] = alarmStatus
  firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = Date.now()
  return GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )
}

const removeMetadataForAlarm = alarmId => {
  // We maintain how many times an alarm has been snoozed on Android
  // native side to support the auto-snooze configuration. When the
  // alarm is deleted, that data can be deleted as well for this alarm
  AlarmManager.removeMetadataForAlarm(alarmId)

  // Remove the current date mapping for alarm if any
  AlarmUtils.removeAlarmIdFromAlarmDatesMap(alarmId)
}

const deleteAlarm = alarmId => (dispatch, getState) => {
  const ownAlarmSelector = makeAllOwnAlarmSelector()
  const alarm = ownAlarmSelector(getState(), { alarmId })
  // Cancel the local notification for the alarm on the device
  // We don't send remote notifications to the backups for the alarm
  // deletion to minimize the number of remote notifications received
  // by a backup
  dispatch(cancelNotificationsForAlarm(alarmId, alarm.scheduledRemotely))

  // Remove the event handlers once the alarm is deleted
  FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
  )
  FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`)
  )

  removeMetadataForAlarm(alarmId)

  if (isEmpty(alarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToDeleteAlarm'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'deleteAlarm'
    })
    return
  }

  if (alarm.parentLink) {
    dispatch(removeSubscribedAlarmSystemAlerts(alarmId))
  }

  dispatch(removeLocalAlarm(alarmId))

  const alarmCategoryForAlarmSelector = makeAlarmCategoryForAlarmIdSelector()
  const alarmCategory = alarmCategoryForAlarmSelector(getState(), {
    alarmId: alarm.id
  })
  if (alarmCategory.id !== Constants.UNCATEGORIZED_ALARM_CATEGORY_ID) {
    dispatch(removeAlarmFromAlarmCategory(alarmCategory.id, alarmId))
  }

  if (
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  ) {
    AlarmUtils.deleteAlarm(alarm)
  } else {
    dispatch(addDeleteAlarmPendingAction(alarm))
  }

  // Don't show the alert on web as we use local storage on web and it can
  // be easily cleared leading to the alert being shown again and again
  if (
    Platform.OS !== 'web' &&
    alarm.creationMode !== Constants.AlarmCreationModes.QUICK_ALARM &&
    alarm.source !== Constants.AlarmCreationSources.CREATED_FROM_TASK_LIST &&
    alarm.source !== Constants.AlarmCreationSources.CREATED_FROM_TASK
  ) {
    GlobalConfig.firebaseHelpers
      .getData(
        GlobalConfig.firebaseHelpers.createRef(
          `userInfos/${GlobalConfig.uid}/restoreDeletedAlarmsAlertShown`
        )
      )
      .then(snapshot => {
        if (!snapshot.exists()) {
          NavigationUtils.showAlert(
            I18n.t('restoreDeletedAlarms'),
            I18n.t('deleteAlarmAlert')
          )
          GlobalConfig.firebaseHelpers.updateData(
            GlobalConfig.firebaseHelpers.createRef(
              `userInfos/${GlobalConfig.uid}`
            ),
            { restoreDeletedAlarmsAlertShown: true }
          )
        }
      })
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.DELETE_ALARM, {
    [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type,
    [Constants.UserAnalyticsEventParameters.REPEAT_TYPE]: alarm.repeatType
      ? alarm.repeatType
      : Constants.RepeatTypes.NO_REPEAT
  })
}

const deleteAllAlarms = (alarmIds, source) => (dispatch, getState) => {
  // Remove the event handlers once the alarm is deleted
  alarmIds.forEach(alarmId => {
    FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
      'App',
      GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
    )
    FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
      'App',
      GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`)
    )
    const ownAlarmSelector = makeAllOwnAlarmSelector()
    const alarm = ownAlarmSelector(getState(), { alarmId })
    dispatch(cancelNotificationsForAlarm(alarmId, alarm.scheduledRemotely))
    removeMetadataForAlarm(alarmId)
  })

  const alarms = objCompact(
    alarmIds.map(alarmId =>
      getState().alarms.alarms.find(alarm => alarm.id === alarmId)
    )
  )

  dispatch(removeLocalAlarms(alarmIds))
  AlarmUtils.deleteAllAlarms(alarms)
  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.DELETE_ALL_ALARMS, {
    [Constants.UserAnalyticsEventParameters.SOURCE]: source
  })
}

// eslint-disable-next-line no-unused-vars
const loadAppData = () => (dispatch, getState) => {
  dispatch(loadLocalUserSettings())
  dispatch(loadUserSettings())
  dispatch(loadAlarms())
  dispatch(loadBackupAlarms())
  dispatch(loadIncidentAlarms())
  dispatch(loadChecklists())
  dispatch(loadRecentlyDeletedAlarms())
  dispatch(loadContacts())
  dispatch(loadConnections())
  dispatch(loadGroups())
  dispatch(removeDeletedParticipantAlarms())
  // dispatch(removeDeletedOwnAlarms())
  dispatch(loadUserInfo())
  dispatch(loadAlerts())
}

// eslint-disable-next-line no-unused-vars
const unloadAppData = () => (dispatch, getState) => {
  FirebaseManager.unbindFirebaseEventHandlers('App')
  FirebaseManager.unbindFirebaseEventHandlers('Conversation')
  FirestoreManager.unsubscribeAllListeners()
}

let existingAlarmsLoaded = false
let batchedExistingAlarmsUpdates = []
let batchedExistingAlarmsAcknowledgements = []
let batchedExistingAlarmsStatusChanges = []
let firebaseUpdateForUpdatingAlarmPreReminderDuration = {}

const loadAlarm = (alarmId, dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`),
    snapshot => {
      // alarmData will be null when an alarm is deleted. So put console.log with a check
      const alarmData = snapshot.val()

      const ownAlarmSelector = makeAllOwnAlarmSelector()
      const existingAlarm = ownAlarmSelector(getState(), { alarmId })
      const deviceOs = getState().userInfo.deviceOs

      // This code is also present in loadAlarms, keep in sync
      if (alarmData === null || alarmData.isDeleted) {
        if (!isEmpty(existingAlarm)) {
          // Local delete and cancel notification
          dispatch(removeLocalAlarm(alarmId))
          dispatch(
            cancelNotificationsForAlarm(
              alarmId,
              existingAlarm.scheduledRemotely
            )
          )
        }
        return
      }

      const alarm = AlarmUtils.createAlarm(alarmData)

      if (alarm === undefined) {
        return
      }

      // Disable remote scheduling on non-iOS platforms
      // Remote scheduling is only supported on iOS due to notification limits
      if (deviceOs !== 'ios') {
        console.log(
          `Disabling remote scheduling for alarm ${alarm.id} on device OS ${deviceOs}`
        )
        alarm.scheduledRemotely = false
      }

      // Schedule the alarm every time. This is to counteract the
      // autostart setting on Android phones to at least have all the alarm scheduled
      // if the app has been open. Also sometimes, the alarm may be imported as part
      // of some notification action or remote fetch in which case the alarm may not
      // be properly rescheduled
      dispatch(scheduleNotificationForOwnAlarm(alarm))

      // If there has been no change to the alarm, then skip it
      if (
        !isEmpty(existingAlarm) &&
        existingAlarm.persistedOnline !== false &&
        (!alarm.lastUpdatedAt ||
          alarm.lastUpdatedAt === existingAlarm.lastUpdatedAt)
      ) {
        return
      }

      // Add the alarm to the redux store if all the existing alarms have already been added
      // Existing alarms are added in one pass over all the alarms
      if (existingAlarmsLoaded) {
        dispatch(updateAlarm(alarmId, alarm))
      } else {
        batchedExistingAlarmsUpdates.push(alarm)
        // If the alarm doesn't have a preReminder duration defined,
        // add the default one. This is added in release 7.1.0
        // to migrate existing alarms.
        if (
          !Object.prototype.hasOwnProperty.call(alarm, 'preReminderDuration') ||
          typeof alarm.preReminderDuration !== 'number'
        ) {
          firebaseUpdateForUpdatingAlarmPreReminderDuration[
            'alarms/' + alarm.id + '/preReminderDuration'
          ] = GlobalConfig.defaultPreReminderDuration
          firebaseUpdateForUpdatingAlarmPreReminderDuration[
            'alarms/' + alarm.id + '/lastUpdatedAt'
          ] = Date.now()
        }
      }
    }
  )

  dispatch(loadAlarmActions(alarmId))

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/unseenMessages/${alarmId}/${GlobalConfig.uid}`
    ),
    snapshot => {
      const currentScreen = getState().appState.currentScreen
      const unseenMessages = snapshot.val() || 0
      const currentUnseenMessagesForAlarm = objGet(
        getState().conversations.alarms,
        `[${alarmId}].unseenMessages`,
        0
      )
      if (currentUnseenMessagesForAlarm !== unseenMessages) {
        dispatch(updateUnseenMessagesForAlarm(alarmId, unseenMessages))
      }
      if (
        unseenMessages &&
        currentScreen === 'AlarmConversationScreen' + alarmId
      ) {
        dispatch(resetUnseenMessagesForAlarm(alarmId))
      }
    }
  )
}

// Load all the existing alarms and future updates to the alarms
const loadAlarms = () => (dispatch, getState) => {
  // Reset all module-level batch state before beginning a new load.
  // These variables persist across calls (module scope). If loadAlarms is
  // called again without an app restart — any leftover data from the previous
  // session would be merged into the new session's Redux store, causing
  // duplicate or stale alarm dispatches.
  existingAlarmsLoaded = false
  batchedExistingAlarmsUpdates = []
  batchedExistingAlarmsAcknowledgements = []
  batchedExistingAlarmsStatusChanges = []
  firebaseUpdateForUpdatingAlarmPreReminderDuration = {}

  const uid = GlobalConfig.uid

  // Process all the alarms and setup notifications. Only the new alarms are added to redux
  // store in this event handler. All the existing ones are added in one pass in the below
  // event handler
  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`userInfos/${uid}/alarms`),
    snapshot => {
      const alarmId = snapshot.key
      loadAlarm(alarmId, dispatch, getState)
    }
  )

  // Load all the existing alarms to the redux store in one pass to improve performance
  GlobalConfig.firebaseHelpers
    .getData(GlobalConfig.firebaseHelpers.createRef(`userInfos/${uid}/alarms`))
    .then(alarmsSnapshot => {
      if (!alarmsSnapshot.exists()) {
        return Promise.resolve([])
      }
      const promises = []
      alarmsSnapshot.forEach(alarmSnapshot => {
        const alarmId = alarmSnapshot.key
        promises.push(
          GlobalConfig.firebaseHelpers.getData(
            GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
          )
        )
      })
      return Promise.all(promises)
    })
    // eslint-disable-next-line no-unused-vars
    .then(alarmSnapshots => {
      existingAlarmsLoaded = true
      dispatch(
        batchActions(
          updateAlarms(batchedExistingAlarmsUpdates),
          updateAlarmsAcknowledgements(batchedExistingAlarmsAcknowledgements),
          updateAlarmsStatusChanges(batchedExistingAlarmsStatusChanges)
        )
      )

      dispatch(handleExistingAlarmsLoaded())

      dispatch(
        rescheduleAlarmsBasedOnLatestAcknowledgementData(
          Object.keys(batchedExistingAlarmsAcknowledgements)
        )
      )

      batchedExistingAlarmsUpdates = []
      batchedExistingAlarmsAcknowledgements = []
      batchedExistingAlarmsStatusChanges = []

      if (!isEmpty(firebaseUpdateForUpdatingAlarmPreReminderDuration)) {
        GlobalConfig.firebaseHelpers.updateData(
          GlobalConfig.rootFirebaseRef,
          firebaseUpdateForUpdatingAlarmPreReminderDuration
        )
        firebaseUpdateForUpdatingAlarmPreReminderDuration = {}
      }
    })
    .catch(error =>
      LogUtils.logError(error, 'Unable to retrieve alarms from database')
    )
}

// eslint-disable-next-line no-unused-vars
const loadIncidentAlarms = () => (dispatch, getState) => {
  const uid = GlobalConfig.uid

  FirestoreManager.listenToIncidentAlarmsForUser(
    `userInfos/${uid}/incidentAlarms`,
    uid,
    snapshot => {
      console.log('Found incident alarms on Firestore', snapshot.size)
      snapshot.docChanges().forEach(change => {
        console.log('Incident alarms change type', change.type)
        if (change.type === 'added') {
          const alarmData = change.doc.data()
          const alarm = AlarmUtils.createAlarmFromFirestoreData(alarmData)
          dispatch(addIncidentAlarm(alarm))
          dispatch(loadAlarmActions(alarm.id))
        } else if (change.type === 'modified') {
          const alarmData = change.doc.data()
          const alarm = AlarmUtils.createAlarmFromFirestoreData(alarmData)
          dispatch(addIncidentAlarm(alarm))
        } else if (change.type === 'removed') {
          const alarmId = change.doc.id
          dispatch(removeIncidentAlarm(alarmId))
          FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
            'App',
            GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`)
          )
        }
      })
    }
  )
}

const updateAlarmAcknowledgementsAndRescheduleAlarm =
  (alarmId, alarmAcknowledgements, cancelSnoozeAlarm = false) =>
  dispatch => {
    dispatch(addAlarmAcknowledgements(alarmId, alarmAcknowledgements))
    dispatch(
      rescheduleAlarmBasedOnLatestAcknowledgementData(
        alarmId,
        cancelSnoozeAlarm
      )
    )
  }

const rescheduleAlarmsBasedOnLatestAcknowledgementData =
  alarmIds =>
  (
    dispatch,
    getState // eslint-disable-line no-unused-vars
  ) => {
    alarmIds.forEach(alarmId => {
      dispatch(rescheduleAlarmBasedOnLatestAcknowledgementData(alarmId))
    })
  }

const rescheduleAlarmBasedOnLatestAcknowledgementData =
  (alarmId, cancelSnoozeAlarm = false) =>
  (dispatch, getState) => {
    return AlarmUtils.retrieveAlarmByAlarmId(alarmId, true).then(alarm => {
      if (!alarm) {
        FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
          [Constants.UserAnalyticsEventParameters.SOURCE]:
            'rescheduleAlarmBasedOnLatestAcknowledgementData'
        })
        return
      }

      if (alarm.creator === GlobalConfig.uid) {
        dispatch(scheduleNotificationForOwnAlarm(alarm, cancelSnoozeAlarm))
      } else {
        scheduleNotificationForParticipantAlarm(
          alarm,
          getState().contacts.contacts,
          cancelSnoozeAlarm
        )
      }
    })
  }

// Helper function to schedule local notification
const scheduleLocalNotificationForOwnAlarm = (
  alarm,
  cancelSnoozeAlarm = false
) => {
  const nextAlarmRingDate = AlarmUtils.getNextRingDateForAlarm(alarm)
  const alarmDate = DateTimeUtils.getMyAlarmDate(nextAlarmRingDate)
  const alarmAlert = AlarmUtils.getMyAlarmNotificationAlertMessage(
    alarm.type,
    alarm.name,
    objGet(alarm, 'recipient.name', '')
  )
  const notificationInfo = AlarmUtils.getMyAlarmNotificationInfo(
    alarm,
    alarmDate
  )

  console.log(
    'Scheduling local notification for own alarm ' +
      alarm.id +
      ' at ' +
      DateTimeUtils.getDateTimeAsString(alarmDate)
  )

  AlarmManager.scheduleNotification(
    alarmDate,
    alarm.endDate,
    alarm.repeatType,
    alarm.repeat,
    alarm.creatorTimezone,
    alarmAlert,
    notificationInfo,
    cancelSnoozeAlarm,
    false
  )

  // This is to handle schedule existing alarms such that snoozing alarms
  // are also rescheduled
  // if (AlarmUtils.isLastSnoozeTimeInSnoozeDurationForMyAlarm(alarm)) {
  //   // Use the previous alarm date for the snooze notification else it will
  //   // create problems when a repeating alarm that is currently snoozing is
  //   // marked done. It will fetch the next date as the current date for the
  //   // alarm for which we would have no acknowledgement and hence end up
  //   // scheduling a snooze notification incorrectly.
  //   const prevAlarmDate = AlarmUtils.getPrevDateForAlarm(
  //     alarm.date,
  //     alarm.endDate,
  //     alarm.repeatType,
  //     alarm.repeat,
  //     alarm.creatorTimezone
  //   )

  //   // Check if the previous occurrence was acknowledged
  //   const prevOccurrenceAcknowledgement =
  //     AlarmUtils.getAlarmAcknowledgementStatusForOccurrenceForAlarm(
  //       alarm,
  //       prevAlarmDate
  //     )

  //   // If alarm was snoozed and prev occurrence was not acknowledged, schedule the snooze notification
  //   if (!prevOccurrenceAcknowledgement) {
  //     const snoozeNotificationInfo = {
  //       ...notificationInfo,
  //       alarmDate: prevAlarmDate
  //     }
  //     const snoozeDate =
  //       alarm.lastSnoozeByCreatorOn + alarm.lastSnoozeByCreatorFor
  //     console.log(
  //       'Scheduling snooze notification',
  //       DateTimeUtils.getDateTimeAsString(snoozeDate)
  //     )
  //     AlarmManager.scheduleSnoozeNotification(
  //       snoozeDate,
  //       snoozeNotificationInfo.alarmAlert,
  //       snoozeNotificationInfo
  //     )
  //   }
  // }
}

// Helper function to schedule remote notification
const scheduleRemoteNotificationForAlarm = (
  alarm,
  cancelSnoozeAlarm = false,
  isRetry = false
) => {
  console.log(
    'Scheduling remote notification for alarm ' +
      alarm.id +
      ' date: ' +
      alarm.date
  )

  TaskManager.addHttpsCloudTask('scheduleNotificationForAlarm', {
    uid: GlobalConfig.uid,
    alarmId: alarm.id,
    cancelSnoozeAlarm: cancelSnoozeAlarm
  })
    .then(result => {
      if (result && result.status === 'success') {
        console.log(
          'Remote notification scheduled successfully for alarm:',
          alarm.id
        )
      } else {
        console.error('Failed to schedule remote notification:', result)
      }
    })
    .catch(error => {
      console.error('Error scheduling remote notification:', error)

      if (!isRetry) {
        // The alarm doc may not have finished syncing to the backend yet
        // (e.g. right after creation/edit), so give it a bit of time and
        // retry once before falling back to a local notification.
        setTimeout(() => {
          scheduleRemoteNotificationForAlarm(alarm, cancelSnoozeAlarm, true)
        }, 5000)
      } else {
        // Still failing after a retry - fall back to a local notification
        // so the alarm rings on this device even if remote scheduling
        // never succeeds.
        AlarmUtils.cancelRemoteNotificationForAlarm(alarm.id)
        scheduleLocalNotificationForOwnAlarm(alarm, cancelSnoozeAlarm)
      }
    })
}

const cancelNotificationsForAlarm =
  (alarmId, alarmScheduledRemotely = false) =>
  (dispatch, getState) => {
    // Cancel the local notification regardless of alarmScheduledRemotely
    // to avoid issues with local notifications lingering around
    AlarmManager.cancelNotifications(alarmId)

    const isOnline =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (alarmScheduledRemotely) {
      if (isOnline) {
        AlarmUtils.cancelRemoteNotificationForAlarm(alarmId)
      } else {
        dispatch(addRemoveRemoteAlarmNotificationPendingAction(alarmId))
      }
    }
  }

const scheduleNotificationForOwnAlarm =
  (alarm, cancelSnoozeAlarm = false) =>
  (dispatch, getState) => {
    const shouldSchedule =
      alarm.status &&
      alarm.creationMode !== Constants.AlarmCreationModes.INSTANT_ALARM

    const isOnline =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    const alarmScheduledRemotely = alarm.scheduledRemotely || false

    console.log(
      'scheduleNotificationForOwnAlarm',
      shouldSchedule,
      isOnline,
      alarmScheduledRemotely
    )

    // Handle the case where alarm should be scheduled
    if (shouldSchedule) {
      if (isOnline) {
        // Schedule notification (remote or local)
        if (alarmScheduledRemotely) {
          scheduleRemoteNotificationForAlarm(alarm, cancelSnoozeAlarm)
        } else {
          scheduleLocalNotificationForOwnAlarm(alarm, cancelSnoozeAlarm)
        }
      } else {
        // Offline: transition from remote to local if
        // user is offline and alarm was scheduled remotely
        if (alarmScheduledRemotely) {
          console.log(
            'Converting remote alarm to local because user is offline'
          )
          const updatedAlarm = { ...alarm, scheduledRemotely: false }
          dispatch(softUpdateLocalAlarm(updatedAlarm))
          dispatch(addRemoveRemoteAlarmNotificationPendingAction(alarm.id))
        }
        // Schedule local notification
        scheduleLocalNotificationForOwnAlarm(alarm, cancelSnoozeAlarm)
      }
      return
    }

    // Handle the case where alarm should NOT be scheduled (disabled or instant)
    dispatch(cancelNotificationsForAlarm(alarm.id, alarmScheduledRemotely))
  }

const scheduleNotificationForParticipantAlarm = (
  alarm,
  contacts,
  cancelSnoozeAlarm = false
) => {
  if (AlarmUtils.willParticipantAlarmRing(alarm)) {
    const creatorName = AlarmUtils.resolveAlarmCreatorName(
      contacts,
      alarm.creator,
      alarm.creatorMobileNumber,
      alarm.creatorName
    )
    const alarmAlert = AlarmUtils.getParticipantAlarmNotificationAlertMessage(
      alarm.type,
      alarm.name,
      alarm.creationMode,
      creatorName
    )

    const nextAlarmRingDate = AlarmUtils.getNextRingDateForAlarm(alarm)
    const backupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
      { ...alarm, date: nextAlarmRingDate },
      alarm.order
    )
    const notificationInfo = AlarmUtils.getParticipantAlarmNotificationInfo(
      alarm,
      backupAlarmDate,
      creatorName
    )

    console.log(
      'Scheduling notification for participant alarm ' +
        alarm.id +
        ' at ' +
        DateTimeUtils.getDateTimeAsString(backupAlarmDate)
    )

    AlarmManager.scheduleNotification(
      backupAlarmDate,
      alarm.endDate,
      alarm.repeatType,
      alarm.repeat,
      alarm.creatorTimezone,
      alarmAlert,
      notificationInfo,
      cancelSnoozeAlarm,
      false
    )

    // This is to handle schedule existing alarms such that snoozing alarms
    // are also rescheduled
    // if (AlarmUtils.isLastSnoozeTimeInSnoozeDurationForParticipantAlarm(alarm)) {
    //   // Use the previous alarm date for the snooze notification else it will
    //   // create problems when a repeating alarm that is currently snoozing is
    //   // marked done. It will fetch the next date as the current date for the
    //   // alarm for which we would have no acknowledgement and hence end up
    //   // scheduling a snooze notification incorrectly.
    //   const prevAlarmDate = AlarmUtils.getPrevDateForAlarm(
    //     alarm.date,
    //     alarm.endDate,
    //     alarm.repeatType,
    //     alarm.repeat,
    //     alarm.creatorTimezone
    //   )

    //   const prevOccurrenceAcknowledgement =
    //     AlarmUtils.getAlarmAcknowledgementStatusForOccurrenceForAlarm(
    //       alarm,
    //       prevAlarmDate
    //     )

    //   // If alarm was snoozed and prev occurrence was not acknowledged, schedule the snooze notification
    //   if (!prevOccurrenceAcknowledgement) {
    //     const prevBackupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
    //       { ...alarm, date: prevAlarmDate },
    //       alarm.order
    //     )
    //     const snoozeNotificationInfo = {
    //       ...notificationInfo,
    //       alarmDate: prevBackupAlarmDate
    //     }
    //     const participant = AlarmUtils.getAlarmParticipant(alarm)
    //     const snoozeDate = participant.lastSnoozeOn + participant.lastSnoozeFor
    //     console.log(
    //       'Scheduling snooze notification',
    //       DateTimeUtils.getDateTimeAsString(snoozeDate)
    //     )
    //     AlarmManager.scheduleSnoozeNotification(
    //       snoozeDate,
    //       snoozeNotificationInfo.alarmAlert,
    //       snoozeNotificationInfo
    //     )
    //   }
    // }
  } else {
    console.log('Canceling notification for participant alarm ' + alarm.id)
    AlarmManager.cancelNotifications(alarm.id)
  }
}

// eslint-disable-next-line no-unused-vars
const resetUnseenMessagesForAlarm = alarmId => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers.transaction(
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/unseenMessages/${alarmId}/${GlobalConfig.uid}`
    ),
    // eslint-disable-next-line no-unused-vars
    unseenMessagesCount => {
      return null
    }
  )
}

// eslint-disable-next-line no-unused-vars
const updateUserCurrentlyTyping = alarmId => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/currentlyTyping/${alarmId}/${GlobalConfig.uid}`
    ),
    true
  )
}

// eslint-disable-next-line no-unused-vars
const resetUserCurrentlyTyping = alarmId => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers.removeData(
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/currentlyTyping/${alarmId}/${GlobalConfig.uid}`
    )
  )
}

// eslint-disable-next-line no-unused-vars
const loadCurrentlyTypingUsers = alarmId => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'AlarmConversation',
    GlobalConfig.firebaseHelpers.createRef(
      'conversations/currentlyTyping/' + alarmId
    ),
    snapshot => {
      const currentlyTypingUsersObj = snapshot.val() || {}
      const currentlyTypingUsers = Object.keys(currentlyTypingUsersObj)
      dispatch(
        updateCurrentlyTypingUsersForAlarm(alarmId, currentlyTypingUsers)
      )
    }
  )
}

// eslint-disable-next-line no-unused-vars
const unloadCurrentlyTypingUsers = alarmId => (dispatch, getState) => {
  FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
    'AlarmConversation',
    GlobalConfig.firebaseHelpers.createRef(
      'conversations/currentlyTyping/' + alarmId
    )
  )
}

// eslint-disable-next-line no-unused-vars
const loadAlerts = () => (dispatch, getState) => {
  // Don't process alerts for web as we don't show
  // alerts on the web at the moment
  if (Platform.OS === 'web') {
    return
  }

  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alerts`
    ),
    snapshot => {
      try {
        const alertId = snapshot.key
        const alertData = snapshot.val()
        const alertJson = JSON.parse(alertData)

        if (!alertJson) {
          throw new Error('Unable to parse alert json')
        }

        if (Array.isArray(alertJson)) {
          alertJson.forEach(alert => {
            handleAlert(alert, dispatch)
          })
        } else {
          handleAlert(alertJson, dispatch)
        }

        // Remove the alert once presented to the user
        GlobalConfig.firebaseHelpers.removeData(
          GlobalConfig.firebaseHelpers.createRef(
            `userInfos/${GlobalConfig.uid}/alerts/${alertId}`
          )
        )
      } catch (error) {
        LogUtils.logError(error, 'Error showing in app alerts to the user')
      }
    }
  )
}

const handleAlert = (alert, dispatch) => {
  let alerts = []
  let impactedAlarms
  let impactedGroups
  switch (alert.type) {
    case Constants.AlertTypes.MEMBER_ADDED_TO_GROUP:
      impactedAlarms = []
      alert.data.impactedAlarms.forEach(alarm => {
        impactedAlarms.push(alarm.name)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.MEMBER_ADDED_TO_GROUP,
        message: I18n.t('membersAddedToGroup', {
          memberNames: alert.data.members.join(', '),
          count: alert.data.members.length,
          groupName: alert.data.name
        }),
        impactedAlarms: impactedAlarms
      })

      break
    case Constants.AlertTypes.MEMBER_REMOVED_FROM_GROUP:
      impactedAlarms = []
      alert.data.impactedAlarms.forEach(alarm => {
        impactedAlarms.push(alarm.name)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.MEMBER_REMOVED_FROM_GROUP,
        message: I18n.t('memberRemovedFromGroup', {
          memberName: alert.data.memberName,
          groupName: alert.data.name
        }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.REMOVED_FROM_GROUP:
      impactedAlarms = []
      alert.data.impactedAlarms.forEach(alarm => {
        impactedAlarms.push(alarm.name)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.REMOVED_FROM_GROUP,
        message: I18n.t('youRemovedFromGroup', { groupName: alert.data.name }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.LEFT_GROUP:
      impactedAlarms = []
      alert.data.impactedAlarms.forEach(alarm => {
        impactedAlarms.push(alarm.name)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.LEFT_GROUP,
        message: I18n.t('youLeftGroup', { groupName: alert.data.name }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.MEMBER_LEFT_GROUP:
      impactedAlarms = []
      alert.data.impactedAlarms.forEach(alarm => {
        impactedAlarms.push(alarm.name)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.MEMBER_LEFT_GROUP,
        message: I18n.t('memberLeftGroup', {
          memberName: alert.data.memberName,
          groupName: alert.data.name
        }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.CREATOR_TIMEZONE_CHANGED:
      impactedAlarms = []
      alert.data.impactedAlarmNames.forEach(alarmName => {
        impactedAlarms.push(alarmName)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.CREATOR_TIMEZONE_CHANGED,
        message: I18n.t('memberMovedToADifferentTimezone', {
          memberName: alert.data.creatorName
        }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.DST_CHANGED:
      impactedAlarms = []
      alert.data.impactedAlarmNames.forEach(alarmName => {
        impactedAlarms.push(alarmName)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.DST_CHANGED,
        message: I18n.t('memberDstChanged', {
          memberName: alert.data.creatorName,
          count: alert.dstStart ? 1 : 0
        }),
        impactedAlarms: impactedAlarms
      })
      break
    case Constants.AlertTypes.MEMBER_DELETED_ACCOUNT:
      impactedAlarms = []
      impactedGroups = []
      alert.data.impactedAlarmNames.forEach(alarmName => {
        impactedAlarms.push(alarmName)
      })
      alert.data.impactedGroupNames.forEach(groupName => {
        impactedGroups.push(groupName)
      })
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.MEMBER_DELETED_ACCOUNT,
        message: I18n.t('memberDeletedAccount', {
          memberName: alert.data.memberName
        }),
        impactedAlarms: impactedAlarms,
        impactedGroups: impactedGroups
      })
      break
    case Constants.AlertTypes.SUBSCRIBED_ALARM_EDITED:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.SUBSCRIBED_ALARM_EDITED,
        message: I18n.t('subscribedAlarmEdited', {
          alarmName: alert.data.alarmName,
          alarmCreatorName: alert.data.alarmCreatorName
        }),
        subscriberAlarmId: alert.data.subscriberAlarmId
      })
      break
    case Constants.AlertTypes.SUBSCRIBED_ALARM_DELETED:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.SUBSCRIBED_ALARM_DELETED,
        message: I18n.t('subscribedAlarmDeleted', {
          alarmName: alert.data.alarmName,
          alarmCreatorName: alert.data.alarmCreatorName
        }),
        subscriberAlarmId: alert.data.subscriberAlarmId
      })
      break
    case Constants.AlertTypes.RESPONDED_TO_USER_TICKET:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.RESPONDED_TO_USER_TICKET,
        message: I18n.t('responseReceivedForTicket', {
          ticketId: alert.data.ticketId,
          email: alert.data.email
        })
      })
      break
    case Constants.AlertTypes.NEW_TICKET_RECEIVED:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.NEW_TICKET_RECEIVED,
        message: I18n.t('newTicketReceived', {
          ticketId: alert.data.ticketId,
          email: alert.data.email
        })
      })
      break
    case Constants.AlertTypes.SENT_ACCOUNT_BACKUP:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.SENT_ACCOUNT_BACKUP,
        message: I18n.t('sentAccountBackup', {
          email: alert.data.email
        })
      })
      break
    case Constants.AlertTypes.SLACK_VERIFICATION_CODE:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.SLACK_VERIFICATION_CODE,
        message: I18n.t('slackVerificationCode', {
          verificationCode: alert.data.verificationCode
        })
      })
      break
    case Constants.AlertTypes.APP_VERIFICATION_CODE_TO_BUY_PREMIUM_SUBSCRIPTION:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes
          .APP_VERIFICATION_CODE_TO_BUY_PREMIUM_SUBSCRIPTION,
        message: I18n.t('appVerificationCodeToBuyPremiumSubscription', {
          verificationCode: alert.data.verificationCode
        })
      })
      break
    case Constants.AlertTypes.MEMBER_CHANGED_PHONE_NUMBER:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.MEMBER_CHANGED_PHONE_NUMBER,
        message: I18n.t('memberChangedPhoneNumber', {
          memberName: alert.data.memberName
        })
      })
      break
    case Constants.AlertTypes.TIMEZONE_FOR_ALARMS_CHANGED:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.TIMEZONE_FOR_ALARMS_CHANGED,
        message: I18n.t('alarmTimezoneChanged'),
        impactedAlarms: alert.data.impactedAlarmNames
      })
      break
    case Constants.AlertTypes.DEFAULT_TIMEZONE_CHANGED:
      alerts.push({
        id: uuid.v4(),
        type: Constants.AlertTypes.DEFAULT_TIMEZONE_CHANGED,
        message: I18n.t('defaultTimezoneChanged', {
          defaultTimezoneForAlarm: alert.data.defaultTimezoneForAlarm
        })
      })
      break
    case Constants.AlertTypes.CALENDAR_GRANT_EXPIRED:
      alerts.push({
        id: 'calendarGrantExpired',
        type: Constants.AlertTypes.CALENDAR_GRANT_EXPIRED,
        message: I18n.t('calendarGrantExpired', {
          connectedAccountName: alert.data.connectedAccountName,
          userName: alert.data.userName
        })
      })
      break
    case Constants.AlertTypes.DEVICE_TOKEN_EXPIRED:
      alerts.push({
        id: 'deviceTokenExpired',
        type: Constants.AlertTypes.DEVICE_TOKEN_EXPIRED,
        message: I18n.t('deviceTokenExpired')
      })
      break
    case Constants.AlertTypes.UNABLE_TO_SEND_REMOTE_NOTIFICATION:
      alerts.push({
        id: 'unableToSendRemoteNotification',
        type: Constants.AlertTypes.UNABLE_TO_SEND_REMOTE_NOTIFICATION,
        message: I18n.t('unableToSendRemoteNotification', {
          errorCode: alert.data.errorCode
        })
      })
      break
    default:
      LogUtils.logError(new Error('Unidentified alert ' + alert.type))
      return
  }

  dispatch(addSystemAlerts(alerts))
}

const isUserNoLongerParticipant = alarm => {
  // If the member has been removed as a backup for the alarm either by removing the individual contact
  // or the user is no longer part of the group, then remove the event handler. If the contact was the
  // only backup or alarmCreator was removed from the group, then the backups object will be undefined
  // The alarm will be removed by the backupAlarms change handler

  const participant = AlarmUtils.getAlarmParticipant(alarm)

  if (participant === undefined) {
    return true
  }

  return false
}

const retrieveAndAddBackupAlarmAndScheduleNotifications = (
  dispatch,
  alarmId,
  getState
) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`),
    snapshot => {
      const alarmData = snapshot.val()

      const participantAlarmSelector = makeAllParticipantAlarmSelector()
      const existingAlarm = participantAlarmSelector(getState(), { alarmId })

      // If an alarm is deleted, this handler will be called with null value. Remove the backup alarm
      if (alarmData === null || alarmData.isDeleted) {
        if (!isEmpty(existingAlarm)) {
          removeBackupAlarmAndCancelNotifications(dispatch, alarmId)
        }
        FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
          'App',
          GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
        )
        FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
          'App',
          GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`)
        )
        return
      }

      const alarm = AlarmUtils.createAlarm(alarmData)

      if (alarm === undefined) {
        return
      }

      // Since the groups are shared now, if a user added a group as a backup for an alarm, we want to show that alarm as a backup
      // alarm for all the users except the creator
      // Sometimes, we get an error and GlobalConfig.uid is not an object here
      if (alarm.creator === GlobalConfig.uid) {
        return
      }

      const userIsNoLongerParticipant = isUserNoLongerParticipant(alarm)

      // Remove the alarm if the user is no longer a backup
      if (userIsNoLongerParticipant) {
        if (!isEmpty(existingAlarm)) {
          removeBackupAlarmAndCancelNotifications(dispatch, alarmId)
        }
        FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
          'App',
          GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
        )
        FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
          'App',
          GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`)
        )
        return
      }

      const blockedContacts = getState().userInfo.blockedContacts

      // Need to remove alarm because when user blocks existing alarms,
      // need to remove those alarms from the app. This should be before
      // the creator check so that the existing alarms can be removed
      // The blocked check if required if the user decided not to restore
      // previously blocked alarms
      if (
        !alarm.status ||
        alarm.state === Constants.ParticipantStates.INACTIVE ||
        alarm.blocked ||
        blockedContacts.includes(alarm.creator)
      ) {
        if (!isEmpty(existingAlarm)) {
          removeBackupAlarmAndCancelNotifications(dispatch, alarmId)
        }
        return
      }

      // Instant alarms are triggered as part of the notifications and needn't be
      // scheduled here again. Scheduling here leads to race condition between schedule
      // and cancel notification calls on iOS leading to instant alarm not ringing at all
      if (alarm.creationMode !== Constants.AlarmCreationModes.INSTANT_ALARM) {
        scheduleNotificationForParticipantAlarm(
          alarm,
          getState().contacts.contacts
        )
      }

      // If there has been no change to the participant alarm, then skip it
      if (
        !isEmpty(existingAlarm) &&
        (!alarm.lastUpdatedAt ||
          alarm.lastUpdatedAt === existingAlarm.lastUpdatedAt)
      ) {
        return
      }

      // Add the alarm to the redux store
      dispatch(addBackupAlarm(alarmId, alarm))
    }
  )

  dispatch(loadAlarmActions(alarmId))

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/unseenMessages/${alarmId}/${GlobalConfig.uid}`
    ),
    snapshot => {
      const currentScreen = getState().appState.currentScreen
      const unseenMessages = snapshot.val() || 0
      const currentUnseenMessagesForAlarm = objGet(
        getState().conversations.alarms,
        `[${alarmId}].unseenMessages`,
        0
      )
      if (currentUnseenMessagesForAlarm !== unseenMessages) {
        dispatch(updateUnseenMessagesForAlarm(alarmId, unseenMessages))
      }
      if (currentScreen === 'AlarmConversationScreen' + alarmId) {
        dispatch(resetUnseenMessagesForAlarm(alarmId))
      }
    }
  )
}

const createAlarmAcknowledgementsFromAlarmActions = alarmActions => {
  const alarmAcknowledgements = alarmActions.alarmAcknowledgements || {}
  const alarmAcknowledgementsToReturn = []
  Object.keys(alarmAcknowledgements).forEach(occurrenceTimeString => {
    const usersResponses = alarmAcknowledgements[occurrenceTimeString] || {}
    Object.keys(usersResponses).forEach(uid => {
      const userResponses = usersResponses[uid] || {}
      Object.keys(userResponses).forEach(responseId => {
        const response = userResponses[responseId]
        alarmAcknowledgementsToReturn.push({
          occurrenceTimeString,
          uid,
          timestamp: response.timestamp,
          response: response.response,
          rescheduleAlarm: response.rescheduleAlarm
        })
      })
    })
  })
  return alarmAcknowledgementsToReturn
}

// eslint-disable-next-line no-unused-vars
const loadAlarmAcknowledgements = alarmId => (dispatch, getState) => {
  return GlobalConfig.firebaseHelpers
    .getData(GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`))
    .then(snapshot => {
      const alarmActionsData = snapshot.val()

      if (alarmActionsData !== null) {
        const alarmAcknowledgements =
          createAlarmAcknowledgementsFromAlarmActions(alarmActionsData)

        // Cancel the snooze alarm as this is called when an alarm
        // is acknowledged.
        dispatch(
          updateAlarmAcknowledgementsAndRescheduleAlarm(
            alarmId,
            alarmAcknowledgements,
            true
          )
        )
      }
    })
}
// eslint-disable-next-line no-unused-vars
const loadAlarmActions = alarmId => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`alarmActions/${alarmId}`),
    snapshot => {
      const alarmActionsData = snapshot.val()

      if (alarmActionsData === null) {
        const currAlarmAcknowledgements = objGet(
          getState().alarmActions,
          `alarmAcknowledgements.${alarmId}`
        )
        if (currAlarmAcknowledgements) {
          dispatch(removeAlarmAcknowledgementActions(alarmId))
        }

        const currAlarmStatusChanges = objGet(
          getState().alarmActions,
          `alarmStatusChanges.${alarmId}`
        )
        if (currAlarmStatusChanges) {
          dispatch(removeAlarmStatusChangeActions(alarmId))
        }

        return
      }

      const alarmAcknowledgements =
        createAlarmAcknowledgementsFromAlarmActions(alarmActionsData)

      const existingAlarmAcknowledgementsSelector =
        makeAlarmAcknowledgementsSelector()
      const existingAlarmAcknowledgements =
        existingAlarmAcknowledgementsSelector(getState(), { alarmId })

      if (
        alarmAcknowledgements.length > 0 &&
        alarmAcknowledgements.length !== existingAlarmAcknowledgements.length
      ) {
        if (!existingAlarmsLoaded) {
          batchedExistingAlarmsAcknowledgements[alarmId] = alarmAcknowledgements
        } else {
          dispatch(
            updateAlarmAcknowledgementsAndRescheduleAlarm(
              alarmId,
              alarmAcknowledgements
            )
          )
        }
      } else {
        console.log('no change to alarm acknowledgements')
      }

      const alarmStatusChanges = alarmActionsData.alarmStatusChanges || {}
      const alarmStatusChangesToAdd = []
      Object.keys(alarmStatusChanges).forEach(responseId => {
        const response = alarmStatusChanges[responseId]
        alarmStatusChangesToAdd.push({
          timestamp: response.timestamp,
          status: response.status
        })
      })

      const existingAlarmStatusChangesSelector =
        makeAlarmStatusChangesSelector()
      const existingAlarmStatusChanges = existingAlarmStatusChangesSelector(
        getState(),
        { alarmId }
      )

      if (
        alarmStatusChangesToAdd.length > 0 &&
        alarmStatusChangesToAdd.length !== existingAlarmStatusChanges.length
      ) {
        if (!existingAlarmsLoaded) {
          batchedExistingAlarmsStatusChanges[alarmId] = alarmStatusChangesToAdd
        } else {
          dispatch(addAlarmStatusChanges(alarmId, alarmStatusChangesToAdd))
        }
      } else {
        console.log('no change to alarm status changes')
      }
    }
  )
}

const removeBackupAlarmAndCancelNotifications = (dispatch, alarmId) => {
  dispatch(removeBackupAlarm(alarmId))
  AlarmManager.cancelNotifications(alarmId)
}

// eslint-disable-next-line no-unused-vars
const removeDeletedParticipantAlarms = () => (dispatch, getState) => {
  const existingAlarmIds = getState().backupAlarms.alarms.map(alarm => alarm.id)
  TaskManager.addHttpsCloudTask('findDeletedAlarms', {
    alarmIds: JSON.stringify(existingAlarmIds),
    areParticipantAlarms: true
  }).then(taskResult => {
    const deletedAlarmIds = taskResult.deletedAlarmIds
    if (!deletedAlarmIds || deletedAlarmIds.length <= 0) {
      return
    }
    deletedAlarmIds.forEach(alarmId => {
      AlarmManager.cancelNotifications(alarmId)
    })
    dispatch(removeParticipantAlarms(deletedAlarmIds))
  })
}

// Alarms maybe deleted on the web and the mobile app may not be running
// at that time and hence miss the events. So, delete any such deleted
// alarms from the local store
// eslint-disable-next-line no-unused-vars
const removeDeletedOwnAlarms = () => (dispatch, getState) => {
  const existingAlarmIds = getState()
    .alarms.alarms.filter(alarm => alarm.persistedOnline !== false)
    .map(alarm => alarm.id)
  TaskManager.addHttpsCloudTask('findDeletedAlarms', {
    alarmIds: JSON.stringify(existingAlarmIds)
  }).then(taskResult => {
    const deletedAlarmIds = taskResult.deletedAlarmIds
    if (!deletedAlarmIds || deletedAlarmIds.length <= 0) {
      return
    }
    deletedAlarmIds.forEach(alarmId => {
      const ownAlarmSelector = makeOwnAlarmSelector()
      const alarm = ownAlarmSelector(getState(), { alarmId })
      dispatch(cancelNotificationsForAlarm(alarmId, alarm.scheduledRemotely))
    })
    dispatch(removeLocalAlarms(deletedAlarmIds))
  })
}

// This function finds own alarms that are only present locally
// and not on the database. This maybe because some of the pending
// actions may have been dropped for some reason. It is not clear
// at the moment why are the pending actions dropped. But this syncs
// those alarms back to the database.
const syncLocalOnlyOwnAlarms = () => (dispatch, getState) => {
  const existingAlarmIds = getState()
    .alarms.alarms.filter(alarm => alarm.persistedOnline === false)
    .map(alarm => alarm.id)
  TaskManager.addHttpsCloudTask('findDeletedAlarms', {
    alarmIds: JSON.stringify(existingAlarmIds)
  }).then(taskResult => {
    const deletedAlarmIds = taskResult.deletedAlarmIds
    if (!deletedAlarmIds || deletedAlarmIds.length <= 0) {
      return
    }
    console.log('local only alarms', deletedAlarmIds)
    deletedAlarmIds.forEach(alarmId => {
      const ownAlarmSelector = makeOwnAlarmSelector()
      const alarm = ownAlarmSelector(getState(), { alarmId })
      AlarmUtils.addAlarm(alarm).catch(() => {})
    })
  })
}

// eslint-disable-next-line no-unused-vars
const loadRecentlyDeletedAlarms = () => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/recentlyDeletedAlarms`
    ),
    async snapshot => {
      let promises = []
      let alarms = []
      snapshot.forEach(childSnapshot => {
        const alarmId = childSnapshot.key
        promises.push(
          GlobalConfig.firebaseHelpers
            .getData(
              GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`)
            )
            .then(snapshot => snapshot.val())
        )
      })
      // Wait for all promises to resolve before proceeding
      const results = await Promise.all(promises)

      // Filter out null results and merge into the alarms object
      alarms.push(
        ...results
          .filter(result => result !== null)
          .map(alarm => AlarmUtils.createAlarm(alarm))
          .filter(alarm => alarm !== undefined)
      )

      dispatch(setRecentlyDeletedAlarms(alarms))
    }
  )
}

const loadChecklist = (checklistId, dispatch) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`checklists/${checklistId}`),
    snapshot => {
      const checklistData = snapshot.val()

      if (checklistData === null) {
        // The realtime listener can fire with a null value transiently during
        // the initial sync on a new device (e.g. the offline persistence cache
        // is empty before the server value arrives, or read permission for the
        // checklist node isn't fully established right after registration). We
        // must only update local state here and never dispatch removeChecklist,
        // which would write a delete back to the server (checklists/${id} = null
        // and the userInfos index entry = null) and permanently erase the
        // user's checklist and all of its tasks. If this was a genuine remote
        // delete, the server is already null; if it was a transient null, the
        // listener will fire again with the real data and re-add it.
        dispatch(removeLocalChecklist(checklistId))
        return
      }

      const checklist = AlarmUtils.createChecklist(checklistData)

      if (checklist === undefined) {
        return
      }

      dispatch(addLocalChecklist(checklist, true))
    }
  )
}

// eslint-disable-next-line no-unused-vars
const loadChecklists = () => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/checklists`
    ),
    async snapshot => {
      snapshot.forEach(childSnapshot => {
        const checklistId = childSnapshot.key
        loadChecklist(checklistId, dispatch)
      })
    }
  )
}

const loadBackupAlarms = () => (dispatch, getState) => {
  // Add new backup alarm when the user is added as an individual backup
  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/backupForAlarms`
    ),
    snapshot => {
      const alarmId = snapshot.key
      retrieveAndAddBackupAlarmAndScheduleNotifications(
        dispatch,
        alarmId,
        getState
      )
    }
  )

  // Handle backup alarms for groups that are backup for an alarm. Whenever a user is added as part of a group,
  // add handlers which will add or remove alarm as
  // 1. Group is added as a backup for an alarm
  // 2. User is added to a group and the group is a backup for some alarms already
  // 3. Group is removed as a backup for an alarm
  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/groups`
    ),
    groupSnapshot => {
      const groupId = groupSnapshot.key

      // Add new backup alarm when then user is member of a group which is added as a backup for an alarm
      FirebaseManager.addFirebaseRefChildAdded(
        'App',
        GlobalConfig.firebaseHelpers.createRef(
          `groupInfos/${groupId}/backupForAlarms`
        ),
        alarmIdSnapshot => {
          const alarmId = alarmIdSnapshot.key
          retrieveAndAddBackupAlarmAndScheduleNotifications(
            dispatch,
            alarmId,
            getState
          )
        }
      )
    }
  )

  // If user is no longer part of a group, then remove the backup alarms which were added due to membership of the group
  FirebaseManager.addFirebaseRefChildRemoved(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/groups`
    ),
    groupSnapshot => {
      const groupId = groupSnapshot.key

      GlobalConfig.firebaseHelpers
        .getData(
          GlobalConfig.firebaseHelpers.createRef(
            `groupInfos/${groupId}/backupForAlarms`
          )
        )
        .then(snapshot => {
          // If the group is deleted, then the snapshot won't exist. The backup alarms will be removed
          // by earlier handlers
          if (snapshot.exists()) {
            snapshot.forEach(alarmIdSnapshot => {
              const alarmId = alarmIdSnapshot.key
              const participantAlarmSelector = makeAllParticipantAlarmSelector()
              const alarm = participantAlarmSelector(getState(), { alarmId })
              // If the user is the creator of the alarm, then the alarm won't be found in the backup alarms
              if (!isEmpty(alarm)) {
                removeBackupAlarmAndCancelNotifications(dispatch, alarmId)
              }
            })
          }
        })

      // Remove the event handlers added earlier to add/remove a backup alarm if the groupInfo changes for a group of which the user is a member
      // If the user is no longer member of a group, then we need to remove those handlers such that we don't add backup alarms for user if that
      // group is made backup for some alarm
      // TODO: Test this by adding a user to a group, then removing him and then adding that group as a backup for an alarm
      FirebaseManager.unbindFirebaseEventHandlerForChildAdded(
        'App',
        GlobalConfig.firebaseHelpers.createRef(
          `groupInfos/${groupId}/backupForAlarms`
        )
      )
    }
  )
}

// eslint-disable-next-line no-unused-vars
const loadUserInfo = () => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`users/${GlobalConfig.uid}`),
    async snapshot => {
      if (snapshot.exists()) {
        dispatch(setUserInfo(snapshot.val()))

        // Update username and phoneId in storage if not present
        if (snapshot.val().name) {
          const data = await StorageManager.retrieveData(['username'])
          if (!data.username) {
            const username = snapshot.val().name
            StorageManager.storeData({ username })
            GlobalConfig.username = username
          }
        }

        if (snapshot.val().phoneId) {
          const data = await StorageManager.retrieveData(['phoneId'])
          if (!data.phoneId) {
            const phoneId = snapshot.val().phoneId
            StorageManager.storeData({ phoneId })
            GlobalConfig.phoneId = phoneId
          }
        }
      }
    }
  )

  Platform.OS !== 'web' &&
    FirebaseManager.addFirebaseRefValueChanged(
      'App',
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/enterpriseSubscriptions`
      ),
      snapshot => {
        if (snapshot.exists()) {
          let promises = []
          snapshot.forEach(enterpriseSubscriptionSnapshot => {
            promises.push(
              GlobalConfig.firebaseHelpers
                .getDocument(
                  GlobalConfig.firebaseHelpers.docRef(
                    GlobalConfig.firebaseHelpers.collectionRef(
                      'enterpriseAccounts'
                    ),
                    enterpriseSubscriptionSnapshot.key
                  )
                )
                .then(enterpriseSubscriptionDoc => {
                  if (enterpriseSubscriptionDoc.exists) {
                    return enterpriseSubscriptionDoc.data()
                  } else {
                    return null
                  }
                })
            )
          })
          Promise.all(promises).then(enterpriseSubscriptions => {
            const activeSubscriptions = enterpriseSubscriptions
              .filter(enterpriseSubscription => !!enterpriseSubscription)
              .map(enterpriseSubscription => enterpriseSubscription.id)
            dispatch(addEnterpriseSubscriptions(activeSubscriptions))
          })
        } else {
          dispatch(addEnterpriseSubscriptions([]))
        }
      }
    )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/stripeSubscriptions`
    ),
    snapshot => {
      const subscriptions = []
      const nowInSeconds = Date.now() / 1000
      if (snapshot.exists()) {
        snapshot.forEach(subSnapshot => {
          const sub = subSnapshot.val()
          const isLifetimePlan = sub.interval === 'lifetime'
          if (
            (sub.status === 'active' ||
              sub.status === 'trialing' ||
              sub.status === 'past_due') &&
            (isLifetimePlan || sub.subscriptionEnd > nowInSeconds)
          ) {
            subscriptions.push(sub)
          }
        })
      }
      dispatch(setStripeSubscriptions(subscriptions))
    }
  )

  FirestoreManager.listenToConnectedAccountsForUser(
    `userInfos/${GlobalConfig.uid}/connectedAccounts`,
    GlobalConfig.uid,
    snapshot => {
      let connectedAccounts = []
      snapshot.forEach(connectedAccountSnapshot => {
        connectedAccounts.push(connectedAccountSnapshot.data())
      })
      dispatch(setConnectedAccounts(connectedAccounts))
    }
  )

  FirestoreManager.listenToCalendarEventsForUser(
    `userInfos/${GlobalConfig.uid}/calendarEvents`,
    GlobalConfig.uid,
    snapshot => {
      console.log('Found calendar events for user', snapshot.size)
      let calendarEvents = []
      snapshot.forEach(calendarEventSnapshot => {
        const calendarEvent = calendarEventSnapshot.data()
        calendarEvent.isActive && calendarEvents.push(calendarEvent)
      })
      dispatch(setCalendarEvents(calendarEvents))
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/blockedContacts`
    ),
    snapshot => {
      if (snapshot.exists()) {
        let blockedContacts = []
        snapshot.forEach(blockedContactSnapshot => {
          blockedContacts.push(blockedContactSnapshot.key)
        })
        dispatch(addBlockedContacts(blockedContacts))
      } else {
        dispatch(addBlockedContacts([]))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/rateTheApp`
    ),
    snapshot => {
      if (snapshot.exists()) {
        dispatch(setRateTheAppUserInfo(snapshot.val()))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alarmsCount`
    ),
    snapshot => {
      if (snapshot.exists()) {
        dispatch(setAlarmsCount(snapshot.val()))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/deviceOs`
    ),
    snapshot => {
      if (snapshot.exists()) {
        dispatch(setDeviceOs(snapshot.val()))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/maxAllowedAlarms`
    ),
    snapshot => {
      if (snapshot.exists()) {
        dispatch(setMaxAllowedAlarms(snapshot.val()))
      }
    }
  )

  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/joinDate`
      )
    )
    .then(joinDateSnapshot => {
      if (joinDateSnapshot.exists()) {
        dispatch(setJoinDate(joinDateSnapshot.val()))
      }
    })

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/images`
    ),
    imagesSnapshot => {
      if (imagesSnapshot.exists()) {
        dispatch(setUserAvatarImages(imagesSnapshot.val()))
      } else {
        dispatch(deleteUserAvatarImages())
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/shareableAlarmLinksCount`
    ),
    linksCountSnapshot => {
      if (linksCountSnapshot.exists()) {
        dispatch(setShareableAlarmLinksCount(linksCountSnapshot.val()))
      } else {
        dispatch(setShareableAlarmLinksCount({}))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alarmsSavedToCalendarCount`
    ),
    alarmsSavedToCalendarCountSnapshot => {
      if (alarmsSavedToCalendarCountSnapshot.exists()) {
        dispatch(
          setAlarmsSavedToCalendarCount(
            alarmsSavedToCalendarCountSnapshot.val()
          )
        )
      } else {
        dispatch(setAlarmsSavedToCalendarCount(0))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/instantAlarmsCount`
    ),
    instantAlarmsCountSnapshot => {
      if (instantAlarmsCountSnapshot.exists()) {
        dispatch(setInstantAlarmsCount(instantAlarmsCountSnapshot.val()))
      } else {
        dispatch(setInstantAlarmsCount(0))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/stopwatchesCount`
    ),
    stopwatchesCountSnapshot => {
      if (stopwatchesCountSnapshot.exists()) {
        dispatch(setStopwatchesCount(stopwatchesCountSnapshot.val()))
      } else {
        dispatch(setStopwatchesCount(0))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/timersCount`
    ),
    timersCountSnapshot => {
      if (timersCountSnapshot.exists()) {
        dispatch(setTimersCount(timersCountSnapshot.val()))
      } else {
        dispatch(setTimersCount(0))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/alarmCategories`
    ),
    alarmCategoriesSnapshot => {
      if (alarmCategoriesSnapshot.exists()) {
        const alarmCategories = {}
        alarmCategoriesSnapshot.forEach(alarmCategorySnapshot => {
          const alarmCategoryId = alarmCategorySnapshot.key
          const alarmCategoryData = alarmCategorySnapshot.val()
          let { alarmIds = {}, ...alarmCategory } = alarmCategoryData
          alarmCategory.alarmIds = Object.keys(alarmIds)
          alarmCategories[alarmCategoryId] = alarmCategory
        })
        dispatch(setAlarmCategories(alarmCategories))
      } else {
        // Don't create the system defined categories if user has deleted their account.
        // GlobalConfig.uid is set to null once user account is deleted.
        if (GlobalConfig.uid) {
          dispatch(createSystemDefinedAlarmCategories())
        }
      }
    }
  )

  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/recentContacts`
      )
    )
    .then(recentContactsSnapshot => {
      if (recentContactsSnapshot.exists()) {
        dispatch(setRecentContacts(recentContactsSnapshot.val()))
      }
    })

  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/recentGroups`
      )
    )
    .then(recentGroupsSnapshot => {
      if (recentGroupsSnapshot.exists()) {
        dispatch(setRecentGroups(recentGroupsSnapshot.val()))
      }
    })
}

// eslint-disable-next-line no-unused-vars
const createSystemDefinedAlarmCategories = () => (dispatch, getState) => {
  GlobalConfig.systemAlarmCategories.forEach(systemAlarmCategory =>
    dispatch(createAlarmCategory(systemAlarmCategory))
  )
}

const incrementMaxAllowedAlarms = amount => (dispatch, getState) => {
  const currentLimit = getState().userInfo.maxAllowedAlarms
  return GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/maxAllowedAlarms`
    ),
    currentLimit + amount
  )
}

// eslint-disable-next-line no-unused-vars
const loadLocalUserSettings = () => (dispatch, getState) => {
  return StorageManager.retrieveData(['firstDayOfWeek']).then(data => {
    if (data.firstDayOfWeek) {
      const firstDayOfWeek = parseInt(data.firstDayOfWeek)
      dispatch(setFirstDayOfWeek(firstDayOfWeek))
      GlobalConfig.firstDayOfWeek = firstDayOfWeek
    }
  })
}

// eslint-disable-next-line no-unused-vars
const loadUserSettings = () => (dispatch, getState) => {
  return GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(`userSettings/${GlobalConfig.uid}`)
    )
    .then(userSettingsSnapshot => {
      if (userSettingsSnapshot.exists()) {
        const userSettings = userSettingsSnapshot.val()
        // If we have a ringtone that's not an object, omit alarmRingtone from userSetting
        let ringtoneObject = objGet(userSettings, 'alarmRingtone', '')
        if (typeof ringtoneObject === 'string') {
          ringtoneObject =
            GlobalConfig.ringtones
              .filter(ringtone => ringtone.value === ringtoneObject)
              .pop() || GlobalConfig.defaultAlarmRingtone
          userSettings.alarmRingtone = ringtoneObject
          GlobalConfig.firebaseHelpers.setData(
            GlobalConfig.firebaseHelpers.createRef(
              `userSettings/${GlobalConfig.uid}/alarmRingtone`
            ),
            ringtoneObject
          )
        } else if (
          typeof ringtoneObject === 'object' &&
          Platform.OS === 'ios' &&
          ringtoneObject.type === 'music'
        ) {
          ringtoneObject = GlobalConfig.defaultAlarmRingtone
          userSettings.alarmRingtone = ringtoneObject
          GlobalConfig.firebaseHelpers.setData(
            GlobalConfig.firebaseHelpers.createRef(
              `userSettings/${GlobalConfig.uid}/alarmRingtone`
            ),
            ringtoneObject
          )
        }

        let notificationSettingsObject = objGet(
          userSettings,
          'notificationSettings',
          {}
        )

        // Merge user's notification settings with default settings to ensure all settings are present
        userSettings.notificationSettings = {
          ...GlobalConfig.defaultNotificationSettings,
          ...notificationSettingsObject
        }

        dispatch(
          setUserSettings({
            ...GlobalConfig.updatedDefaultUserSettings,
            ...userSettings
          })
        )

        // Also set the user settings on the global config so that they are easily accessible
        Object.keys(userSettings).forEach(userSetting => {
          GlobalConfig[userSetting] = userSettings[userSetting]
        })

        // Set the alarmRingtone and ringOnVibrate settings if user has them changed.
        Platform.OS === 'android' && setAndroidNativePreferences(userSettings)
      } else {
        // If some defaults are changed, they need to be set explicitly
        // to overwrite the cached values in redux-persist
        setUserSettings(GlobalConfig.updatedDefaultUserSettings)
      }
    })
}

const setAndroidNativePreferences = userSettings => {
  if (userSettings.vibrate) {
    AlarmManager.updateVibratePreferences(userSettings.vibrate)
  }
  if (userSettings.volume) {
    AlarmManager.updateVolumePreferences(userSettings.volume)
  }
  if (userSettings.alarmRingtone) {
    AlarmManager.updateRingtonePreferences(userSettings.alarmRingtone)
  }
  if (userSettings.ringOnVibrate) {
    AlarmManager.updateRingOnVibratePreferences(userSettings.ringOnVibrate)
  }
  if (userSettings.ringtoneDuration) {
    AlarmManager.updateRingtoneDurationPreferences(
      userSettings.ringtoneDuration
    )
  }
  if (userSettings.autoSnooze) {
    AlarmManager.updateAutoSnoozePreferences(
      userSettings.autoSnooze,
      userSettings.autoSnoozeDuration || GlobalConfig.defaultAutoSnoozeDuration,
      userSettings.autoSnoozeCount || GlobalConfig.defaultAutoSnoozeCount
    )
  }
  if (userSettings.ringOnEarphoneOnly) {
    AlarmManager.updateRingOnEarphoneOnlyPreferences(
      userSettings.ringOnEarphoneOnly
    )
  }
  if (userSettings.gestureToDismissAnAlarm) {
    AlarmManager.updateGestureToDismissAnAlarmPreferences(
      userSettings.gestureToDismissAnAlarm
    )
  }
  if (userSettings.graduallyIncreaseVolume) {
    AlarmManager.updateGraduallyIncreaseVolumePreferences(
      userSettings.graduallyIncreaseVolume
    )
  }
  if (userSettings.pinMode) {
    AlarmManager.updatePinModePreferences(userSettings.pinMode)
  }
  if (userSettings.timeFormat) {
    AlarmManager.updateTimeFormatPreferences(userSettings.timeFormat)
  }
  if (userSettings.announceAlarmName) {
    AlarmManager.updateAnnounceAlarmNamePreferences(
      userSettings.announceAlarmName
    )
  }
  if (userSettings.muteAlarms) {
    AlarmManager.muteAlarms(userSettings.muteAlarms)
  }
}

const updateRingParticipantAlarmByDefaultUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setRingParticipantAlarmsByDefault(newValue))
    GlobalConfig.ringParticipantAlarmsByDefault = newValue

    // Schedule or cancel notifications for participants alarms that has not been
    // responded yet based on the new value
    const backupAlarms = participantAlarmsSelector(getState())
    backupAlarms
      .filter(alarm => {
        return (
          alarm.responseStatus === Constants.ALARM_RESPONSE_PENDING &&
          alarm.status === true
        )
      })
      .forEach(alarm => {
        if (newValue === true) {
          scheduleNotificationForParticipantAlarm(
            alarm,
            getState().contacts.contacts
          )
        } else {
          AlarmManager.cancelNotifications(alarm.id)
        }
      })

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/ringParticipantAlarmsByDefault`
        ),
        newValue
      )
    } else {
      console.log(
        'Adding update ring participant alarms by default setting pending action'
      )
      dispatch(
        addUpdateRingParticipantAlarmsByDefaultSettingSoftPendingAction(
          newValue
        )
      )
    }
  }

const updateGraduallyIncreaseVolumeUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setGraduallyIncreaseVolume(newValue))

    AlarmManager.updateGraduallyIncreaseVolumePreferences(newValue)

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/graduallyIncreaseVolume`
        ),
        newValue
      )
    } else {
      console.log('Adding update gradually increase volume pending action')
      dispatch(addUpdateGraduallyIncreaseVolumeSoftPendingAction(newValue))
    }
  }

const updateShakeToStopAlarmUserSetting = newValue => (dispatch, getState) => {
  dispatch(setShakeToStopAlarm(newValue))

  AlarmManager.updateShakeToStopAlarmPreferences(newValue)

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/shakeToStopAlarm`
      ),
      newValue
    )
  } else {
    console.log('Adding update shake to stop alarm pending action')
    dispatch(addUpdateShakeToStopAlarmSoftPendingAction(newValue))
  }
}

const updateShakeSensitivityUserSetting = newValue => (dispatch, getState) => {
  dispatch(setShakeSensitivity(newValue))

  AlarmManager.updateShakeSensitivityPreferences(newValue)

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/shakeSensitivity`
      ),
      newValue
    )
  } else {
    console.log('Adding update shake sensitivity pending action')
    dispatch(addUpdateShakeSensitivitySoftPendingAction(newValue))
  }
}

const updatePinModeUserSetting = newValue => (dispatch, getState) => {
  dispatch(setPinMode(newValue))

  AlarmManager.updatePinModePreferences(newValue)

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/pinMode`
      ),
      newValue
    )
  } else {
    console.log('Adding update pin mode pending action')
    dispatch(addUpdatePinModeSoftPendingAction(newValue))
  }
}

const updateNotificationActionBehaviorUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setNotificationActionBehavior(newValue))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/notificationActionBehavior`
        ),
        newValue
      )
    } else {
      console.log('Adding update notification action behavior pending action')
      dispatch(addUpdateNotificationActionBehaviorSoftPendingAction(newValue))
    }
  }

const updatePromptForUpdateUserSetting = newValue => (dispatch, getState) => {
  dispatch(setPromptForUpdate(newValue))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/promptForUpdate`
      ),
      newValue
    )
  } else {
    console.log('Adding update prompt for update pending action')
    dispatch(addUpdatePromptForUpdateSoftPendingAction(newValue))
  }
}

const updateSortAlarmCategoriesByUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setSortAlarmCategoriesBy(newValue))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/sortAlarmCategoriesBy`
        ),
        newValue
      )
    } else {
      console.log('Adding update sort alarm categories by pending action')
      dispatch(addUpdateSortAlarmCategoriesBySoftPendingAction(newValue))
    }
  }

const updateMissedAlarmPlacementSettingUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setMissedAlarmPlacementSetting(newValue))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/missedAlarmPlacementSetting`
        ),
        newValue
      )
    } else {
      console.log('Adding update missed alarm placement setting pending action')
      dispatch(addUpdateMissedAlarmPlacementSettingSoftPendingAction(newValue))
    }
  }

const updateFabButtonBehaviorUserSetting = newValue => (dispatch, getState) => {
  dispatch(setFabButtonBehavior(newValue))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/fabButtonBehavior`
      ),
      newValue
    )
  } else {
    console.log('Adding update fab button behavior pending action')
    dispatch(addUpdateFabButtonBehaviorSoftPendingAction(newValue))
  }
}

const updateGestureToDismissAnAlarmUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setGestureToDismissAnAlarm(newValue))

    AlarmManager.updateGestureToDismissAnAlarmPreferences(newValue)

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/gestureToDismissAnAlarm`
        ),
        newValue
      )
    } else {
      console.log('Adding update ring on earphone only pending action')
      dispatch(addUpdateGestureToDimissAnAlarmSoftPendingAction(newValue))
    }
  }

const updateEnhancedNotificationsUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setEnhancedNotifications(newValue))
    GlobalConfig.enhancedNotifications = newValue

    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/enhancedNotifications`
      ),
      newValue
    )

    if (!newValue) {
      const cancelNotificationForAlarmTaskPromises = []

      // Find alarms that are scheduled remotely
      const myAlarms = ownAlarmsSelector(getState())

      // Call cancelNotificationForAlarm task for those alarms
      // and schedule those alarms locally
      myAlarms
        .filter(alarm => alarm.scheduledRemotely)
        .forEach(alarm => {
          // Cancel remote notifications for such alarms
          cancelNotificationForAlarmTaskPromises.push(
            TaskManager.addHttpsCloudTask('cancelNotificationForAlarm', {
              uid: GlobalConfig.uid,
              alarmId: alarm.id
            })
          )
          // Schedule local notifications for such alarms
          dispatch(
            scheduleNotificationForOwnAlarm({
              ...alarm,
              scheduledRemotely: false
            })
          )
        })

      Promise.all(cancelNotificationForAlarmTaskPromises)
        .then(() => {
          console.log('All cancelNotificationForAlarm tasks completed')
        })
        .catch(error => {
          console.error(
            'Error completing cancelNotificationForAlarm tasks:',
            error
          )
        })
    }
  }

const updateAppTerminatedNotificationUserSetting =
  // eslint-disable-next-line no-unused-vars
  newValue => (dispatch, getState) => {
    dispatch(setAppTerminatedNotification(newValue))

    // Write to native UserDefaults for iOS so it can be read during app termination
    if (Platform.OS === 'ios') {
      const { NativeModules } = require('react-native')
      if (
        NativeModules.DeviceState &&
        NativeModules.DeviceState.setAppTerminatedNotification
      ) {
        NativeModules.DeviceState.setAppTerminatedNotification(newValue)
      }
    }
  }

const updatePreReminderRingtoneUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setPreReminderRingtone(newValue))
    GlobalConfig.preReminderRingtone = newValue

    AlarmManager.updatePreReminderRingtonePreferences(newValue)

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/preReminderRingtone`
        ),
        newValue
      )
    } else {
      console.log('Adding update pre reminder ringtone pending action')
      dispatch(addUpdatePreReminderRingtoneSoftPendingAction(newValue))
    }
  }

const updateTimerRingtoneUserSetting = newValue => (dispatch, getState) => {
  dispatch(setTimerRingtone(newValue))
  GlobalConfig.timerRingtone = newValue

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/timerRingtone`
      ),
      newValue
    )
  } else {
    console.log('Adding update timer ringtone pending action')
    dispatch(addUpdateTimerRingtoneSoftPendingAction(newValue))
  }
}

const updateMuteAlarmsUserSetting = newValue => (dispatch, getState) => {
  dispatch(setMuteAlarms(newValue))
  GlobalConfig.muteAlarms = newValue

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `userSettings/${GlobalConfig.uid}/muteAlarms`
      ),
      newValue
    )
  } else {
    console.log('Adding update mute alarms pending action')
    dispatch(addUpdateMuteAlarmsSoftPendingAction(newValue))
  }
}

const updateRingOnEarphoneOnlyUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setRingOnEarphoneOnly(newValue))

    AlarmManager.updateRingOnEarphoneOnlyPreferences(newValue)

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/ringOnEarphoneOnly`
        ),
        newValue
      )
    } else {
      console.log('Adding update ring on earphone only pending action')
      dispatch(addUpdateRingOnEarphoneOnlySoftPendingAction(newValue))
    }
  }
const updateDefaultTimezoneForAlarmUserSetting =
  // eslint-disable-next-line no-unused-vars
  newValue => (dispatch, getState) => {
    dispatch(setDefaultTimezoneForAlarm(newValue))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/defaultTimezoneForAlarm`
        ),
        newValue
      )
    } else {
      console.log(
        'Adding update default timezone for buddy alarm pending action'
      )
      dispatch(addUpdateDefaultTimezoneForAlarmSoftPendingAction(newValue))
    }
  }

const updateTimezoneForAllAlarms = newValue => (dispatch, getState) => {
  let creatorTimezone
  let timezoneSetting
  if (newValue) {
    creatorTimezone = newValue
    timezoneSetting = Constants.TIMEZONE_SETTINGS.EXPLICIT
  }
  // If a timezone is unselected, then change it back to default
  else {
    creatorTimezone = RNLocalize.getTimeZone()
    timezoneSetting = Constants.TIMEZONE_SETTINGS.DEVICE
  }

  const myAlarms = ownAlarmsSelector(getState())
  const firebaseUpdate = {}
  myAlarms.forEach(alarm => {
    const newDate = moment.tz(alarm.dateString, creatorTimezone).valueOf()
    firebaseUpdate['alarms/' + alarm.id + '/date'] = newDate
    firebaseUpdate['alarms/' + alarm.id + '/timezoneSetting'] = timezoneSetting
    firebaseUpdate['alarms/' + alarm.id + '/creatorTimezone'] = creatorTimezone
    firebaseUpdate['alarms/' + alarm.id + '/lastUpdatedAt'] = Date.now()
  })

  return GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdate
  )
}

const updateRingerSettingsForAllAlarms =
  ringerSettings => (dispatch, getState) => {
    const myAlarms = ownAlarmsSelector(getState())
    const backupAlarms = participantAlarmsSelector(getState())
    const firebaseUpdate = {}
    const currDate = Date.now()

    // On iOS, if an alarm already has a higher snooze count (> 2 or unlimited),
    // preserve it — global settings don't allow setting higher counts on iOS.
    const getEffectiveRingerSettings = currentAutoSnoozeCount => {
      if (
        Platform.OS === 'ios' &&
        (currentAutoSnoozeCount === -1 || currentAutoSnoozeCount > 2)
      ) {
        return { ...ringerSettings, autoSnoozeCount: currentAutoSnoozeCount }
      }
      return ringerSettings
    }

    // Process own alarms and update the ringtone settings
    myAlarms.forEach(alarm => {
      const effectiveRingerSettings = getEffectiveRingerSettings(
        alarm.ringerSettings?.autoSnoozeCount
      )
      const updateObj =
        AlarmUtils.createFirebaseObjForUpdatingAlarmRingerSettings(
          alarm,
          effectiveRingerSettings
        )

      updateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate

      Object.assign(firebaseUpdate, updateObj)
    })

    // Process backup alarms and update the ringtone settings
    backupAlarms.forEach(alarm => {
      const firebaseUpdateObj =
        AlarmUtils.createFirebaseObjForUpdatingParticipantAlarmRingerSettings(
          alarm,
          ringerSettings
        )

      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate

      Object.assign(firebaseUpdate, firebaseUpdateObj)
    })
    return GlobalConfig.firebaseHelpers.updateData(
      GlobalConfig.rootFirebaseRef,
      firebaseUpdate
    )
  }

const updateSpecifyTimezoneForAlarmUserSetting =
  newValue => (dispatch, getState) => {
    dispatch(setSpecifyTimezoneForAlarm(newValue))
    GlobalConfig.specifyTimezoneForAlarm = newValue

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/specifyTimezoneForAlarm`
        ),
        newValue
      )
      if (!newValue) {
        GlobalConfig.firebaseHelpers.setData(
          GlobalConfig.firebaseHelpers.createRef(
            `userSettings/${GlobalConfig.uid}/defaultTimezoneForAlarm`
          ),
          ''
        )
      }
    } else {
      console.log(
        'Adding update specify timezone for buddy alarm pending action'
      )
      dispatch(addUpdateSpecifyTimezoneForAlarmSoftPendingAction(newValue))
    }
  }

const updateGlobalAlarmRingerSettings =
  ringerSettings => (dispatch, getState) => {
    dispatch(setGlobalAlarmRingerSettings(ringerSettings))
    GlobalConfig.alarmRingtone = ringerSettings.alarmRingtone
    GlobalConfig.vibrate = ringerSettings.vibrate
    GlobalConfig.volume = ringerSettings.volume
    GlobalConfig.ringtoneDuration = ringerSettings.ringtoneDuration
    GlobalConfig.ringOnVibrate = ringerSettings.ringOnVibrate
    GlobalConfig.autoSnooze = ringerSettings.autoSnooze
    GlobalConfig.autoSnoozeDuration = ringerSettings.autoSnoozeDuration
    GlobalConfig.autoSnoozeCount = ringerSettings.autoSnoozeCount
    GlobalConfig.announceAlarmName = ringerSettings.announceAlarmName
    GlobalConfig.criticalAlerts = ringerSettings.criticalAlerts
    GlobalConfig.criticalAlertsVolume = ringerSettings.criticalAlertsVolume

    if (Platform.OS === 'android') {
      // Update shared prefrences on the android native side
      AlarmManager.updateRingtonePreferences(ringerSettings.alarmRingtone)
      AlarmManager.updateVibratePreferences(ringerSettings.vibrate)
      AlarmManager.updateVolumePreferences(ringerSettings.volume)
      AlarmManager.updateRingOnVibratePreferences(ringerSettings.ringOnVibrate)
      AlarmManager.updateRingtoneDurationPreferences(
        ringerSettings.ringtoneDuration
      )
      AlarmManager.updateAutoSnoozePreferences(
        ringerSettings.autoSnooze,
        ringerSettings.autoSnoozeDuration,
        ringerSettings.autoSnoozeCount
      )
      AlarmManager.updateAnnounceAlarmNamePreferences(
        ringerSettings.announceAlarmName
      )
    }

    if (Platform.OS === 'ios') {
      // Reschedule existing participant alarms that don't have a ringtone set
      const backupAlarms = participantAlarmsSelector(getState())
      backupAlarms.forEach(alarm => {
        const participant = AlarmUtils.getAlarmParticipant(alarm)

        // If the participant alarm has custom ringone specified, don't reschedule
        if (participant.ringerSettings) {
          return
        }

        scheduleNotificationForParticipantAlarm(
          alarm,
          getState().contacts.contacts
        )
      })
    }

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.updateData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}`
        ),
        ringerSettings
      )
    } else {
      console.log('Adding update alarm global ringer settings pending action')
      dispatch(
        addUpdateGlobalAlarmRingerSettingsSoftPendingAction(ringerSettings)
      )
    }
  }

const updateTimeFormatUserSetting = newValue => dispatch => {
  GlobalConfig.timeFormat = newValue
  dispatch(setTimeFormat(newValue))
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userSettings/${GlobalConfig.uid}/timeFormat`
    ),
    newValue
  )
  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.CHANGED_TIME_FORMAT, {
    [Constants.UserAnalyticsEventParameters.TIME_FORMAT_VALUE]: newValue
  })
  // Update shared prefrences on the native side
  AlarmManager.updateTimeFormatPreferences(newValue)
}

// eslint-disable-next-line no-unused-vars
const updateAppEnvInfo = () => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.firebaseHelpers.createRef(`userInfos/${GlobalConfig.uid}`),
    {
      deviceLocale: I18n.currentLocale(),
      deviceOs: Platform.OS
    }
  )
}

// eslint-disable-next-line no-unused-vars
const handleExistingAlarmsLoaded = () => (dispatch, getState) => {
  dispatch(setExistingAlarmsLoaded())

  // Once the existing alarms are loaded, we can check if the user has
  // changed timezone and handle it accordingly.
  AlarmUtilsWithExtras.getTimezone().then(timezoneString => {
    dispatch(updateTimezoneAndHandleTimezoneChangeIfNeeded(timezoneString))
  })
}

const updateTimezoneAndHandleTimezoneChangeIfNeeded =
  currentTimezone =>
  (
    dispatch,
    getState // eslint-disable-line no-unused-vars
  ) => {
    const isAuthenticated = getState().appState.authenticatedWithFirebase
    if (!isAuthenticated) {
      return
    }

    const currentTimezoneOffset =
      DateTimeUtils.getTimezoneOffsetForTimezone(currentTimezone)

    let promises = [],
      previousTimezone,
      previousTimezoneOffset

    promises.push(
      GlobalConfig.firebaseHelpers
        .getData(
          GlobalConfig.firebaseHelpers.createRef(
            `userInfos/${GlobalConfig.uid}/timezone`
          )
        )
        .then(snapshot => snapshot.val())
    )
    promises.push(
      GlobalConfig.firebaseHelpers
        .getData(
          GlobalConfig.firebaseHelpers.createRef(
            `userInfos/${GlobalConfig.uid}/timezoneOffset`
          )
        )
        .then(snapshot => snapshot.val())
    )
    Promise.all(promises)
      .then(values => {
        previousTimezone = values[0]
        previousTimezoneOffset = values[1]

        console.log(
          'updateTimezoneAndHandleTimezoneChangeIfNeeded ' +
            previousTimezone +
            ' ' +
            currentTimezone +
            ' ' +
            previousTimezoneOffset +
            ' ' +
            currentTimezoneOffset
        )

        return dispatch(
          handleTimezoneChange(
            currentTimezoneOffset,
            previousTimezoneOffset,
            currentTimezone
          )
        )
      })
      .then(() => {
        if (
          !previousTimezone ||
          !previousTimezoneOffset ||
          previousTimezone !== currentTimezone ||
          previousTimezoneOffset !== currentTimezoneOffset
        ) {
          GlobalConfig.firebaseHelpers
            .updateData(
              GlobalConfig.firebaseHelpers.createRef(
                `userInfos/${GlobalConfig.uid}`
              ),
              {
                timezone: currentTimezone,
                timezoneOffset: currentTimezoneOffset
              }
            )
            .then(() => {
              // This is a fallback for very old alarms which do not have timezone set.
              !previousTimezone &&
                TaskManager.addHttpsCloudTask(
                  'updateCreatorTimezoneForAlarms',
                  {
                    uid: GlobalConfig.uid,
                    timezone: currentTimezone
                  }
                )
            })
        }
      })
  }

const handleTimezoneChange =
  (currentTimezoneOffset, previousTimezoneOffset, currentTimezone) =>
  (dispatch, getState) => {
    console.log('Handling timezone change')

    // The timezone offset is in mins. Get the difference in time in msec. This is the amount time by which
    // the alarms needs to be shifted such that they ring at the right time. For e.g. if an alarm is set for
    // 9 AM IST, it is 10:30 PM EST. The timezone offset for IST is -330 mins. The timezone offset for EST is
    // 300 mins. If the person were to move from IST to EST, we will add 300 - (-330) = 630 mins to the time.
    // which will become 9 AM EST
    const ref = GlobalConfig.rootFirebaseRef
    let firebaseUpdateObj = {}
    let participantIds = []
    const currDate = Date.now()
    const alarms = ownAlarmsSelector(getState())
    let isDstChange = false,
      dstStart = true
    alarms.forEach(alarm => {
      // We don't need to adjust the time if the timezone setting is explicit
      if (
        !alarm.dateString ||
        alarm.timezoneSetting === Constants.TIMEZONE_SETTINGS.EXPLICIT
      ) {
        return
      }

      // It should be AND as otherwise, DST changes would be skipped as the
      // timezone string remains the same but the offset changes
      if (
        alarm.creatorTimezone === currentTimezone &&
        alarm.creatorTimezoneOffset === currentTimezoneOffset
      ) {
        return
      }

      // Update the alarm time
      const alarmDateString = alarm.dateString
      const newAlarmDate = DateTimeUtils.getDateFromFormattedDateString(
        alarmDateString,
        currentTimezone
      )

      // This condition takes care of DST. If there is a change in timezone offset
      // but the time is still same, it means the person didn't move to a timezone
      // where the time was always different
      if (newAlarmDate === alarm.date) {
        isDstChange = true
        dstStart = !!(previousTimezoneOffset - currentTimezoneOffset)
      }

      // Convert firstAlarmDate and endDate independently through their
      // wall-clock representations to avoid DST-related errors. Using
      // changeInTime (derived from alarm.date) is incorrect when
      // firstAlarmDate/endDate fall on dates with a different DST state.
      let newFirstAlarmDate = alarm.firstAlarmDate
        ? DateTimeUtils.getDateFromFormattedDateString(
            DateTimeUtils.getFormattedDateAsStringInTimezone(
              alarm.firstAlarmDate,
              alarm.creatorTimezone
            ),
            currentTimezone
          )
        : newAlarmDate

      // Self-healing: ensure firstAlarmDate has the same time (HH:mm)
      // as the alarm date. If they differ (e.g. due to prior DST bugs),
      // correct the time while preserving the date.
      if (newFirstAlarmDate && newFirstAlarmDate !== newAlarmDate) {
        const alarmMoment = moment.tz(newAlarmDate, currentTimezone)
        const firstAlarmMoment = moment.tz(newFirstAlarmDate, currentTimezone)
        if (
          firstAlarmMoment.hour() !== alarmMoment.hour() ||
          firstAlarmMoment.minute() !== alarmMoment.minute()
        ) {
          newFirstAlarmDate = firstAlarmMoment
            .hour(alarmMoment.hour())
            .minute(alarmMoment.minute())
            .valueOf()
        }
      }

      const newAlarmEndDate = alarm.endDate
        ? DateTimeUtils.getDateFromFormattedDateString(
            DateTimeUtils.getFormattedDateAsStringInTimezone(
              alarm.endDate,
              alarm.creatorTimezone
            ),
            currentTimezone
          )
        : GlobalConfig.defaultAlarmEndDate

      firebaseUpdateObj['alarms/' + alarm.id + '/date'] = newAlarmDate
      firebaseUpdateObj['alarms/' + alarm.id + '/endDate'] = newAlarmEndDate
      firebaseUpdateObj['alarms/' + alarm.id + '/firstAlarmDate'] =
        newFirstAlarmDate
      firebaseUpdateObj['alarms/' + alarm.id + '/creatorTimezone'] =
        currentTimezone
      firebaseUpdateObj['alarms/' + alarm.id + '/creatorTimezoneOffset'] =
        currentTimezoneOffset
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
      // Update the userInfos object alarmDate. Not sure where the date is used right
      // now but we need to keep the data in sync. TODO: Check if the date is used
      firebaseUpdateObj[
        'userInfos/' + GlobalConfig.uid + '/alarms/' + alarm.id
      ] = newAlarmDate
      if (alarm.backupGroup && alarm.backupGroup.members) {
        firebaseUpdateObj[
          'groupInfos/' + alarm.backupGroup.id + '/backupForAlarms/' + alarm.id
        ] = newAlarmDate
        // Add the participants to the list participants which are participating in at least one of the alarms
        alarm.backupGroup.members.forEach(member => {
          if (member.state !== Constants.ParticipantStates.INACTIVE) {
            // Change the response status back to not responded only if accepted
            if (
              member.responseStatus === Constants.ACCEPT_ALARM &&
              !isDstChange
            ) {
              firebaseUpdateObj[
                'alarms/' +
                  alarm.id +
                  '/backups/group/' +
                  alarm.backupGroup.id +
                  '/members/' +
                  member.id +
                  '/responseStatus'
              ] = Constants.ALARM_RESPONSE_PENDING
            }
            participantIds.push(member.id)
          }
        })
      } else if (alarm.backupContacts && alarm.backupContacts.length > 0) {
        alarm.backupContacts.forEach(participant => {
          firebaseUpdateObj[
            'userInfos/' + participant.id + '/backupForAlarms/' + alarm.id
          ] = newAlarmDate
          // Change the response status back to not responded only if accepted
          if (
            participant.responseStatus === Constants.ACCEPT_ALARM &&
            !isDstChange
          ) {
            firebaseUpdateObj[
              'alarms/' +
                alarm.id +
                '/backups/contacts/' +
                participant.id +
                '/responseStatus'
            ] = Constants.ALARM_RESPONSE_PENDING
          }
          // Add the participants to the list participants which are participating in at least one of the alarms
          participantIds.push(participant.id)
        })
      } else if (alarm.recipient) {
        firebaseUpdateObj[
          'userInfos/' + alarm.recipient.id + '/backupForAlarms/' + alarm.id
        ] = newAlarmDate
        // Change the response status back to not responded only if accepted
        if (
          alarm.recipient.responseStatus === Constants.ACCEPT_ALARM &&
          !isDstChange
        ) {
          firebaseUpdateObj[
            'alarms/' + alarm.id + '/recipient/responseStatus'
          ] = Constants.ALARM_RESPONSE_PENDING
        }
        // Add the participants to the list participants which are participating in at least one of the alarms
        participantIds.push(alarm.recipient.id)
      }

      // Reschedule notifications if the alarm is active
      if (
        alarm.status === true &&
        (newAlarmDate > currDate || alarm.repeatType !== '')
      ) {
        dispatch(scheduleNotificationForOwnAlarm(alarm))
      } else {
        dispatch(cancelNotificationsForAlarm(alarm.id, alarm.scheduledRemotely))
      }
    })

    // No change detected, return
    if (isEmpty(firebaseUpdateObj)) {
      return Promise.resolve()
    }

    if (!isDstChange) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('adjustingAlarmsAfterTimezoneChange'),
        duration: Constants.AlertDurations.LONG
      })
    }

    // Update the alarms
    return GlobalConfig.firebaseHelpers
      .updateData(ref, firebaseUpdateObj)
      .then(() => {
        // Add a task to notify the participants of timezone change
        const uniqueParticipantIds = arrayUniq(participantIds)
        if (uniqueParticipantIds.length > 0)
          TaskManager.addHttpsCloudTask('notifyParticipantsOfTimezoneChange', {
            uid: GlobalConfig.uid,
            currentTimezoneOffset,
            participantIds: JSON.stringify(uniqueParticipantIds),
            isDstChange,
            dstStart
          })
      })
      .catch(error => {
        LogUtils.logError(
          error,
          'Unable to resync participant alarms after detecting timezone change'
        )
      })
  }

const deleteUserAvatar = uid => dispatch => {
  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('deletingImageFromServer')
  )

  let imageFullImageDeletePromise = FirebaseProxy.deleteFile(
    FirebaseProxy.createStorageRef('/images/' + uid + '/avatarFullImage.jpg')
  )
  let imageThumbnailDeletePromise = FirebaseProxy.deleteFile(
    FirebaseProxy.createStorageRef('/images/' + uid + '/avatarThumbnail.jpg')
  )

  let promises = []
  promises.push(imageFullImageDeletePromise)
  promises.push(imageThumbnailDeletePromise)

  return Promise.all(promises)
    .then(() => {
      GlobalConfig.firebaseHelpers.removeData(
        GlobalConfig.firebaseHelpers.createRef(`userInfos/${uid}/images`)
      )

      dispatch(deleteUserAvatarImages())

      NavigationUtils.dismissProgress()
    })
    .catch(error => {
      LogUtils.logError(
        error,
        'Error deleting avatar image from server for user: ' + uid
      )
      GlobalConfig.firebaseHelpers.removeData(
        GlobalConfig.firebaseHelpers.createRef(`userInfos/${uid}/images`)
      )

      dispatch(deleteUserAvatarImages())

      NavigationUtils.dismissProgress()
    })
}

const uploadImage = (image, location, metadata) => dispatch => {
  const updatedOn = Date.now()

  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('uploadingImageToServer')
  )

  const imageRef = FirebaseProxy.createStorageRef(location)
  const customMetadata = {
    ...metadata,
    [Constants.FILE_METADATA_KEYS.UPDATED_ON]: updatedOn.toString(),
    [Constants.FILE_METADATA_KEYS.IMAGE_TYPE]: Constants.IMAGE_TYPES.FULL_IMAGE,
    [Constants.FILE_METADATA_KEYS.CACHE_CONTROL]: 'public,max-age=31536000'
  }

  const imageUploadPromise = FirebaseProxy.putFile(imageRef, image, {
    customMetadata
  })
  return imageUploadPromise
    .then(() => {
      NavigationUtils.dismissProgress()
      return FirebaseProxy.getDownloadUrl(imageRef)
    })
    .then(downloadUrl => {
      return {
        status: 'success',
        downloadUrl
      }
    })
    .catch(error => {
      LogUtils.logError(error, 'Error uploading image to server')
      dispatch(
        setProgress(
          Constants.ProgressStates.ERROR,
          I18n.t('errorUploadingImageToServer'),
          true
        )
      )
      return {
        status: 'failure'
      }
    })
}

const deleteImage = downloadUrl => () => {
  return FirebaseProxy.deleteFile(
    FirebaseProxy.createStorageRefFromUrl(downloadUrl)
  )
    .then(() => {
      return { status: 'success' }
    })
    .catch(error => {
      LogUtils.logError(error, 'Error deleting image from server')
      return {
        status: 'failure'
      }
    })
}

// Set in redux store and upload to firebase
// Assumes that the client is connected
// avatarFullImage is used in the generate_avatar_thumbnail worker
// If the key is changed, it should be changed in the worker also.
// Same for uploadGroupAvatar
// We are not storing the avatarThumbnailUpdatedOn timestamp for user avatar
// locally. May want to change it later
// eslint-disable-next-line no-unused-vars
// From the web, we pass the entire file object and from the mobile we pass the file path
// eslint-disable-next-line no-unused-vars
const uploadUserAvatar = (uid, avatar) => (dispatch, getState) => {
  const avatarUpdatedOn = Date.now()

  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('uploadingImageToServer')
  )

  const userAvatarLocation = '/images/' + uid + '/avatarFullImage.jpg'
  const imageRef = FirebaseProxy.createStorageRef(userAvatarLocation)

  const customMetadata = {
    [Constants.FILE_METADATA_KEYS.ENTITY_TYPE]: Constants.ENTITY_TYPES.USER,
    [Constants.FILE_METADATA_KEYS.UID]: uid,
    [Constants.FILE_METADATA_KEYS.UPDATED_ON]: avatarUpdatedOn.toString(),
    [Constants.FILE_METADATA_KEYS.IMAGE_TYPE]: Constants.IMAGE_TYPES.FULL_IMAGE,
    [Constants.FILE_METADATA_KEYS.CACHE_CONTROL]: 'public,max-age=31536000'
  }

  const imageUploadPromise = FirebaseProxy.putFile(imageRef, avatar, {
    customMetadata
  })
  return imageUploadPromise
    .then(() => {
      return FirebaseProxy.getDownloadUrl(imageRef)
    })
    .then(profileImagePath => {
      GlobalConfig.firebaseHelpers.updateData(
        GlobalConfig.firebaseHelpers.createRef(`userInfos/${uid}/images`),
        {
          avatarFullImageUrl: profileImagePath,
          avatarFullImageUpdatedOn: avatarUpdatedOn
        }
      )

      if (avatar !== undefined) {
        FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.UPLOAD_NEW_PROFILE_IMAGE,
          {
            [Constants.UserAnalyticsEventParameters.ENTRY_POINT]:
              Constants.NEW_PROFILE_IMAGE_ENTRY_POINTS.USER
          }
        )
      }
      const images = {
        avatarThumbnailUrl: profileImagePath,
        avatarFullImageUrl: profileImagePath,
        avatarFullImageUpdatedOn: avatarUpdatedOn,
        avatarThumbnailUpdatedOn: avatarUpdatedOn
      }

      dispatch(setUserAvatarImages(images))

      NavigationUtils.dismissProgress()
    })
    .catch(error => {
      LogUtils.logError(error, 'Error uploading user avatar to server')
      dispatch(
        setProgress(
          Constants.ProgressStates.ERROR,
          I18n.t('errorUploadingImageToServer'),
          true
        )
      )
    })
}

// eslint-disable-next-line no-unused-vars
const uploadGroupAvatar = (groupId, avatar) => (dispatch, getState) => {
  const avatarUpdatedOn = Date.now()

  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('uploadingImageToServer')
  )

  const groupAvatarLocation = '/images/' + groupId + '/avatarFullImage.jpg'
  const imageRef = FirebaseProxy.createStorageRef(groupAvatarLocation)

  const customMetadata = {
    [Constants.FILE_METADATA_KEYS.ENTITY_TYPE]: Constants.ENTITY_TYPES.GROUP,
    [Constants.FILE_METADATA_KEYS.UID]: groupId,
    [Constants.FILE_METADATA_KEYS.UPDATED_ON]: avatarUpdatedOn.toString(),
    [Constants.FILE_METADATA_KEYS.IMAGE_TYPE]: Constants.IMAGE_TYPES.FULL_IMAGE,
    [Constants.FILE_METADATA_KEYS.CACHE_CONTROL]: 'public,max-age=31536000'
  }

  const imageUploadPromise = FirebaseProxy.putFile(imageRef, avatar, {
    customMetadata
  })
  return imageUploadPromise
    .then(() => {
      return FirebaseProxy.getDownloadUrl(imageRef)
    })
    .then(profileImagePath => {
      GlobalConfig.firebaseHelpers.updateData(
        GlobalConfig.firebaseHelpers.createRef(`groups/${groupId}/images`),
        {
          avatarFullImageUrl: profileImagePath,
          avatarFullImageUpdatedOn: avatarUpdatedOn
        }
      )

      if (avatar !== undefined) {
        FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.UPLOAD_NEW_PROFILE_IMAGE,
          {
            [Constants.UserAnalyticsEventParameters.ENTRY_POINT]:
              Constants.NEW_PROFILE_IMAGE_ENTRY_POINTS.GROUP
          }
        )
      }
      const images = {
        avatarThumbnailUrl: profileImagePath,
        avatarFullImageUrl: profileImagePath,
        avatarFullImageUpdatedOn: avatarUpdatedOn,
        avatarThumbnailUpdatedOn: avatarUpdatedOn
      }

      dispatch(updateGroupAvatarImages(groupId, images))

      NavigationUtils.dismissProgress()
    })
    .catch(error => {
      LogUtils.logError(error, 'Error uploading group avatar to server')
      dispatch(
        setProgress(
          Constants.ProgressStates.ERROR,
          I18n.t('errorUploadingImageToServer'),
          true
        )
      )
    })
}

const deleteGroupAvatar = groupId => dispatch => {
  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('deletingImageFromServer')
  )

  let imageFullImageDeletePromise = FirebaseProxy.deleteFile(
    FirebaseProxy.createStorageRef(
      '/images/' + groupId + '/avatarFullImage.jpg'
    )
  )
  let imageThumbnailDeletePromise = FirebaseProxy.deleteFile(
    FirebaseProxy.createStorageRef(
      '/images/' + groupId + '/avatarThumbnail.jpg'
    )
  )

  let promises = []
  promises.push(imageFullImageDeletePromise)
  promises.push(imageThumbnailDeletePromise)

  return Promise.all(promises)
    .then(() => {
      GlobalConfig.firebaseHelpers.removeData(
        GlobalConfig.firebaseHelpers.createRef(`groups/${groupId}/images`)
      )

      dispatch(deleteGroupAvatarImages(groupId))

      NavigationUtils.dismissProgress()
    })
    .catch(error => {
      LogUtils.logError(
        error,
        'Error deleting avatar image from server for group: ' + groupId
      )
      GlobalConfig.firebaseHelpers.removeData(
        GlobalConfig.firebaseHelpers.createRef(`groups/${groupId}/images`)
      )

      dispatch(deleteGroupAvatarImages(groupId))

      NavigationUtils.dismissProgress()
    })
}

const loadGroups = () => (dispatch, getState) => {
  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/groups`
    ),
    snapshot => {
      const groupId = snapshot.key
      const groupData = snapshot.val()
      const existingGroup = Utils.getObjectWithId(
        getState().groups.groups,
        groupId
      )
      if (
        !existingGroup ||
        (groupData.lastUpdatedAt &&
          existingGroup.lastUpdatedAt !== groupData.lastUpdatedAt)
      ) {
        // Update the group in the redux store
        dispatch(updateGroup(groupId, groupData))
      }

      FirebaseManager.addFirebaseRefValueChanged(
        'App',
        GlobalConfig.firebaseHelpers.createRef(`groups/${groupId}/images`),
        imagesSnapshot => {
          const newExistingGroup = Utils.getObjectWithId(
            getState().groups.groups,
            groupId
          )
          if (!newExistingGroup) {
            return
          }
          const existingImages = newExistingGroup.images

          if (imagesSnapshot.exists()) {
            const newImages = imagesSnapshot.val()
            if (!isObjEqual(existingImages, newImages)) {
              dispatch(updateGroupAvatarImages(groupId, newImages))
            }
          } else if (!isEmpty(existingImages)) {
            dispatch(deleteGroupAvatarImages(groupId))
          }
        }
      )
    }
  )

  FirebaseManager.addFirebaseRefChildChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/groups`
    ),
    snapshot => {
      const groupId = snapshot.key
      const groupData = snapshot.val()
      const existingGroup = Utils.getObjectWithId(
        getState().groups.groups,
        groupId
      )
      if (
        !existingGroup ||
        (groupData.lastUpdatedAt &&
          existingGroup.lastUpdatedAt !== groupData.lastUpdatedAt)
      ) {
        // Update the group in the redux store
        dispatch(updateGroup(groupId, groupData))
      }
    }
  )

  // Group deletion not allowed at the moment

  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/removedFromGroups`
    ),
    snapshot => {
      const groupId = snapshot.key
      const groupData = snapshot.val()
      const existingGroup = Utils.getObjectWithId(
        getState().groups.groups,
        groupId
      )
      if (
        !existingGroup ||
        (groupData.lastUpdatedAt &&
          existingGroup.lastUpdatedAt !== groupData.lastUpdatedAt)
      ) {
        // Update the group in the redux store
        dispatch(updateGroup(groupId, groupData, true))
      }
      FirebaseManager.unbindFirebaseEventHandlerForValueChanged(
        'App',
        GlobalConfig.firebaseHelpers.createRef(
          `images/${groupId}/avatarThumbnailUpdatedOn`
        )
      )
    }
  )

  FirebaseManager.addFirebaseRefChildRemoved(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/removedFromGroups`
    ),
    snapshot => {
      const groupId = snapshot.key
      // Make sure the group doesn't exist for user before removing it.
      // If the member is added back to the group, the group is removed from
      // removedFromGroups and added back to groups. In that case, we don't want
      // to remove the group locally but only update its status
      GlobalConfig.firebaseHelpers
        .getData(
          GlobalConfig.firebaseHelpers.createRef(
            `userInfos/${GlobalConfig.uid}/groups/${groupId}/id`
          )
        )
        .then(groupSnapshot => {
          if (!groupSnapshot.exists()) {
            // Remove the group from the redux store
            dispatch(removeGroup(groupId))
          }
        })
    }
  )
}

// TODO: Implement contact deletion if user removes the contact from the phone contacts
// Need to define what would happen to the alarms which have that contact as a backup
// because this will happen in the background and user can't be informed like we do in group deletion
const loadContacts = () => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(
        `userInfos/${GlobalConfig.uid}/contacts`
      )
    )
    .then(contactsSnapshot => {
      if (contactsSnapshot.exists()) {
        let contacts = []
        contactsSnapshot.forEach(snapshot => {
          contacts.push(snapshot.val())
        })
        dispatch(addContacts(contacts))
      }

      FirebaseManager.addFirebaseRefChildAdded(
        'App',
        GlobalConfig.firebaseHelpers.createRef(
          `userInfos/${GlobalConfig.uid}/contacts`
        ),
        snapshot => {
          const contact = snapshot.val()
          const contactId = contact.id
          const contactName = contact.name
          const contactMobileNumber = contact.mobileNumber
          const contactSource = contact.source
          const existingContact = Utils.getObjectWithId(
            getState().contacts.contacts,
            contactId
          )
          const dontUpdateContact =
            existingContact &&
            existingContact.id === contactId &&
            existingContact.name === contactName &&
            existingContact.mobileNumber === contactMobileNumber &&
            existingContact.source === contactSource
          if (!dontUpdateContact) {
            dispatch(addContact(contact))
          }

          FirebaseManager.addFirebaseRefValueChanged(
            'App',
            GlobalConfig.firebaseHelpers.createRef(
              `userInfos/${contactId}/images`
            ),
            imagesSnapshot => {
              const newExistingContact = Utils.getObjectWithId(
                getState().contacts.contacts,
                contactId
              )

              if (!newExistingContact) {
                return
              }
              const existingImages = newExistingContact.images

              if (imagesSnapshot.exists()) {
                const newImages = imagesSnapshot.val()
                if (!isObjEqual(existingImages, newImages)) {
                  dispatch(setContactAvatarImages(contactId, newImages))
                }
              } else if (!isEmpty(existingImages)) {
                dispatch(deleteContactAvatarImages(contactId))
              }
            }
          )
        }
      )
    })

  FirebaseManager.addFirebaseRefChildChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/contacts`
    ),
    snapshot => {
      const contact = snapshot.val()
      const contactId = contact.id
      const contactName = contact.name
      const contactMobileNumber = contact.mobileNumber
      const contactSource = contact.source
      const existingContact = Utils.getObjectWithId(
        getState().contacts.contacts,
        contactId
      )
      const dontUpdateContact =
        existingContact &&
        existingContact.id === contactId &&
        existingContact.name === contactName &&
        existingContact.mobileNumber === contactMobileNumber &&
        existingContact.source === contactSource
      if (!dontUpdateContact) {
        dispatch(addContact(contact))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/totalNumberOfContacts`
    ),
    snapshot => {
      if (snapshot.exists()) {
        const totalNumberOfContacts = snapshot.val()
        dispatch(setTotalNumberOfContacts(totalNumberOfContacts))
      }
    }
  )

  FirebaseManager.addFirebaseRefValueChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/contactsLastUpdatedAt`
    ),
    snapshot => {
      if (snapshot.exists()) {
        const contactsLastUpdatedAt = snapshot.val()
        dispatch(setContactsLastUpdatedAt(contactsLastUpdatedAt))
      }
    }
  )

  FirebaseManager.addFirebaseRefChildRemoved(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/contacts`
    ),
    snapshot => {
      const contactId = snapshot.key
      dispatch(deleteContact(contactId))
    }
  )

  FirebaseManager.addFirebaseRefChildAdded(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/invitedContacts`
    ),
    snapshot => {
      const contact = snapshot.val()
      const contactId = contact.id
      const contactName = contact.name
      const contactMobileNumber = contact.mobileNumber
      const existingContact = Utils.getObjectWithId(
        getState().contacts.invitedContacts,
        contactId
      )
      const dontUpdateContact =
        existingContact &&
        existingContact.id === contactId &&
        existingContact.name === contactName &&
        existingContact.mobileNumber === contactMobileNumber
      if (!dontUpdateContact) {
        dispatch(addInvitedContact(contact))
      }
    }
  )

  FirebaseManager.addFirebaseRefChildChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/invitedContacts`
    ),
    snapshot => {
      const contact = snapshot.val()
      const contactId = contact.id
      const contactName = contact.name
      const contactMobileNumber = contact.mobileNumber
      const existingContact = Utils.getObjectWithId(
        getState().contacts.invitedContacts,
        contactId
      )
      const dontUpdateContact =
        existingContact &&
        existingContact.id === contactId &&
        existingContact.name === contactName &&
        existingContact.mobileNumber === contactMobileNumber
      if (!dontUpdateContact) {
        dispatch(addInvitedContact(contact))
      }
    }
  )

  FirebaseManager.addFirebaseRefChildRemoved(
    'App',
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/invitedContacts`
    ),
    snapshot => {
      const contactId = snapshot.key
      dispatch(deleteInvitedContact(contactId))
    }
  )
}

const loadConnections = () => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createRef(`connections/${GlobalConfig.uid}`)
    )
    .then(connectionsSnapshot => {
      if (!connectionsSnapshot.exists()) {
        return
      }

      let connections = []
      connectionsSnapshot.forEach(snapshot => {
        const id = snapshot.key
        const name = snapshot.val().name
        const mobileNumber = snapshot.val().mobileNumber
        const countryCode = snapshot.val().countryCode
        const existingConnection = Utils.getObjectWithId(
          getState().connections.connections,
          id
        )
        const dontUpdateConnection =
          existingConnection && existingConnection.name === name
        if (!dontUpdateConnection) {
          connections.push({
            id,
            name,
            mobileNumber,
            countryCode
          })
        }
      })

      if (connections.length > 0) {
        dispatch(addConnections(connections))
      }

      FirebaseManager.addFirebaseRefChildAdded(
        'App',
        GlobalConfig.firebaseHelpers.createRef(
          `connections/${GlobalConfig.uid}`
        ),
        snapshot => {
          const id = snapshot.key
          const connection = snapshot.val()
          const name = connection.name
          const mobileNumber = connection.mobileNumber
          const countryCode = connection.countryCode
          const existingConnection = Utils.getObjectWithId(
            getState().connections.connections,
            id
          )
          const dontUpdateConnection =
            existingConnection && existingConnection.name === name
          if (!dontUpdateConnection) {
            dispatch(addConnection(id, { name, mobileNumber, countryCode }))
          }

          FirebaseManager.addFirebaseRefValueChanged(
            'App',
            GlobalConfig.firebaseHelpers.createRef(`userInfos/${id}/images`),
            imagesSnapshot => {
              const newExistingConnection = Utils.getObjectWithId(
                getState().connections.connections,
                id
              )

              if (!newExistingConnection) {
                return
              }
              const existingImages = newExistingConnection.images

              if (imagesSnapshot.exists()) {
                const newImages = imagesSnapshot.val()
                if (!isObjEqual(existingImages, newImages)) {
                  dispatch(setConnectionAvatarImages(id, newImages))
                }
              } else if (!isEmpty(existingImages)) {
                dispatch(deleteConnectionAvatarImages(id))
              }
            }
          )
        }
      )
    })

  FirebaseManager.addFirebaseRefChildChanged(
    'App',
    GlobalConfig.firebaseHelpers.createRef(`connections/${GlobalConfig.uid}`),
    snapshot => {
      const id = snapshot.key
      const name = snapshot.val().name
      const mobileNumber = snapshot.val().mobileNumber
      const countryCode = snapshot.val().countryCode
      const existingConnection = Utils.getObjectWithId(
        getState().connections.connections,
        id
      )
      const dontUpdateConnection =
        existingConnection && existingConnection.name === name
      if (!dontUpdateConnection) {
        dispatch(addConnection(id, { name, mobileNumber, countryCode }))
      }
    }
  )
}

const setPastAlarmOccurrenceResponse =
  (alarm, occurrenceTime, timestamp, response) => (dispatch, getState) => {
    dispatch(
      addAlarmAcknowledgementAction(
        alarm,
        occurrenceTime,
        GlobalConfig.uid,
        timestamp,
        response
      )
    )

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      AlarmUtils.setPastAlarmOccurrenceResponse(
        alarm,
        occurrenceTime,
        timestamp,
        response
      )
    } else {
      console.log('Adding set past alarm occurrence response pending action')
      dispatch(
        addSetPastAlarmOccurrenceResponseSoftPendingAction(
          alarm,
          occurrenceTime,
          timestamp,
          response
        )
      )
    }
  }

const markAlarmAsAcknowledged = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)

  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmDone'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'markAlarmAsAcknowledged'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.PERSONAL_ALARM_DONE
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: alarm.repeatType !== ''
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  const participants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
  const numParticipants = participants.length
  if (persistOnFirebase) {
    await AlarmUtils.markAlarmAsAcknowledgedCore(alarm, currAlarmDate, currDate)
    numParticipants > 0 &&
      NavigationUtils.showTransientAlert({
        message: I18n.t('participantsAreNotified')
      })
  } else {
    console.log('Adding mark personal alarm done pending action')
    dispatch(
      addMarkPersonalAlarmDoneSoftPendingAction(alarm, currAlarmDate, currDate)
    )
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_PERSONAL_ALARM_DONE,
    {}
  )
}

const markRecipientCreatorAlarmAsUnskipped =
  alarmId => async (dispatch, getState) => {
    const alarm = await retrieveAlarmByAlarmId(alarmId, getState)

    if (isEmpty(alarm)) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToMarkAlarmUnskipped'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'markRecipientCreatorAlarmAsUnskipped'
      })
      return
    }
    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const currDate = Date.now()
    dispatch(
      addAlarmAcknowledgementAction(
        alarm,
        currAlarmDate,
        GlobalConfig.uid,
        currDate,
        Constants.RECIPIENT_CREATOR_ALARM_UNKSIP
      )
    )

    await AlarmUtils.markRecipientCreatorAlarmAsUnskipped(
      alarm,
      currAlarmDate,
      currDate
    )
    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.MARK_RECIPIENT_CREATOR_ALARM_UNSKIPPED,
      {}
    )
  }

const markPersonalAlarmAsUnskipped = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)

  if (isEmpty(alarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmUnskipped'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'markPersonalAlarmAsUnskipped'
    })
    return
  }
  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.PERSONAL_ALARM_UNSKIP
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: true
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  await AlarmUtils.markPersonalAlarmAsUnskipped(alarm, currAlarmDate, currDate)
  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_PERSONAL_ALARM_UNSKIPPED,
    {}
  )
}

const markPersonalAlarmAsUndone = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)

  if (isEmpty(alarm)) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmUndone'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'markPersonalAlarmAsUndone'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.PERSONAL_ALARM_UNDONE
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: true
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  await AlarmUtils.markPersonalAlarmAsUndone(alarm, currAlarmDate, currDate)
  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_PERSONAL_ALARM_UNDONE,
    {}
  )
}

const skipPersonalAlarm = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToSkipAlarm'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'skipPersonalAlarm'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.PERSONAL_ALARM_SKIP
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: alarm.repeatType !== ''
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  const participants = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
  const numParticipants = participants.length
  if (persistOnFirebase) {
    await AlarmUtils.skipPersonalAlarmCore(alarm, currAlarmDate, currDate)
    numParticipants > 0 &&
      NavigationUtils.showTransientAlert({
        message: I18n.t('participantsAreNotified')
      })
  } else {
    console.log('Adding skip alarm pending action')

    dispatch(
      addSkipPersonalAlarmSoftPendingAction(alarm, currAlarmDate, currDate)
    )
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SKIP_PERSONAL_ALARM, {})
}

const markRecipientAlarmAsDone = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmDone'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'markRecipientAlarmAsDone'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.RECIPIENT_ALARM_DONE
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: alarm.repeatType !== ''
  })
  dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase
  if (persistOnFirebase) {
    await AlarmUtils.markRecipientAlarmAsDoneCore(
      alarm,
      currAlarmDate,
      currDate
    )
    const creatorName = AlarmUtils.resolveAlarmCreatorName(
      getState().contacts.contacts,
      alarm.creator,
      alarm.creatorMobileNumber,
      alarm.creatorName
    )
    NavigationUtils.showTransientAlert({
      message: I18n.t('creatorIsNotified', { creatorName })
    })
  } else {
    console.log('Adding mark recipient alarm done pending action')
    dispatch(
      addMarkRecipientAlarmDoneSoftPendingAction(alarm, currAlarmDate, currDate)
    )
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_BUDDY_ALARM_DONE,
    {}
  )
}
const markPersonalParticipantAlarmAsUnskipped =
  alarmId => async (dispatch, getState) => {
    const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
    if (!alarm) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToMarkAlarmUnskipped'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'markPersonalParticipantAlarmAsUnskipped'
      })
      return
    }

    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const currDate = Date.now()
    dispatch(
      addAlarmAcknowledgementAction(
        alarm,
        currAlarmDate,
        GlobalConfig.uid,
        currDate,
        Constants.PERSONAL_PARTICIPANT_ALARM_UNSKIP
      )
    )

    await AlarmUtils.markPersonalParticipantAlarmAsUnskipped(
      alarm,
      currAlarmDate,
      currDate
    )
    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.MARK_PERSONAL_PARTICIPANT_ALARM_UNSKIPPED,
      {}
    )
  }

const markRecipientAlarmAsUnskipped = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmUnskipped'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'markRecipientAlarmAsUnskipped'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.RECIPIENT_ALARM_UNSKIP
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: true
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  await AlarmUtils.markRecipientAlarmAsUnskipped(alarm, currAlarmDate, currDate)
  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_RECIPIENT_ALARM_UNSKIPPED,
    {}
  )
}
const markRecipientAlarmAsUndone = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToMarkAlarmUndone'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'markRecipientAlarmAsUndone'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.RECIPIENT_ALARM_UNDONE
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: true
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  await AlarmUtils.markRecipientAlarmAsUndone(alarm, currAlarmDate, currDate)
  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.MARK_BUDDY_ALARM_UNDONE,
    {}
  )
}

const skipPersonalParticipantAlarm = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToSkipAlarm'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'skipPersonalParticipantAlarm'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.PERSONAL_PARTICIPANT_ALARM_SKIP
    )
  )

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  if (persistOnFirebase) {
    await AlarmUtils.skipPersonalParticipantAlarmCore(
      alarm,
      currAlarmDate,
      currDate
    )
  } else {
    console.log('Adding skip participant alarm pending action')
    dispatch(
      addSkipPersonalParticipantAlarmSoftPendingAction(
        alarm,
        currAlarmDate,
        currDate
      )
    )
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.SKIP_PERSONAL_PARTICIPANT_ALARM,
    {}
  )
}

const skipRecipientAlarm = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToSkipAlarm'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]: 'skipRecipientAlarm'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.RECIPIENT_ALARM_SKIP
    )
  )

  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    status: alarm.repeatType !== ''
  })
  dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  if (persistOnFirebase) {
    await AlarmUtils.skipRecipientAlarmCore(alarm, currAlarmDate, currDate)
    const creatorName = AlarmUtils.resolveAlarmCreatorName(
      getState().contacts.contacts,
      alarm.creator,
      alarm.creatorMobileNumber,
      alarm.creatorName
    )
    NavigationUtils.showTransientAlert({
      message: I18n.t('creatorIsNotified', { creatorName })
    })
  } else {
    console.log('Adding skip alarm pending action')
    dispatch(
      addSkipRecipientAlarmSoftPendingAction(alarm, currAlarmDate, currDate)
    )
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SKIP_RECIPIENT_ALARM, {})
}

const skipRecipientCreatorAlarm = alarmId => async (dispatch, getState) => {
  const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
  if (!alarm) {
    NavigationUtils.showTransientAlert({
      message: I18n.t('unableToSkipAlarm'),
      duration: Constants.AlertDurations.LONG
    })
    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'skipRecipientCreatorAlarm'
    })
    return
  }

  const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
  const currDate = Date.now()
  dispatch(
    addAlarmAcknowledgementAction(
      alarm,
      currAlarmDate,
      GlobalConfig.uid,
      currDate,
      Constants.RECIPIENT_CREATOR_ALARM_SKIP
    )
  )

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  if (persistOnFirebase) {
    await AlarmUtils.skipRecipientCreatorAlarmCore(
      alarm,
      currAlarmDate,
      currDate
    )
  } else {
    console.log('Adding skip recipient creator alarm pending action')
    dispatch(
      addSkipRecipientCreatorAlarmSoftPendingAction(
        alarm,
        currAlarmDate,
        currDate
      )
    )
  }

  FirebaseProxy.logEvent(
    Constants.UserAnalyticsEvents.SKIP_RECIPIENT_CREATOR_ALARM,
    {}
  )
}

const updateRecipientAlarmDateAndTime =
  (alarmId, newRecipientDate) => async (dispatch, getState) => {
    const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
    if (!alarm) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToSaveAlarm'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'updateRecipientAlarmDateAndTime'
      })
      return
    }

    // For a RECIPIENT alarm, the stored alarm.date includes the recipientAlarmInterval
    // (it represents when the creator is reminded). The recipient's actual alarm time is
    // alarm.date - recipientAlarmInterval. When the recipient changes their alarm time,
    // we compute the new stored date accordingly.
    const recipientIntervalValue =
      Constants.RecipientAlarmIntervals[alarm.recipientAlarmInterval].value
    const newStoredDate = newRecipientDate + recipientIntervalValue
    const currDate = Date.now()

    let updatedRepeat = alarm.repeat
    if (alarm.repeatType) {
      const participantRepeat =
        AlarmUtils.adjustRepetitionStringIfParticipant(alarm)
      updatedRepeat =
        AlarmUtils.adjustRepetitionStringForRecipientAlarmIfNeeded(
          newStoredDate,
          alarm.repeatType,
          participantRepeat,
          alarm.recipientAlarmInterval,
          alarm.creatorTimezone
        )
    }

    // Capture the original recipient date before soft-updating
    const originalRecipientDate = alarm.date - recipientIntervalValue

    // Editing the time is itself a form of response - accept the alarm for the
    // recipient if they haven't already accepted it
    const shouldAcceptAlarm = alarm.responseStatus !== Constants.ACCEPT_ALARM

    // Soft-update the local participant alarm with the new date
    const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
      date: newStoredDate,
      repeat: updatedRepeat,
      lastUpdatedAt: currDate,
      ...(shouldAcceptAlarm && {
        responseStatus: Constants.ACCEPT_ALARM,
        recipient: {
          ...alarm.recipient,
          responseStatus: Constants.ACCEPT_ALARM,
          seenOn: currDate
        }
      })
    })
    dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

    // Reschedule the participant alarm notification with the new date
    const contacts = getState().contacts.contacts
    scheduleNotificationForParticipantAlarm(softUpdatedAlarm, contacts)

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (persistOnFirebase) {
      await updateRecipientAlarmDateAndTimeCore(
        softUpdatedAlarm,
        newRecipientDate,
        originalRecipientDate,
        currDate
      )

      const dateTimeString = DateTimeUtils.getDateTimeAsString(newRecipientDate)
      NavigationUtils.showTransientAlert({
        message: I18n.t('recipientUpdatedAlarmDateAndTime', { dateTimeString })
      })
    } else {
      console.log('Adding update recipient alarm date and time pending action')
      dispatch(
        addUpdateRecipientAlarmDateAndTimeSoftPendingAction(
          softUpdatedAlarm,
          newRecipientDate,
          originalRecipientDate,
          currDate
        )
      )
    }

    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.EDIT_ALARM, {
      [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type,
      [Constants.UserAnalyticsEventParameters.SOURCE]:
        'updateRecipientAlarmDateAndTime'
    })
  }

const updateRecipientAlarmDateAndTimeCore = async (
  alarm,
  newRecipientDate,
  originalRecipientDate,
  currDate
) => {
  console.log('Handling update recipient alarm date and time pending action')
  const alarmId = alarm.id
  const recipientIntervalValue =
    Constants.RecipientAlarmIntervals[alarm.recipientAlarmInterval].value
  const newStoredDate = newRecipientDate + recipientIntervalValue

  const firebaseUpdateObj = {
    [`alarms/${alarmId}/date`]: newStoredDate,
    [`alarms/${alarmId}/repeat`]: alarm.repeat,
    [`alarms/${alarmId}/lastUpdatedAt`]: currDate,
    [`alarms/${alarmId}/recipient/responseStatus`]:
      alarm.recipient.responseStatus,
    [`alarms/${alarmId}/recipient/seenOn`]: alarm.recipient.seenOn
  }
  await GlobalConfig.firebaseHelpers.updateData(
    GlobalConfig.rootFirebaseRef,
    firebaseUpdateObj
  )

  const notificationInfo = {
    type: Constants.NotificationTypes.ALARM_ADDED,
    alarmId: alarmId,
    alarmType: alarm.type,
    alarmName: alarm.name,
    alarmRecipientName: alarm.recipient?.name || I18n.t('recipient'),
    previousAlarmDate: originalRecipientDate.toString(),
    newAlarmDate: newRecipientDate.toString()
  }
  NotificationManager.sendRemoteNotification(
    alarm.creator,
    Constants.NotificationKeys.RecipientAlarmEditedByRecipientNotification,
    notificationInfo
  )

  // Notify the recipient's phone to reschedule the alarm with the updated time.
  // Only needed when the change originates from the web — the native app already
  // reschedules the local notification directly via scheduleNotificationForParticipantAlarm.
  // BACKUP_ALARM_ADDED causes the phone to fetch the latest alarm from Firebase
  // (which now has the new date) and reschedule the local notification.
  if (Platform.OS === 'web' && alarm.recipient) {
    const recipientPhoneNotificationInfo =
      getNotificationInfoForBackupAlarmAdded(alarm, alarm.order)
    NotificationManager.sendRemoteNotification(
      alarm.recipient.id,
      Constants.NotificationKeys.AddedAsRecipientNotification,
      recipientPhoneNotificationInfo
    )
  }

  const systemMessageId = GlobalConfig.firebaseHelpers.generatePushKey(
    GlobalConfig.rootFirebaseRef
  )
  const systemMessage = {
    id: systemMessageId,
    text: I18n.t('recipientChangedAlarmTimeChatMessage', {
      username: GlobalConfig.username,
      originalTime: DateTimeUtils.getDateTimeAsString(originalRecipientDate),
      newTime: DateTimeUtils.getDateTimeAsString(newRecipientDate)
    }),
    createdAt: currDate,
    userId: 'system',
    username: 'Galarm',
    system: true
  }
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `conversations/alarms/${alarmId}/${systemMessageId}`
    ),
    systemMessage
  )
}

const retrieveAlarmByAlarmId = function (alarmId, getState) {
  const alarmSelector = makeAlarmSelector()
  const alarm = alarmSelector(getState(), { alarmId })
  if (!isEmpty(alarm)) {
    return Promise.resolve(alarm)
  }

  return GlobalConfig.firebaseHelpers
    .getData(GlobalConfig.firebaseHelpers.createRef(`alarms/${alarmId}`))
    .then(snapshot => {
      if (!snapshot.exists()) {
        return null
      }

      const alarmData = snapshot.val()
      const newAlarm = AlarmUtils.createAlarm(alarmData)
      return newAlarm
    })
}

const setBackupResponseStatusForAlarm =
  (alarmId, responseStatus) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      // Sanity checks
      if (!alarm) {
        NavigationUtils.showTransientAlert({
          message: I18n.t('unableToSetAlarmResponse'),
          duration: Constants.AlertDurations.LONG
        })
        LogUtils.logError(
          new Error(
            "Can't set participant response for personal alarm action because alarm is null " +
              alarmId
          )
        )
        return
      }

      const tempSoftUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
        alarm,
        GlobalConfig.uid,
        {
          responseStatus: responseStatus,
          seenOn: Date.now()
        }
      )
      const softUpdatedAlarm = AlarmUtils.updateAlarm(tempSoftUpdatedAlarm, {
        responseStatus: responseStatus
      })

      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      AlarmUtilsWithExtras.setBackupResponseStatusForAlarm(
        alarm,
        alarm.responseStatus,
        responseStatus,
        alarm.order,
        persistOnFirebase
      )

      if (!persistOnFirebase) {
        console.log('Adding set participant alarm response pending action')

        dispatch(
          addSetParticipantAlarmResponseSoftPendingAction(alarm, responseStatus)
        )
      }

      responseStatus === Constants.ACCEPT_ALARM
        ? FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ACCEPT_ALARM, {
            [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type
          })
        : FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.DECLINE_ALARM, {
            [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type
          })
    })
  }

const setRecipientResponseStatusForAlarm =
  (alarmId, responseStatus) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      // Sanity checks
      if (!alarm) {
        NavigationUtils.showTransientAlert({
          message: I18n.t('unableToSetAlarmResponse'),
          duration: Constants.AlertDurations.LONG
        })
        LogUtils.logError(
          new Error(
            "Can't set recipient response for alarm action because alarm is null " +
              alarmId
          )
        )
        return
      }

      const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
        responseStatus: responseStatus,
        recipient: {
          ...alarm.recipient,
          responseStatus: responseStatus,
          seenOn: Date.now()
        }
      })

      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      AlarmUtilsWithExtras.setRecipientResponseStatusForAlarm(
        alarm,
        responseStatus,
        persistOnFirebase
      )

      if (!persistOnFirebase) {
        console.log('Adding set recipient alarm response pending action')

        dispatch(
          addSetRecipientAlarmResponseSoftPendingAction(alarm, responseStatus)
        )
      }

      responseStatus === Constants.ACCEPT_ALARM
        ? FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ACCEPT_ALARM, {
            [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type
          })
        : FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.DECLINE_ALARM, {
            [Constants.UserAnalyticsEventParameters.ALARM_TYPE]: alarm.type
          })
    })
  }

// Set alarmInstanceTimestamp to alarm.date as a fail safe in case user presses a notification
// action for an old alarm
const markCreatorResponseForSimultaneousAlarm =
  (alarmId, response, rescheduleAlarm) => async (dispatch, getState) => {
    const alarm = await retrieveAlarmByAlarmId(alarmId, getState)

    if (isEmpty(alarm)) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToSetGroupAlarmResponse', {
          response: response.toLowerCase()
        }),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'markCreatorResponseForSimultaneousAlarm'
      })
      return
    }

    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const currDate = Date.now()
    dispatch(
      addAlarmAcknowledgementAction(
        alarm,
        currAlarmDate,
        GlobalConfig.uid,
        currDate,
        response,
        rescheduleAlarm
      )
    )

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (persistOnFirebase) {
      await AlarmUtils.markCreatorResponseForSimultaneousAlarmCore(
        alarm,
        currAlarmDate,
        currDate,
        response,
        rescheduleAlarm
      )
    } else {
      console.log('Adding mark creator response for group alarm pending action')
      dispatch(
        addMarkCreatorResponseForGroupAlarmSoftPendingAction(
          alarm,
          response,
          rescheduleAlarm,
          currAlarmDate,
          currDate
        )
      )
    }

    response === Constants.GROUP_ALARM_YES
      ? FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.CONFIRM_GROUP_ALARM,
          {}
        )
      : FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.DECLINE_GROUP_ALARM,
          {}
        )
  }

const markIncidentAlarmResponse =
  (alarmId, occurrenceTimeString, timestamp, response) =>
  // eslint-disable-next-line no-unused-vars
  async (dispatch, getState) => {
    dispatch(
      addIncidentAlarmAcknowledgementAction(
        alarmId,
        occurrenceTimeString,
        GlobalConfig.uid,
        timestamp,
        response,
        true
      )
    )

    await AlarmUtils.markIncidentAlarmResponse(
      alarmId,
      occurrenceTimeString,
      timestamp,
      response
    )
  }

// Set alarmInstanceTimestamp to alarm.date as a fail safe in case user presses a notification
// action for an old alarm
const markParticipantResponseForSimultaneousAlarm =
  (alarmId, response, rescheduleAlarm) => async (dispatch, getState) => {
    const alarm = await retrieveAlarmByAlarmId(alarmId, getState)
    if (!alarm) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToSetGroupAlarmResponse', {
          response: response.toLowerCase()
        }),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'markParticipantResponseForSimultaneousAlarm'
      })
      return
    }

    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const currDate = Date.now()
    dispatch(
      addAlarmAcknowledgementAction(
        alarm,
        currAlarmDate,
        GlobalConfig.uid,
        currDate,
        response,
        rescheduleAlarm
      )
    )

    let updateAlarmResponseStatus = true
    if (
      response === Constants.GROUP_ALARM_NO &&
      alarm.repeatType !== '' &&
      alarm.responseStatus !== Constants.ALARM_RESPONSE_PENDING
    ) {
      updateAlarmResponseStatus = false
    }

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      await AlarmUtils.markParticipantResponseForSimultaneousAlarmCore(
        alarm,
        currAlarmDate,
        currDate,
        response,
        updateAlarmResponseStatus,
        rescheduleAlarm
      )
    } else {
      console.log(
        'Adding mark participant response for group alarm pending action'
      )
      dispatch(
        addMarkParticipantResponseForGroupAlarmSoftPendingAction(
          alarm,
          response,
          rescheduleAlarm,
          updateAlarmResponseStatus,
          currAlarmDate,
          currDate
        )
      )
    }

    response === Constants.GROUP_ALARM_YES
      ? FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.CONFIRM_GROUP_ALARM,
          {}
        )
      : FirebaseProxy.logEvent(
          Constants.UserAnalyticsEvents.DECLINE_GROUP_ALARM,
          {}
        )
  }

const syncAlarmsStatus = connected => (dispatch, getState) => {
  const alarms = getState().alarms.alarms
  let firebaseUpdateObj = {}
  let performSync = false
  let batchedActions = []
  const currDate = Date.now()
  alarms.forEach(alarm => {
    // Only update the status for one time enabled alarms
    // acknowledged group or buddy alarms because they are not
    // disabled when confirmed or declined
    if (alarm.status === false || AlarmUtils.getNewStatusForAlarm(alarm)) {
      return
    }
    // Get the effective alarm date and check if it is still in the window and disable
    // only if outside the window
    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const currentAlarmOccurrenceAcknowledged =
      AlarmUtils.isCurrentAlarmOccurrenceAcknowledged(alarm)

    if (
      currentAlarmOccurrenceAcknowledged &&
      currAlarmDate + GlobalConfig.alarmPreviousOccurrenceThreshold < currDate
    ) {
      const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
        status: false,
        lastUpdatedAt: currDate
      })
      batchedActions.push(softUpdateLocalAlarm(softUpdatedAlarm))

      firebaseUpdateObj['alarms/' + alarm.id + '/status'] = false
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
      performSync = true
    }
  })

  if (performSync) {
    dispatch(batchActions(...batchedActions))
    if (connected) {
      GlobalConfig.firebaseHelpers
        .updateData(GlobalConfig.rootFirebaseRef, firebaseUpdateObj)
        .catch(error => {
          LogUtils.logWarning(error.message, 'Unable to sync alarm status')
        })
    }
  }
}

const syncAlarmsStatusLocally = () => (dispatch, getState) => {
  const alarms = ownAlarmsSelector(getState())
  const participantAlarms = participantAlarmsSelector(getState())
  let myExpiredAlarms = []
  let participantExpiredAlarms = []
  let myAlarmsToBeUpdatedLocally = []
  let participantAlarmsToBeUpdatedLocally = []
  let myAlarmsToBeUnsnoozed = []
  let participantAlarmsToBeUnsnoozed = []
  const currDate = Date.now()
  alarms.forEach(alarm => {
    if (alarm.status === false) {
      return
    }
    // Get the effective alarm date and check if it is still in the window and disable
    // only if outside the window
    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)

    if (currAlarmDate < currDate && !alarm.lastExpiredAt) {
      myExpiredAlarms.push(alarm.id)
    } else if (currAlarmDate > currDate && alarm.lastExpiredAt) {
      myExpiredAlarms.push(alarm.id)
    } else if (
      alarm.lastSnoozeByCreatorOn &&
      alarm.lastSnoozeByCreatorFor &&
      alarm.lastSnoozeByCreatorOn + alarm.lastSnoozeByCreatorFor < currDate
    ) {
      myAlarmsToBeUnsnoozed.push(alarm.id)
    } else if (currAlarmDate > currDate) {
      // Merged the two separate !lastSeenAt/lastSeenAt branches — they both
      // pushed to the same array so the distinction had no effect.
      myAlarmsToBeUpdatedLocally.push(alarm.id)
    }
  })

  participantAlarms.forEach(alarm => {
    if (alarm.status === false) {
      return
    }

    const currAlarmDate = AlarmUtils.getCurrentDateForAlarm(alarm)
    const backupAlarmDate = DateTimeUtils.getParticipantAlarmDate(
      { ...alarm, date: currAlarmDate },
      alarm.order
    )
    const participant = AlarmUtils.getAlarmParticipant(alarm)
    if (!participant) {
      return
    }

    if (backupAlarmDate < currDate && !alarm.lastExpiredAt) {
      participantExpiredAlarms.push(alarm.id)
    } else if (backupAlarmDate > currDate && alarm.lastExpiredAt) {
      participantExpiredAlarms.push(alarm.id)
    } else if (
      participant.lastSnoozeOn &&
      participant.lastSnoozeFor &&
      participant.lastSnoozeOn + participant.lastSnoozeFor < currDate
    ) {
      participantAlarmsToBeUnsnoozed.push(alarm.id)
    } else if (backupAlarmDate > currDate) {
      participantAlarmsToBeUpdatedLocally.push(alarm.id)
    }
  })

  if (
    myExpiredAlarms.length > 0 ||
    myAlarmsToBeUpdatedLocally.length > 0 ||
    participantExpiredAlarms.length > 0 ||
    participantAlarmsToBeUpdatedLocally.length > 0 ||
    myAlarmsToBeUnsnoozed.length > 0 ||
    participantAlarmsToBeUnsnoozed.length > 0
  ) {
    dispatch(
      batchActions(
        markAlarmsAsExpired(myExpiredAlarms),
        updateAlarmsLocally(myAlarmsToBeUpdatedLocally),
        markParticipantAlarmsAsExpired(participantExpiredAlarms),
        updateParticipantsAlarmsLocally(participantAlarmsToBeUpdatedLocally),
        unsnoozeAlarmsLocally(myAlarmsToBeUnsnoozed),
        unsnoozeParticipantAlarmsLocally(
          participantAlarmsToBeUnsnoozed,
          GlobalConfig.uid
        )
      )
    )
  }

  // myExpiredAlarms.length > 0 && dispatch(markAlarmsAsExpired(myExpiredAlarms))
  // myAlarmsToBeUpdatedLocally.length > 0 && dispatch(updateAlarmsLocally(myAlarmsToBeUpdatedLocally))
  // participantExpiredAlarms.length > 0 && dispatch(markParticipantAlarmsAsExpired(participantExpiredAlarms))
  // participantAlarmsToBeUpdatedLocally.length > 0 && dispatch(updateParticipantsAlarmsLocally(participantAlarmsToBeUpdatedLocally))
}

// eslint-disable-next-line no-unused-vars
const markBackupAlarmAsDelivered = alarm => (dispatch, getState) => {
  if (!alarm) {
    return
  }

  const currDate = Date.now()
  let firebaseUpdateObj = {}
  if (
    alarm.backupGroup &&
    alarm.backupGroup.members &&
    Utils.getIndexOfObjectWithId(
      alarm.backupGroup.members,
      GlobalConfig.uid
    ) !== -1
  ) {
    const member = Utils.getObjectWithId(
      alarm.backupGroup.members,
      GlobalConfig.uid
    )
    if (!member.deliveredOn) {
      firebaseUpdateObj[
        'alarms/' +
          alarm.id +
          '/backups/group/' +
          alarm.backupGroup.id +
          '/members/' +
          GlobalConfig.uid +
          '/deliveredOn'
      ] = currDate
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
    }
  } else if (
    alarm.backupContacts &&
    alarm.backupContacts.length > 0 &&
    Utils.getIndexOfObjectWithId(alarm.backupContacts, GlobalConfig.uid) !== -1
  ) {
    const contact = Utils.getObjectWithId(
      alarm.backupContacts,
      GlobalConfig.uid
    )
    if (!contact.deliveredOn) {
      firebaseUpdateObj[
        'alarms/' +
          alarm.id +
          '/backups/contacts/' +
          GlobalConfig.uid +
          '/deliveredOn'
      ] = currDate
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
    }
  } else if (
    alarm.recipient &&
    alarm.recipient.id === GlobalConfig.uid &&
    !alarm.recipient.deliveredOn
  ) {
    firebaseUpdateObj['alarms/' + alarm.id + '/recipient/deliveredOn'] =
      currDate
    firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
  }
  GlobalConfig.firebaseHelpers
    .updateData(GlobalConfig.rootFirebaseRef, firebaseUpdateObj)
    .catch(error => {
      LogUtils.logError(error, 'Unable to mark participant alarm as delivered')
    })
}

// eslint-disable-next-line no-unused-vars
const markIncidentAlarmAsDelivered = alarmId => (dispatch, getState) => {
  const currDate = Date.now()

  GlobalConfig.firebaseHelpers
    .updateDocument(
      GlobalConfig.firebaseHelpers.docRef(
        GlobalConfig.firebaseHelpers.collectionRef(
          `userInfos/${GlobalConfig.uid}/incidentAlarms`
        ),
        alarmId
      ),
      {
        [`backupContacts.${GlobalConfig.uid}.deliveredOn`]: currDate,
        lastUpdatedAt: currDate
      }
    )
    .catch(error => {
      LogUtils.logError(error, 'Unable to mark incident alarm as delivered')
    })
}

const markBackupAlarmIdAsSeen = alarmId => async (dispatch, getState) => {
  retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
    if (!alarm) {
      LogUtils.logError(
        new Error(
          'Backup alarm not present while marking it as seen ' + alarmId
        )
      )
      return
    }

    dispatch(markBackupAlarmAsSeen(alarm))
  })
}

// eslint-disable-next-line no-unused-vars
const markBackupAlarmAsSeen = alarm => async (dispatch, getState) => {
  const currDate = Date.now()
  let firebaseUpdateObj = {}

  updateFirebaseObjWithAlarmSeenData(firebaseUpdateObj, alarm, currDate)

  GlobalConfig.firebaseHelpers
    .updateData(GlobalConfig.rootFirebaseRef, firebaseUpdateObj)
    .catch(error => {
      LogUtils.logError(error, 'Unable to mark participant alarm as seen')
    })
}

const updateFirebaseObjWithAlarmSeenData = (
  firebaseUpdateObj,
  alarm,
  currDate
) => {
  if (
    alarm.backupGroup &&
    alarm.backupGroup.members &&
    Utils.getIndexOfObjectWithId(
      alarm.backupGroup.members,
      GlobalConfig.uid
    ) !== -1
  ) {
    const member = Utils.getObjectWithId(
      alarm.backupGroup.members,
      GlobalConfig.uid
    )
    if (!member.seenOn) {
      firebaseUpdateObj[
        'alarms/' +
          alarm.id +
          '/backups/group/' +
          alarm.backupGroup.id +
          '/members/' +
          GlobalConfig.uid +
          '/seenOn'
      ] = currDate
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
    }
  } else if (
    alarm.backupContacts &&
    alarm.backupContacts.length > 0 &&
    Utils.getIndexOfObjectWithId(alarm.backupContacts, GlobalConfig.uid) !== -1
  ) {
    const contact = Utils.getObjectWithId(
      alarm.backupContacts,
      GlobalConfig.uid
    )
    if (!contact.seenOn) {
      firebaseUpdateObj[
        'alarms/' +
          alarm.id +
          '/backups/contacts/' +
          GlobalConfig.uid +
          '/seenOn'
      ] = currDate
      firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
    }
  } else if (
    alarm.recipient &&
    alarm.recipient.id === GlobalConfig.uid &&
    !alarm.recipient.seenOn
  ) {
    firebaseUpdateObj['alarms/' + alarm.id + '/recipient/seenOn'] = currDate
    firebaseUpdateObj['alarms/' + alarm.id + '/lastUpdatedAt'] = currDate
  }
}

// Need to provide appSecret because this action is also used to store the
// name when the user registers at which time the user is not authenticated yet
// eslint-disable-next-line no-unused-vars
const updateUserName = (uid, username) => (dispatch, getState) => {
  dispatch(setUserName(username))
  GlobalConfig.username = username
  StorageManager.storeData({ username })
  GlobalConfig.firebaseHelpers
    .updateData(GlobalConfig.firebaseHelpers.createRef(`users/${uid}`), {
      name: username,
      appSecret: GlobalConfig.appSecret
    })
    .then(() => {
      TaskManager.addHttpsCloudTask('updateConnections', {
        uid: GlobalConfig.uid,
        name: username
      })
    })
    .catch(error => {
      LogUtils.logError(error, 'Unable to update user name')
    })
}

const createFirebaseUpdateObjForBlockContact = contactId => {
  let firebaseUpdateObj = {}
  firebaseUpdateObj[
    'userInfos/' + GlobalConfig.uid + '/blockedContacts/' + contactId
  ] = true
  return firebaseUpdateObj
}

const createFirebaseUpdateObjForUnblockContact = contactId => {
  let firebaseUpdateObj = {}
  firebaseUpdateObj[
    'userInfos/' + GlobalConfig.uid + '/blockedContacts/' + contactId
  ] = null
  return firebaseUpdateObj
}

// eslint-disable-next-line no-unused-vars
const blockContact = (contactId, contactName) => (dispatch, getState) => {
  const ref = GlobalConfig.rootFirebaseRef

  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('blockingContact', { name: contactName })
  )

  const blockContactFirebaseUpdateObj =
    createFirebaseUpdateObjForBlockContact(contactId)
  GlobalConfig.firebaseHelpers
    .updateData(ref, blockContactFirebaseUpdateObj)
    .then(() => {
      return (
        TaskManager.addHttpsCloudTask('blockExistingAlarms', {
          uid: GlobalConfig.uid,
          contactId: contactId
        })
          // eslint-disable-next-line no-unused-vars
          .then(taskResult => {
            NavigationUtils.dismissProgress()
          })
          .catch(error => {
            LogUtils.logError(
              new Error(error.error || error.message),
              'Unable to block contact ' + contactId
            )
            dispatch(
              setProgress(
                Constants.ProgressStates.ERROR,
                I18n.t('unableToBlockContact', {
                  error: error.error || error.message
                }),
                true
              )
            )
          })
      )
    })
    .catch(error => {
      LogUtils.logError(
        new Error(error.error || error.message),
        'Unable to block contact ' + contactId
      )
      dispatch(
        setProgress(
          Constants.ProgressStates.ERROR,
          I18n.t('unableToBlockContact', {
            error: error.error || error.message
          }),
          true
        )
      )
    })

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.BLOCK_USER, {})
}

// eslint-disable-next-line no-unused-vars
const unblockContact = (contactId, contactName) => (dispatch, getState) => {
  const ref = GlobalConfig.rootFirebaseRef

  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('unblockingContact', { name: contactName })
  )

  // We have to unblock the contact first such that the when the alarms are restored,
  // they are synced with the app or else the restored alarms would still be blocked
  const firebaseUpdateObjForUnblockContact =
    createFirebaseUpdateObjForUnblockContact(contactId)
  GlobalConfig.firebaseHelpers
    .updateData(ref, firebaseUpdateObjForUnblockContact)
    .then(() => {
      return (
        TaskManager.addHttpsCloudTask('restoreBlockedAlarms', {
          uid: GlobalConfig.uid,
          contactId: contactId
        })
          // eslint-disable-next-line no-unused-vars
          .then(taskResult => {
            NavigationUtils.dismissProgress()
          })
          .catch(error => {
            LogUtils.logError(
              new Error(error.error || error.message),
              'Unable to unblock contact ' + contactId
            )
            dispatch(
              setProgress(
                Constants.ProgressStates.ERROR,
                I18n.t('unableToUnblockContact', {
                  error: error.error || error.message
                }),
                true
              )
            )
          })
      )
    })
    .catch(error => {
      LogUtils.logError(
        new Error(error.error || error.message),
        'Unable to unblock contact ' + contactId
      )
      dispatch(
        setProgress(
          Constants.ProgressStates.ERROR,
          I18n.t('unableToUnblockContact', {
            error: error.error || error.message
          }),
          true
        )
      )
    })

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.UNBLOCK_USER, {})
}

const sendRemoteNotificationsForNewMessage = (alarm, messageText) => {
  const notificationInfo = {
    alarmId: alarm.id,
    alarmName: alarm.name,
    type: Constants.NotificationTypes.NEW_ALARM_MESSAGE,
    participantName: GlobalConfig.username,
    messageText: messageText
  }
  const participantIds = AlarmUtils.getAlarmParticipants(
    alarm.type,
    alarm.backupGroup,
    alarm.backupContacts,
    alarm.recipient
  )
    .filter(
      participant => participant.responseStatus !== Constants.REJECT_ALARM
    )
    .map(participant => participant.id)

  // If number of participants in the alarm are less than the max limit
  // of the person is the alarm creator, send the push notification to
  // all the participants.
  if (
    participantIds.length <=
      GlobalConfig.maxNumParticipantsForFullNotifications ||
    alarm.creator === GlobalConfig.uid
  ) {
    participantIds.push(alarm.creator)
    participantIds.forEach(participantId => {
      if (participantId !== GlobalConfig.uid) {
        NotificationManager.sendRemoteNotification(
          participantId,
          Constants.NotificationKeys.NewAlarmMessage,
          notificationInfo
        )
      }
    })
  } else {
    NotificationManager.sendRemoteNotification(
      alarm.creator,
      Constants.NotificationKeys.NewAlarmMessage,
      notificationInfo
    )
  }
}

const addMessageToAlarmConversation =
  (alarmId, message) => (dispatch, getState) => {
    // eslint-disable-line no-unused-vars
    // {
    //   "text": "Sds\nDfs",
    //   "user": {
    //     "_id": "-KGvMIPwul2dUY181xLQ"
    //   },
    //   "createdAt": "2017-04-28T05:51:28.764Z",
    //   "_id": "e98d9c03-131e-468c-b0d1-b383d62d1705"
    // }
    // id, text, createdAt, userId and username
    const id = GlobalConfig.firebaseHelpers.generatePushKey(
      GlobalConfig.rootFirebaseRef
    )
    const finalMessage = {
      id,
      text: message.text,
      createdAt: Date.now(),
      userId: GlobalConfig.uid,
      username: GlobalConfig.username,
      mobileNumber: getState().userInfo.formattedMobileNumberWithCC
    }
    dispatch(addNewMessageToAlarmConversation(alarmId, finalMessage))
    GlobalConfig.firebaseHelpers.setData(
      GlobalConfig.firebaseHelpers.createRef(
        `conversations/alarms/${alarmId}/${id}`
      ),
      finalMessage
    )

    // Send out remote notifications to the creator is the message is sent by a participant
    // or to all the participants if the message is sent by the creator
    const alarmSelector = makeAlarmSelector()
    const alarm = alarmSelector(getState(), { alarmId })
    if (!isEmpty(alarm)) {
      sendRemoteNotificationsForNewMessage(alarm, message.text)
      const participants = AlarmUtils.getAlarmParticipants(
        alarm.type,
        alarm.backupGroup,
        alarm.backupContacts,
        alarm.recipient
      )
      let allParticipants = participants.slice()
      allParticipants.push({ id: alarm.creator })
      allParticipants.splice(
        Utils.getIndexOfObjectWithId(allParticipants, GlobalConfig.uid),
        1
      )
      const participantIds = allParticipants.map(participant => participant.id)
      participantIds.forEach(participantId => {
        GlobalConfig.firebaseHelpers.transaction(
          GlobalConfig.firebaseHelpers.createRef(
            `conversations/unseenMessages/${alarmId}/${participantId}`
          ),
          unseenMessagesCount => {
            if (!unseenMessagesCount) {
              return 1
            } else {
              return unseenMessagesCount + 1
            }
          }
        )
      })
    }

    FirebaseProxy.logEvent(
      Constants.UserAnalyticsEvents.SEND_MESSAGE_ON_CHAT,
      {}
    )
  }

// eslint-disable-next-line no-unused-vars
const loadLastConversationMessageForAlarm = alarmId => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers
    .getData(
      GlobalConfig.firebaseHelpers.createQuery(
        GlobalConfig.firebaseHelpers.createRef(
          `conversations/alarms/${alarmId}`
        ),
        GlobalConfig.firebaseHelpers.orderByKey(),
        GlobalConfig.firebaseHelpers.limitToLast(1)
      )
    )
    .then(lastMessageSnapshot => {
      dispatch(
        addNewMessageToAlarmConversation(alarmId, lastMessageSnapshot.val())
      )
    })
}

const loadLatestConversationMessagesForAlarm =
  alarmId =>
  (
    dispatch,
    getState // eslint-disable-line no-unused-vars
  ) => {
    let processedOldMessages = false
    FirebaseManager.addFirebaseRefChildAddedIfNotPresent(
      'Conversation' + alarmId,
      GlobalConfig.firebaseHelpers.createRef(`conversations/alarms/${alarmId}`),
      messageSnapshot => {
        if (processedOldMessages) {
          dispatch(
            addNewMessageToAlarmConversation(alarmId, messageSnapshot.val())
          )
        }
      }
    )
    GlobalConfig.firebaseHelpers
      .getData(
        GlobalConfig.firebaseHelpers.createQuery(
          GlobalConfig.firebaseHelpers.createRef(
            `conversations/alarms/${alarmId}`
          ),
          GlobalConfig.firebaseHelpers.orderByKey(),
          GlobalConfig.firebaseHelpers.limitToLast(
            GlobalConfig.numConversationMessagesToLoadInOneRequest + 1
          )
        )
      )
      .then(conversationSnapshot => {
        if (conversationSnapshot.exists()) {
          dispatch(
            addMessagesToAlarmConversation(
              alarmId,
              Object.values(conversationSnapshot.val())
            )
          )
        } else {
          dispatch(addMessagesToAlarmConversation(alarmId, []))
        }
        processedOldMessages = true
        return GlobalConfig.firebaseHelpers.getData(
          GlobalConfig.firebaseHelpers.createQuery(
            GlobalConfig.firebaseHelpers.createRef(
              `conversations/alarms/${alarmId}`
            ),
            GlobalConfig.firebaseHelpers.orderByKey(),
            GlobalConfig.firebaseHelpers.limitToFirst(1)
          )
        )
      })
      .then(firstConversationSnapshot => {
        if (firstConversationSnapshot.exists()) {
          const firstMessageKey = Object.keys(
            firstConversationSnapshot.val()
          )[0]
          dispatch(
            processFirstMessageKeyForAlarmConversation(alarmId, firstMessageKey)
          )
        }
      })
  }

const loadEarlierConversationMessagesForAlarm =
  alarmId => (dispatch, getState) => {
    dispatch(setIsLoadingEarlierMessagesForAlarm(alarmId, true))
    const alarmConversation = getState().conversations.alarms[alarmId]
    if (!alarmConversation || alarmConversation.messages.length === 0) {
      dispatch(setIsLoadingEarlierMessagesForAlarm(alarmId, false))
      return
    }
    const earliestMessageInConversation =
      alarmConversation.messages[alarmConversation.messages.length - 1]
    GlobalConfig.firebaseHelpers
      .getData(
        GlobalConfig.firebaseHelpers.createQuery(
          GlobalConfig.firebaseHelpers.createRef(
            `conversations/alarms/${alarmId}`
          ),
          GlobalConfig.firebaseHelpers.orderByKey(),
          GlobalConfig.firebaseHelpers.endAt(earliestMessageInConversation.id),
          GlobalConfig.firebaseHelpers.limitToLast(
            GlobalConfig.numConversationMessagesToLoadInOneRequest + 1
          )
        )
      )
      .then(conversationSnapshot => {
        if (conversationSnapshot.exists()) {
          dispatch(
            addMessagesToAlarmConversation(
              alarmId,
              Object.values(conversationSnapshot.val())
            )
          )
        } else {
          dispatch(addMessagesToAlarmConversation(alarmId, []))
        }
        dispatch(setIsLoadingEarlierMessagesForAlarm(alarmId, false))
      })
  }

const snoozeParticipantAlarm =
  (alarmId, snoozeInterval) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      if (!alarm) {
        NavigationUtils.showTransientAlert({
          message: I18n.t('unableToSnoozeAlarm'),
          duration: Constants.AlertDurations.LONG
        })
        FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
          [Constants.UserAnalyticsEventParameters.SOURCE]:
            'snoozeParticipantAlarm'
        })
        return
      }

      const creatorName = AlarmUtils.resolveAlarmCreatorName(
        getState().contacts.contacts,
        alarm.creator,
        alarm.creatorMobileNumber,
        alarm.creatorName
      )
      const snoozeDate = DateTimeUtils.shaveSecondsFromDate(Date.now())
      const softUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
        alarm,
        GlobalConfig.uid,
        {
          lastSnoozeOn: snoozeDate,
          lastSnoozeFor: snoozeInterval
        }
      )
      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      AlarmUtils.snoozeAlarmForParticipant(
        alarm,
        creatorName,
        snoozeInterval,
        snoozeDate,
        persistOnFirebase
      )

      if (!persistOnFirebase) {
        console.log('Adding start snooze for participant pending action')

        dispatch(
          addStartSnoozeForParticipantSoftPendingAction(
            alarm,
            snoozeInterval,
            snoozeDate
          )
        )
      }

      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SNOOZE_ALARM, {
        [Constants.UserAnalyticsEventParameters.SNOOZE_ALARM_DURATION]:
          AlarmUtils.getSnoozeDurationAsString(snoozeInterval)
      })
    })
  }

const updateSnoozeStatusForParticipantAlarm =
  (alarmId, snoozeDate, snoozeInterval) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      if (!alarm) {
        FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
          [Constants.UserAnalyticsEventParameters.SOURCE]:
            'snoozeParticipantAlarmFromAlarmAction'
        })
        return
      }

      const softUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
        alarm,
        GlobalConfig.uid,
        {
          lastSnoozeOn: snoozeDate,
          lastSnoozeFor: snoozeInterval
        }
      )

      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      if (!persistOnFirebase) {
        console.log('Adding start snooze for participant pending action')

        dispatch(
          addStartSnoozeForParticipantSoftPendingAction(
            alarm,
            snoozeInterval,
            snoozeDate
          )
        )
      } else {
        AlarmUtils.updateSnoozeStatusForParticipantAlarmCore(
          alarm,
          snoozeDate,
          snoozeInterval
        )
      }
    })

    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SNOOZE_ALARM, {
      [Constants.UserAnalyticsEventParameters.SNOOZE_ALARM_DURATION]:
        AlarmUtils.getSnoozeDurationAsString(snoozeInterval)
    })
  }

const snoozeCreatorAlarm =
  (alarmId, snoozeInterval) => (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const alarm = ownAlarmSelector(getState(), { alarmId })

    const snoozeDate = DateTimeUtils.shaveSecondsFromDate(Date.now())
    const snoozeAlarmDate = snoozeDate + snoozeInterval

    const isOnline =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    const alarmScheduledRemotely = alarm.scheduledRemotely || false

    // Schedule snooze notification (remote or local)
    if (isOnline && alarmScheduledRemotely) {
      // Schedule remote snooze notification
      console.log(
        'Scheduling remote snooze notification for alarm ' +
          alarm.id +
          ' at ' +
          DateTimeUtils.getDateTimeAsString(snoozeAlarmDate)
      )

      const currAlarmDate =
        AlarmUtils.getCurrentDateForAlarm(alarm) || alarm.date
      const myAlarmDate = DateTimeUtils.getMyAlarmDate(currAlarmDate)

      TaskManager.addHttpsCloudTask('snoozeNotificationForAlarm', {
        uid: GlobalConfig.uid,
        alarmId: alarm.id,
        snoozeTime: snoozeDate,
        snoozeInterval: snoozeInterval,
        originalTimestamp: myAlarmDate
      })
        .then(result => {
          if (result && result.status === 'success') {
            console.log(
              'Remote snooze notification scheduled successfully for alarm:',
              alarm.id
            )
          } else {
            console.error(
              'Failed to schedule remote snooze notification:',
              result
            )
          }
        })
        .catch(error => {
          console.error('Error scheduling remote snooze notification:', error)
        })
    } else {
      // Schedule local snooze notification
      const alarmAlert = AlarmUtils.getMyAlarmNotificationAlertMessage(
        alarm.type,
        alarm.name,
        objGet(alarm, 'recipient.name', '')
      )

      const alarmDate = AlarmUtils.getCurrentDateForAlarm(alarm) || alarm.date
      const myAlarmDate = DateTimeUtils.getMyAlarmDate(alarmDate)

      // Use effective alarm date here
      const notificationInfo = AlarmUtils.getMyAlarmNotificationInfo(
        alarm,
        myAlarmDate
      )

      AlarmManager.scheduleSnoozeNotification(
        snoozeAlarmDate,
        alarmAlert,
        notificationInfo
      )

      const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
        lastSnoozeByCreatorOn: snoozeDate,
        lastSnoozeByCreatorFor: snoozeInterval
      })

      dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

      if (!isOnline) {
        console.log('Adding start snooze for creator pending action')

        dispatch(
          addStartSnoozeForCreatorSoftPendingAction(
            alarmId,
            snoozeInterval,
            snoozeDate
          )
        )
      } else {
        AlarmUtils.snoozeAlarmForCreator(alarm, snoozeInterval, snoozeDate)
      }
    }

    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SNOOZE_ALARM, {
      [Constants.UserAnalyticsEventParameters.SNOOZE_ALARM_DURATION]:
        AlarmUtils.getSnoozeDurationAsString(snoozeInterval)
    })
  }

const updateSnoozeStatusForCreatorAlarm =
  (alarmId, snoozeDate, snoozeInterval) => (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const alarm = ownAlarmSelector(getState(), { alarmId })

    if (isEmpty(alarm)) {
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'snoozeCreatorAlarmFromAlarmAction'
      })
      return
    }

    const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
      lastSnoozeByCreatorOn: snoozeDate,
      lastSnoozeByCreatorFor: snoozeInterval
    })
    dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    if (!persistOnFirebase) {
      console.log('Adding start snooze for creator pending action')

      dispatch(
        addStartSnoozeForCreatorSoftPendingAction(
          alarmId,
          snoozeInterval,
          snoozeDate
        )
      )
    } else {
      AlarmUtils.updateSnoozeStatusForCreatorAlarm(
        alarmId,
        snoozeDate,
        snoozeInterval
      )
    }

    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.SNOOZE_ALARM, {
      [Constants.UserAnalyticsEventParameters.SNOOZE_ALARM_DURATION]:
        AlarmUtils.getSnoozeDurationAsString(snoozeInterval)
    })
  }

const stopSnoozeForParticipantAlarm = alarmId => (dispatch, getState) => {
  retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
    if (!alarm) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToStopSnoozeForAlarm'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'stopSnoozeForParticipantAlarm'
      })
      return
    }

    const softUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
      alarm,
      GlobalConfig.uid,
      {
        lastSnoozeOn: undefined,
        lastSnoozeFor: undefined
      }
    )

    dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase

    AlarmUtils.stopSnoozeForParticipantAlarm(alarm, persistOnFirebase)

    if (!persistOnFirebase) {
      console.log('Adding stop snooze for participant pending action')

      dispatch(addStopSnoozeForParticipantSoftPendingAction(alarm))
    }

    FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.UNSNOOZE_ALARM, {})
  })
}

const stopSnoozeForCreatorAlarm = alarmId => (dispatch, getState) => {
  AlarmManager.cancelSnoozeNotification(alarmId)
  const ownAlarmSelector = makeOwnAlarmSelector()
  const alarm = ownAlarmSelector(getState(), { alarmId })
  const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
    lastSnoozeByCreatorOn: undefined,
    lastSnoozeByCreatorFor: undefined
  })
  dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

  const persistOnFirebase =
    getState().appState.isConnected &&
    getState().appState.authenticatedWithFirebase

  const alarmScheduledRemotely = alarm.scheduledRemotely || false

  if (persistOnFirebase && alarmScheduledRemotely) {
    // Cancel remote snooze notification
    console.log('Canceling remote snooze notification for alarm ' + alarm.id)

    TaskManager.addHttpsCloudTask('cancelSnoozeForAlarm', {
      uid: GlobalConfig.uid,
      alarmId: alarm.id
    })
      .then(() => {
        console.log('Successfully canceled remote snooze notification')
      })
      .catch(error => {
        console.error('Error canceling remote snooze notification:', error)
      })
    return
  }

  if (persistOnFirebase) {
    AlarmUtils.stopSnoozeForCreatorAlarm(alarmId)
  } else {
    console.log('Adding stop snooze for creator pending action')

    dispatch(
      addStopSnoozeForCreatorSoftPendingAction(alarmId, alarmScheduledRemotely)
    )
  }

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.UNSNOOZE_ALARM, {})
}

const showWelcomeAlarmsIfNeeded =
  navigation =>
  (
    dispatch, // eslint-disable-line no-unused-vars
    getState // eslint-disable-line no-unused-vars
  ) => {
    const promise = new Promise(resolve => {
      GlobalConfig.firebaseHelpers
        .getData(
          GlobalConfig.firebaseHelpers.createRef(
            `users/${GlobalConfig.uid}/shownWelcomeAlarms`
          )
        )
        .then(shownWelcomeAlarmsSnapshot => {
          if (shownWelcomeAlarmsSnapshot.val() === false) {
            // If welcome alarms have not been shown, then launch the welcome alarm list overlay
            NavigationUtils.showWelcomeAlarms(navigation, resolve)
          } else {
            resolve()
          }
        })
    })
    return promise
  }

// If the user skips the process to create welcome alarms, mark the welcome alarms as shown
// Remove the shownWelcomeAlarms flag which is set to false on account creation
const markWelcomeAlarmsAsShown =
  () =>
  (
    dispatch, // eslint-disable-line no-unused-vars
    getState // eslint-disable-line no-unused-vars
  ) => {
    GlobalConfig.firebaseHelpers.removeData(
      GlobalConfig.firebaseHelpers.createRef(
        `users/${GlobalConfig.uid}/shownWelcomeAlarms`
      )
    )
  }

// Cloud task to create welcome alarms once the user selects and saves welcome alarms
const createWelcomeAlarms =
  welcomeAlarms =>
  (
    dispatch, // eslint-disable-line no-unused-vars
    getState // eslint-disable-line no-unused-vars
  ) => {
    welcomeAlarms.forEach(alarm => {
      dispatch(addAlarm(alarm))
    })
  }

const deleteAccount = feedback => (dispatch, getState) => {
  // eslint-disable-line no-unused-vars
  NavigationUtils.showProgress(
    Constants.ProgressStates.IN_PROGRESS,
    I18n.t('deletingAccount')
  )

  FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.DELETE_ACCOUNT, {})
  return (
    dispatch(
      createSupportTicket(
        Constants.TICKET_TYPES.ACCOUNT_DELETION,
        getState().userInfo.email,
        feedback
      )
    )
      .then(() => {
        return TaskManager.addHttpsCloudTask('deleteAccount', {
          uid: GlobalConfig.uid,
          phoneId: GlobalConfig.phoneId || null
        })
      })
      // eslint-disable-next-line no-unused-vars
      .then(taskResult => {
        NavigationUtils.dismissProgress()
        NavigationUtils.showAlert('', I18n.t('accountDeleted'))
        GlobalConfig.uid = undefined
        dispatch(unloadAppData())
        dispatch(resetApp())
        AlarmManager.cancelAllNotifications()
        return StorageManager.removeData(['uid'])
      })
      .catch(error => {
        LogUtils.logError(
          new Error(error.error || error.message),
          'Unable to delete account'
        )
        dispatch(
          setProgress(
            Constants.ProgressStates.ERROR,
            I18n.t('unableToDeleteAccount', {
              error: error.error || error.message
            }),
            true
          )
        )
      })
  )
}

const updateSnoozingAlarms = alarms => (dispatch, getState) => {
  Object.keys(alarms).forEach(alarmId => {
    var snoozeDateAndDurationObject = alarms[alarmId]

    let snoozeDate

    let snoozeDuration = GlobalConfig.defaultSnoozeInterval

    // For backward comaptilibity if it's an older version the object
    // will be an integer for the timestamp
    if (typeof snoozeDateAndDurationObject === 'string') {
      const snoozeDateAndDurationArray = snoozeDateAndDurationObject.split(':')
      if (
        Array.isArray(snoozeDateAndDurationArray) &&
        snoozeDateAndDurationArray.length
      ) {
        snoozeDate = Number(snoozeDateAndDurationArray[0])
        snoozeDuration = Number(snoozeDateAndDurationArray[1])
      }
    } else {
      snoozeDate = snoozeDateAndDurationObject
    }
    const allAlarms = allAlarmsSelector(getState())
    const alarm = Utils.getObjectWithId(allAlarms, alarmId)
    if (alarm) {
      if (alarm.alarmCategory === Constants.AlarmCategories.MY_ALARM) {
        AlarmUtils.updateSnoozeStatusForCreatorAlarm(
          alarmId,
          snoozeDate,
          snoozeDuration
        )
      } else if (
        alarm.alarmCategory === Constants.AlarmCategories.PARTICIPANT_ALARM
      ) {
        AlarmUtils.updateSnoozeStatusForParticipantAlarmCore(
          alarm,
          snoozeDate,
          snoozeDuration
        )
      }
    }
  })
}

const updateAcknowledgedAlarms = alarms => (dispatch, getState) => {
  Object.keys(alarms).forEach(alarmIdAndOccurenceTime => {
    const alarmIdAndOccurenceTimeArray = alarmIdAndOccurenceTime.split(':')
    const alarmId = alarmIdAndOccurenceTimeArray[0]
    const occurrenceTime = Number(alarmIdAndOccurenceTimeArray[1])
    const timestamp = Number(alarms[alarmIdAndOccurenceTime])

    const allAlarms = allAlarmsSelector(getState())
    const alarm = Utils.getObjectWithId(allAlarms, alarmId)

    if (!alarm) {
      return
    }

    let alarmResponse
    switch (alarm.type) {
      case Constants.AlarmTypes.CASCADING:
        alarmResponse = Constants.PERSONAL_ALARM_DONE
        break
      case Constants.AlarmTypes.SIMULTANEOUS:
        alarmResponse = Constants.GROUP_ALARM_YES
        break
      case Constants.AlarmTypes.RECIPIENT:
        alarmResponse = Constants.RECIPIENT_ALARM_DONE
        break
      default:
        console.log('Unknown alarm type')
    }

    if (!alarmResponse) {
      return
    }

    AlarmUtils.setPastAlarmOccurrenceResponse(
      alarm,
      occurrenceTime,
      timestamp,
      alarmResponse
    )
  })
}

const continueWithoutRegistration =
  () =>
  (
    dispatch,
    getState // eslint-disable-line no-unused-vars
  ) => {
    NavigationUtils.showProgress(
      Constants.ProgressStates.IN_PROGRESS,
      I18n.t('creatingUserProfile')
    )

    return TaskManager.addHttpsCloudTask('createUserWithoutMobileNumber', {
      os: Platform.OS
    })
      .then(taskResult => {
        NavigationUtils.dismissProgress()
        const uid = taskResult.result.uid
        GlobalConfig.uid = uid
      })
      .catch(error => {
        dispatch(
          setProgress(
            Constants.ProgressStates.ERROR,
            I18n.t('unabeToCreateUserProfile'),
            true
          )
        )
        LogUtils.logError(error, 'Unable to create user without mobile number')
      })
  }

// eslint-disable-next-line no-unused-vars
const addMisingConnection = id => (dispatch, getState) => {
  return TaskManager.addHttpsCloudTask('addConnections', {
    uids: [GlobalConfig.uid, id].join(',')
  })
}

// eslint-disable-next-line no-unused-vars
const updateLastActiveTime = () => (dispatch, getState) => {
  GlobalConfig.firebaseHelpers.setData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/lastActiveAt`
    ),
    Date.now()
  )
}

const updateAlarmPreReminderDuration =
  (alarmId, preReminderDuration) => (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const alarm = ownAlarmSelector(getState(), { alarmId })

    if (isEmpty(alarm)) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToUpdateAlarmPreReminderDuration'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'updateAlarmPreReminderDuration'
      })
      return
    }

    const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
      preReminderDuration: preReminderDuration
    })
    dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

    dispatch(scheduleNotificationForOwnAlarm(softUpdatedAlarm))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (!persistOnFirebase) {
      console.log(
        'Adding pending action for add update pre reminder duration' + alarmId
      )

      dispatch(
        addUpdateAlarmPreReminderSoftPendingAction(alarm, preReminderDuration)
      )
    } else {
      const firebaseUpdateObj =
        AlarmUtils.createFirebaseObjForUpdatingAlarmPreReminderDuration(
          alarm,
          preReminderDuration
        )
      GlobalConfig.firebaseHelpers.updateData(
        GlobalConfig.rootFirebaseRef,
        firebaseUpdateObj
      )
    }
  }

const updateAlarmRingerSettings =
  (alarmId, ringerSettings) => (dispatch, getState) => {
    const ownAlarmSelector = makeOwnAlarmSelector()
    const alarm = ownAlarmSelector(getState(), { alarmId })

    if (isEmpty(alarm)) {
      NavigationUtils.showTransientAlert({
        message: I18n.t('unableToUpdateAlarmRingerSettings'),
        duration: Constants.AlertDurations.LONG
      })
      FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
        [Constants.UserAnalyticsEventParameters.SOURCE]:
          'updateAlarmRingerSettings'
      })
      return
    }

    const softUpdatedAlarm = AlarmUtils.updateAlarm(alarm, {
      ringerSettings: ringerSettings
    })
    dispatch(softUpdateLocalAlarm(softUpdatedAlarm))

    dispatch(scheduleNotificationForOwnAlarm(softUpdatedAlarm))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (!persistOnFirebase) {
      console.log(
        'Adding pending action for add update ringer settings' + alarmId
      )

      dispatch(
        addUpdateAlarmRingerSettingsSoftPendingAction(alarm, ringerSettings)
      )
    } else {
      const firebaseUpdateObj =
        AlarmUtils.createFirebaseObjForUpdatingAlarmRingerSettings(
          alarm,
          ringerSettings
        )
      GlobalConfig.firebaseHelpers.updateData(
        GlobalConfig.rootFirebaseRef,
        firebaseUpdateObj
      )
    }
  }

const updateParticipantPreReminderDuration =
  (alarmId, preReminderDuration) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      if (!alarm) {
        NavigationUtils.showTransientAlert({
          message: I18n.t('unableToUpdateParticipantPreReminderDuration'),
          duration: Constants.AlertDurations.LONG
        })
        FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
          [Constants.UserAnalyticsEventParameters.SOURCE]:
            'updateParticipantPreReminderDuration'
        })
        return
      }

      const softUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
        alarm,
        GlobalConfig.uid,
        {
          preReminderDuration
        }
      )

      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      scheduleNotificationForParticipantAlarm(
        softUpdatedAlarm,
        getState().contacts.contacts
      )

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      if (!persistOnFirebase) {
        console.log(
          'Adding pending action for add update pre-reminder duration' + alarmId
        )

        dispatch(
          addUpdateParticipantPreReminderDurationSoftPendingAction(
            alarm,
            GlobalConfig.uid,
            preReminderDuration
          )
        )
      } else {
        const firebaseUpdateObj =
          AlarmUtils.createFirebaseObjForUpdatingParticipantAlarmPreReminderDuration(
            alarm,
            preReminderDuration
          )
        GlobalConfig.firebaseHelpers.updateData(
          GlobalConfig.rootFirebaseRef,
          firebaseUpdateObj
        )
      }
    })
  }

const updateParticipantAlarmRingerSettings =
  (alarmId, ringerSettings) => (dispatch, getState) => {
    retrieveAlarmByAlarmId(alarmId, getState).then(alarm => {
      if (!alarm) {
        NavigationUtils.showTransientAlert({
          message: I18n.t('unableToUpdateParticipantAlarmRingerSettings'),
          duration: Constants.AlertDurations.LONG
        })
        FirebaseProxy.logEvent(Constants.UserAnalyticsEvents.ALARM_NOT_FOUND, {
          [Constants.UserAnalyticsEventParameters.SOURCE]:
            'updateParticipantAlarmRingerSettings'
        })
        return
      }

      const softUpdatedAlarm = AlarmUtils.updateAlarmParticipant(
        alarm,
        GlobalConfig.uid,
        {
          ringerSettings
        }
      )

      dispatch(softUpdateLocalParticipantAlarm(softUpdatedAlarm))

      scheduleNotificationForParticipantAlarm(
        softUpdatedAlarm,
        getState().contacts.contacts
      )

      const persistOnFirebase =
        getState().appState.isConnected &&
        getState().appState.authenticatedWithFirebase

      if (!persistOnFirebase) {
        console.log(
          'Adding pending action for add update ringer settings' + alarmId
        )

        dispatch(
          addUpdateParticipantAlarmRingerSettingsSoftPendingAction(
            alarm,
            GlobalConfig.uid,
            ringerSettings
          )
        )
      } else {
        const firebaseUpdateObj =
          AlarmUtils.createFirebaseObjForUpdatingParticipantAlarmRingerSettings(
            alarm,
            ringerSettings
          )
        GlobalConfig.firebaseHelpers.updateData(
          GlobalConfig.rootFirebaseRef,
          firebaseUpdateObj
        )
      }
    })
  }

const setAdditionalSetupInstructions = additionalSetupInstructions => ({
  type: ActionTypes.SET_ADDITIONAL_SETUP_INSTRUCTIONS,
  payload: {
    additionalSetupInstructions
  }
})

const scheduleExistingAlarms = () => (dispatch, getState) => {
  const allAlarms = allAlarmsSelector(getState())
  allAlarms
    .slice()
    .reverse()
    .forEach(alarm => {
      if (alarm.alarmCategory === Constants.AlarmCategories.MY_ALARM) {
        dispatch(scheduleNotificationForOwnAlarm(alarm))
      } else {
        scheduleNotificationForParticipantAlarm(
          alarm,
          getState().contacts.contacts
        )
      }
    })
}

const scheduleNextFiveAlarms = () => (dispatch, getState) => {
  const nextFiveAlarms = nextFiveAlarmsThatShouldRingSelector(getState())
  nextFiveAlarms.forEach(alarm => {
    if (alarm.alarmCategory === Constants.AlarmCategories.MY_ALARM) {
      dispatch(scheduleNotificationForOwnAlarm(alarm))
    } else {
      scheduleNotificationForParticipantAlarm(
        alarm,
        getState().contacts.contacts
      )
    }
  })
}

const createSupportTicket =
  (type, emailId, message, extras = '') =>
  (dispatch, getState) => {
    const state = getState()
    let deviceString, deviceOsName, deviceOsVersion
    if (Platform.OS === 'web') {
      deviceString = `${WebUtils.getBrowserName()} ${WebUtils.getBrowserVersion()}`
      deviceOsName = WebUtils.getDeviceOsName()
      deviceOsVersion = WebUtils.getDeviceOsVersion()
    } else {
      deviceString =
        state.userInfo.deviceManufacturer + '-' + DeviceInfo.getModel()
      deviceOsName = DeviceInfo.getSystemName()
      deviceOsVersion = DeviceInfo.getSystemVersion()
    }

    const numAllAlarms = simpleAllAlarmsSelector(state).length
    const numberOfMissedAlarms = missedAlarmsSelector(state).length
    const numberOfInactiveAlarms = inactiveAlarmsCountSelector(state)
    const tasksCount = allTasksCountSelector(state)

    return TaskManager.addHttpsCloudTask('sendFeedbackEmail', {
      uid: GlobalConfig.uid,
      username: GlobalConfig.username,
      deviceUid: GlobalConfig.deviceUid,
      os: deviceOsName,
      osVersion: deviceOsVersion,
      locale: I18n.currentLocale(),
      device: deviceString,
      feedback: message,
      release: GlobalConfig.release,
      emailId: emailId,
      type: type,
      appState: JSON.stringify(
        objOmit(
          {
            ...getState().appState,
            ...getState().userSettings,
            isAuthenticated: getState().appState.authenticatedWithFirebase,
            premiumUser: upgradePurchasedSelector(getState()),
            userSince: DateTimeUtils.getDateTimeAsString(
              getState().userInfo.joinDate
            ),
            alarmsCount: getState().userInfo.alarmsCount,
            shareableAlarmLinksCount:
              getState().userInfo.shareableAlarmLinksCount,
            alarmsSavedToCalendarCount:
              getState().userInfo.alarmsSavedToCalendarCount,
            instantAlarmsCount: getState().userInfo.instantAlarmsCount,
            isUserRegistered: getState().userInfo.mobileNumber !== '',
            enterpriseSubscriptions:
              getState().userInfo.enterpriseSubscriptions,
            allAlarmsCount: numAllAlarms,
            missedAlarmsCount: numberOfMissedAlarms,
            inactiveAlarmsCount: numberOfInactiveAlarms,
            tasksCount: tasksCount
          },
          [
            'latestRelease',
            'deviceToken',
            'currentScreen',
            'authenticatedWithFirebase',
            'skuDetails',
            'inspectorPanelConfig'
          ]
        )
      ),
      extras: extras
    })
  }

const makeGroupMembersActiveInAlarms =
  (groupId, memberIds) => (dispatch, getState) => {
    const ownAlarms = ownAlarmsSelector(getState())
    const impactedAlarms = ownAlarms.filter(alarm => {
      return (
        alarm.status === true &&
        (alarm.date > Date.now() || alarm.repeatType !== '') &&
        !!alarm.backupGroup &&
        alarm.backupGroup.id === groupId
      )
    })
    let firebaseUpdate = {}
    impactedAlarms.forEach(alarm => {
      memberIds.forEach(memberId => {
        firebaseUpdate[
          'alarms/' +
            alarm.id +
            '/backups/group/' +
            groupId +
            '/members/' +
            memberId +
            '/state'
        ] = 'active'
        firebaseUpdate[
          'userInfos/' + memberId + '/backupForAlarms/' + alarm.id
        ] = alarm.date
        firebaseUpdate['alarms/' + alarm.id + '/lastUpdatedAt'] = Date.now()
      })
    })
    GlobalConfig.firebaseHelpers
      .updateData(GlobalConfig.rootFirebaseRef, firebaseUpdate)
      .then(() => {
        // Send remote notification to the new members
        impactedAlarms.forEach(alarm => {
          const notificationType =
            Constants.NotificationKeys.AddedAsParticipantNotification
          memberIds.forEach(memberId => {
            const participants = objGet(alarm, `backupGroup.members`, [])
            const participant = Utils.getObjectWithId(participants, memberId)

            if (!participant) {
              return
            }

            const notificationInfo = getNotificationInfoForBackupAlarmAdded(
              alarm,
              participant.order || 0
            )
            NotificationManager.sendRemoteNotification(
              participant.id,
              notificationType,
              notificationInfo
            )
          })
        })
      })
  }

const disablePremiumFeatures = () => (dispatch, getState) => {
  // dispatch(deleteAllUserDefinedAlarmCategories())

  if (Platform.OS === 'android') {
    const ringerSettings = ringerSettingsSelector(getState())
    if (ringerSettings.announceAlarmName) {
      const newRingerSettings = {
        ...ringerSettings,
        announceAlarmName: false
      }
      dispatch(updateGlobalAlarmRingerSettings(newRingerSettings))
    }
  }

  // We are not disabling enhanced notifications for now
  // as the alarms are moved to remote alarms only when
  // a user is a premium user
  // dispatch(updateEnhancedNotificationsUserSetting(false))

  // Remove any active web sessions
  GlobalConfig.firebaseHelpers.removeData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/activeSessionId`
    )
  )
  GlobalConfig.firebaseHelpers.removeData(
    GlobalConfig.firebaseHelpers.createRef(
      `userInfos/${GlobalConfig.uid}/sessions`
    )
  )
}

const updateNotificationSettingsUserSettings =
  notificationSettings => (dispatch, getState) => {
    dispatch(setNotificationSettingsUserSettings(notificationSettings))

    const persistOnFirebase =
      getState().appState.isConnected &&
      getState().appState.authenticatedWithFirebase
    if (persistOnFirebase) {
      GlobalConfig.firebaseHelpers.setData(
        GlobalConfig.firebaseHelpers.createRef(
          `userSettings/${GlobalConfig.uid}/notificationSettings`
        ),
        notificationSettings
      )
    } else {
      console.log('Adding notification settingns pending action')
      dispatch(
        addUpdateNotificationSettingsSoftPendingAction(notificationSettings)
      )
    }
  }

const markAlarmsAsComplete = selectedAlarms => async (dispatch, getState) => {
  const alarmSelector = makeAlarmSelector()
  for (const alarm of selectedAlarms) {
    if (alarm.alarmCategory === Constants.AlarmCategories.MY_ALARM) {
      switch (alarm.type) {
        case Constants.AlarmTypes.CASCADING:
          await dispatch(markAlarmAsAcknowledged(alarm.id))
          break
        case Constants.AlarmTypes.SIMULTANEOUS:
          await dispatch(
            markCreatorResponseForSimultaneousAlarm(
              alarm.id,
              Constants.GROUP_ALARM_YES,
              true
            )
          )
          break
        case Constants.AlarmTypes.RECIPIENT:
          await dispatch(skipRecipientCreatorAlarm(alarm.id))
          break
        default:
          break
      }
      const updatedAlarm = alarmSelector(getState(), {
        alarmId: alarm.id
      })
      if (!isEmpty(updatedAlarm)) {
        dispatch(scheduleNotificationForOwnAlarm(updatedAlarm))
      }
    } else if (
      alarm.alarmCategory === Constants.AlarmCategories.PARTICIPANT_ALARM
    ) {
      switch (alarm.type) {
        case Constants.AlarmTypes.CASCADING:
          await dispatch(skipPersonalParticipantAlarm(alarm.id))
          break
        case Constants.AlarmTypes.SIMULTANEOUS:
          await dispatch(
            markParticipantResponseForSimultaneousAlarm(
              alarm.id,
              Constants.GROUP_ALARM_YES,
              true
            )
          )
          break
        case Constants.AlarmTypes.RECIPIENT:
          await dispatch(markRecipientAlarmAsDone(alarm.id))
          break
        default:
          break
      }
      const updatedAlarm = alarmSelector(getState(), {
        alarmId: alarm.id
      })
      if (!isEmpty(updatedAlarm)) {
        AlarmUtils.scheduleNotificationForParticipantAlarm(updatedAlarm)
      }
    }
  }
}

export default {
  loadAppData,
  unloadAppData,
  deleteAlarm,
  markAlarmAsAcknowledged,
  markPersonalAlarmAsUnskipped,
  addAlarm,
  setConnectionStatus,
  addSystemAlerts,
  addSystemAlert,
  removeSystemAlert,
  handlePendingActions,
  editAlarm,
  setUserName,
  setUserMobileNumber,
  updateUserName,
  uploadUserAvatar,
  deleteUserAvatar,
  markBackupAlarmAsDelivered,
  markBackupAlarmAsSeen,
  uploadGroupAvatar,
  deleteGroupAvatar,
  updateGroupAvatarImages,
  markCreatorResponseForSimultaneousAlarm,
  markParticipantResponseForSimultaneousAlarm,
  setAuthenticatedWithFirebase,
  setProgress,
  resetProgress,
  updateTimezoneAndHandleTimezoneChangeIfNeeded,
  updateRingParticipantAlarmByDefaultUserSetting,
  setContactAvatarImages,
  setUserAvatarImages,
  setNotificationsEnabled,
  setCriticalAlertsEnabled,
  setBackgroundAppRefreshEnabled,
  markAlarmsAsExpired,
  markParticipantAlarmsAsExpired,
  setCurrentScreen,
  updateTimeFormatUserSetting,
  setDeviceToken,
  updateAlarmStatus,
  restoreAlarm,
  setBackupResponseStatusForAlarm,
  blockContact,
  unblockContact,
  addMessageToAlarmConversation,
  loadLatestConversationMessagesForAlarm,
  loadEarlierConversationMessagesForAlarm,
  updatePendingConversationMessageForAlarm,
  editTimeAndEnableAlarm,
  editTimeAndRestoreAlarm,
  snoozeParticipantAlarm,
  stopSnoozeForParticipantAlarm,
  showWelcomeAlarmsIfNeeded,
  createWelcomeAlarms,
  markWelcomeAlarmsAsShown,
  deleteAllAlarms,
  updatePendingFeedback,
  updatePendingProblem,
  setUserEmail,
  loadLastConversationMessageForAlarm,
  snoozeCreatorAlarm,
  resetUnseenMessagesForAlarm,
  updateUserCurrentlyTyping,
  resetUserCurrentlyTyping,
  loadCurrentlyTypingUsers,
  unloadCurrentlyTypingUsers,
  updateAppEnvInfo,
  stopSnoozeForCreatorAlarm,
  setRecipientResponseStatusForAlarm,
  markRecipientAlarmAsDone,
  markPersonalAlarmAsUndone,
  markRecipientAlarmAsUndone,
  resetApp,
  deleteAccount,
  removeLocalAlarm,
  removeLocalAlarms,
  updateSnoozingAlarms,
  updateAcknowledgedAlarms,
  syncAlarmsStatusLocally,
  setContactsPermissionStatus,
  continueWithoutRegistration,
  addMisingConnection,
  updateLastActiveTime,
  setLatestRelease,
  markBackupAlarmIdAsSeen,
  syncAlarmsStatus,
  setPastAlarmOccurrenceResponse,
  setAdditionalSetupInstructions,
  removeSystemMessage,
  addHiddenSystemMessage,
  updateParticipantAlarmRingerSettings,
  updateGlobalAlarmRingerSettings,
  updateAlarmRingerSettings,
  loadAlarmAcknowledgements,
  deleteInvitedContact,
  setConnectedToIap,
  setPurchases,
  addPurchase,
  incrementMaxAllowedAlarms,
  setAlarmNotificationChannelPopupEnabled,
  setAlarmLockScreenNotificationEnabled,
  addBackupAlarm,
  updateSnoozeStatusForCreatorAlarm,
  updateSnoozeStatusForParticipantAlarm,
  scheduleExistingAlarms,
  createSupportTicket,
  makeGroupMembersActiveInAlarms,
  setDeviceManufacturer,
  loadUserSettings,
  addPhoneContacts,
  addSkuDetails,
  updateSubscriberAlarm,
  deleteSubscriberAlarm,
  removeSubscribedAlarmSystemAlerts,
  incrementShareableAlarmLinkCount,
  incrementAlarmsSavedToCalendarCount,
  incrementInstantAlarmsCount,
  incrementStopwatchesCount,
  incrementTimersCount,
  disablePremiumFeatures,
  setColorScheme,
  setWebColorScheme,
  setPrimaryColorId,
  updateWebColorScheme,
  updateColorScheme,
  updatePrimaryColorId,
  softUpdateLocalAlarm,
  softUpdateLocalParticipantAlarm,
  addAlarmAcknowledgementAction,
  skipPersonalAlarm,
  skipPersonalParticipantAlarm,
  skipRecipientAlarm,
  skipRecipientCreatorAlarm,
  updateAlarm,
  toggleCategorizedAlarmView,
  createAlarmCategory,
  addAlarmToAlarmCategory,
  removeAlarmFromAlarmCategory,
  deleteAlarmCategory,
  updateAlarmCategory,
  setAlarmsSavedToCalendarCount,
  setInstantAlarmsCount,
  setStopwatchesCount,
  setTimersCount,
  setShowAppRunningElsewhereAlert,
  setTabActiveIndex,
  showNewAlarmWizard,
  showNewInstantAlarmWizard,
  showNewGroupWizard,
  showEditGroupWizard,
  hideNewAlarmWizard,
  hideNewGroupWizard,
  hideEditGroupWizard,
  hideNewInstantAlarmWizard,
  showSelectAlarmTypeScreen,
  showAlarmDetailsScreen,
  showCalendarEventDetailsScreen,
  showInstantAlarmDetailsScreen,
  hideAlarmDetailsScreen,
  hideCalendarEventDetailsScreen,
  hideInstantAlarmDetailsScreen,
  showGroupDetailsScreen,
  hideGroupDetailsScreen,
  showContactDetailsScreen,
  showChangeMemberStateScreen,
  hideContactDetailsScreen,
  hideChangeGroupMemberStateScreen,
  closeChangeGroupMemberStateScreen,
  showReportAProblemScreen,
  hideReportAProblemScreen,
  showEditAlarmWizard,
  showAlarmConversationScreen,
  hideAlarmConversationScreen,
  hideEditAlarmWizard,
  showProfileAndSettingsScreen,
  hideProfileAndSettingsScreen,
  showParticipantAlarmDetailsScreen,
  showInstantParticipantAlarmDetailsScreen,
  hideParticipantAlarmDetailsScreen,
  hideInstantParticipantAlarmDetailsScreen,
  showIncidentAlarmDetailsScreen,
  hideIncidentAlarmDetailsScreen,
  setCurrentlySelectedAlarmCategoryId,
  syncLocalOnlyOwnAlarms,
  closeNewAlarmWizard,
  closeEditAlarmWizard,
  closeNewGroupWizard,
  closeEditGroupWizard,
  unhideAlarmCategory,
  hideAlarmCategory,
  deleteAlarmsInCategory,
  showAlarmHistoryScreen,
  hideAlarmHistoryScreen,
  markRecipientCreatorAlarmAsUnskipped,
  markRecipientAlarmAsUnskipped,
  markPersonalParticipantAlarmAsUnskipped,
  updateRecipientAlarmDateAndTime,
  hideSelectAlarmTypeScreen,
  setShowQuickReminder,
  resetInspectorPanel,
  closeInstantAlarmWizard,
  setIosNumNotificationsScheduled,
  setShowSidebar,
  updateRingOnEarphoneOnlyUserSetting,
  updateGestureToDismissAnAlarmUserSetting,
  updatePreReminderRingtoneUserSetting,
  updateTimerRingtoneUserSetting,
  updateMuteAlarmsUserSetting,
  deleteAlarmHistory,
  updateSpecifyTimezoneForAlarmUserSetting,
  showDuplicateAlarmWizard,
  hideDuplicateAlarmWizard,
  closeDuplicateAlarmWizard,
  updateGraduallyIncreaseVolumeUserSetting,
  updateShakeToStopAlarmUserSetting,
  updateShakeSensitivityUserSetting,
  updatePinModeUserSetting,
  setSeenSpecifyTimezoneAlert,
  setMobileAndWebTimezoneMismatchDetected,
  updateParticipantPreReminderDuration,
  updateAlarmPreReminderDuration,
  setBatteryOptimizationDisabled,
  setDndAccessGranted,
  setExistingAlarmsLoaded,
  updateNotificationSettingsUserSettings,
  handleExistingAlarmsLoaded,
  removeBackupAlarm,
  setScheduleExactAlarmsEnabled,
  addChecklist,
  updateChecklist,
  removeChecklist,
  toggleTaskInChecklist,
  removeTaskFromChecklist,
  updateTaskNameInChecklist,
  uploadImage,
  deleteImage,
  setAppUpdateAvailable,
  setMuteAlarms,
  setCurrentlySelectedTaskListId,
  setShowAlertIncidents,
  setShowExpiredAlarms,
  setShowCalendarEvents,
  setShowInstantAlarms,
  setShowTasks,
  setShowRecentlyDeletedAlarms,
  updateFirstDayOfWeekUserSetting,
  setFirstDayOfWeek,
  setWebFirstDayOfWeek,
  updateDefaultTimezoneForAlarmUserSetting,
  updateTimezoneForAllAlarms,
  updateRingerSettingsForAllAlarms,
  scheduleNextFiveAlarms,
  updateNotificationActionBehaviorUserSetting,
  updatePromptForUpdateUserSetting,
  updateWebFirstDayOfWeekUserSetting,
  willChangesBeDiscarded,
  scheduleNotificationForOwnAlarm,
  updateSortAlarmCategoriesByUserSetting,
  updateMissedAlarmPlacementSettingUserSetting,
  updateFabButtonBehaviorUserSetting,
  updateCalendarEvent,
  updateConnectedAccount,
  markIncidentAlarmResponse,
  addIncidentAlarm,
  markIncidentAlarmAsDelivered,
  removeIncidentAlarm,
  cancelNotificationsForAlarm,
  updateEnhancedNotificationsUserSetting,
  updateAppTerminatedNotificationUserSetting,
  updateRecentContacts,
  updateRecentGroups,
  markAlarmsAsComplete,
  setStripeSubscriptions,
  updatePendingActionRetryCount,
  updateSoftPendingActionRetryCount
}
